/* eslint-disable */


//DynamicCRF.vue-getMenuItemsForEventID BEGIN
export function getMenuItemsForEventID(eventID) {
  if(eventID == 70){
    //########################################
    //3-month Questionnaire
    //########################################
    
    let formDict = {
      tbFrmChgOfContDtl: {
        id: "tbFrmChgOfContDtl", to: "/change-of-contact",
        caption: "Change of Contact Details",
        iconPath: "mdi-file-document-edit-outline", formCompleteness: "", showMenuItem: false,},
      tbFrmRecentMedicalProblems: {
        id: "tbFrmRecentMedicalProblems", to: "/medical-problems",
        caption: "Recent medical problems",
        iconPath: "mdi-file-document-edit-outline", formCompleteness: "", showMenuItem: false,},
      tbFrmQOL: {
        id: "tbFrmQOL", to: "/qol",
        caption: "Your Quality of Life",
        iconPath: "mdi-file-document-edit-outline", formCompleteness: "", showMenuItem: false,},
      tbFrmPROMISNeuro: {
        id: "tbFrmPROMISNeuro", to: "/promis",
        caption: "How well you understand things",
        iconPath: "mdi-file-document-edit-outline", formCompleteness: "", showMenuItem: false,},
      tbFrmQoLEQ5D5L_EQ5D: {
        id: "tbFrmQoLEQ5D5L_EQ5D", to: "/general-health-eq5d",
        caption: "Your Health and Quality of Life",
        iconPath: "mdi-file-document-edit-outline", formCompleteness: "", showMenuItem: false,},
      tbFrmIPAQSF: {
        id: "tbFrmIPAQSF", to: "/ipaqsf",
        caption: "Your Activity Levels",
        iconPath: "mdi-file-document-edit-outline", formCompleteness: "", showMenuItem: false,},
      tbFrmYourOverallHealth: {
        id: "tbFrmYourOverallHealth", to: "/overall-health",
        caption: "Your Overall Health",
        iconPath: "mdi-file-document-edit-outline", formCompleteness: "", showMenuItem: false,},
      tbFrmHealthSocialCareResourceUse: {
        id: "tbFrmHealthSocialCareResourceUse", to: "/resource-use",
        caption: "Health and Social Care Resource Use",
        iconPath: "mdi-file-document-edit-outline", formCompleteness: "", showMenuItem: false,}
    };
    
    return {
      getFilteredMenu: function(enrolStatuses){
        return this.menuItems.filter(item => this.formIsApplicable(item.id,enrolStatuses)); 
      },
      menuItems: [
        "tbFrmChgOfContDtl",
        "tbFrmRecentMedicalProblems",
        "tbFrmQOL",
        "tbFrmPROMISNeuro",
        "tbFrmQoLEQ5D5L_EQ5D",
        "tbFrmIPAQSF",
        "tbFrmYourOverallHealth",
        "tbFrmHealthSocialCareResourceUse"
      ].map(dataTableID=>formDict[dataTableID]),
      formIsApplicable: function(dataTableID,enrolStatuses){
        switch(dataTableID){
          case 'tbFrmChgOfContDtl':
            return enrolStatuses.some(s => [107].includes(s));
          case 'tbFrmRecentMedicalProblems':
            return enrolStatuses.some(s => [107].includes(s));
          case 'tbFrmQOL':
            return enrolStatuses.some(s => [107].includes(s));
          case 'tbFrmPROMISNeuro':
            return enrolStatuses.some(s => [107].includes(s));
          case 'tbFrmQoLEQ5D5L_EQ5D':
            return enrolStatuses.some(s => [107].includes(s));
          case 'tbFrmIPAQSF':
            return enrolStatuses.some(s => [107].includes(s));
          case 'tbFrmYourOverallHealth':
            return enrolStatuses.some(s => [107].includes(s));
          case 'tbFrmHealthSocialCareResourceUse':
            return enrolStatuses.some(s => [107].includes(s));
          default:
            return false;
        }
      }
    };
  } else 
  if(eventID == 80){
    //########################################
    //6-month Questionnaire
    //########################################
    
    let formDict = {
      tbFrmChgOfContDtl: {
        id: "tbFrmChgOfContDtl", to: "/change-of-contact",
        caption: "Change of Contact Details",
        iconPath: "mdi-file-document-edit-outline", formCompleteness: "", showMenuItem: false,},
      tbFrmRecentMedicalProblems: {
        id: "tbFrmRecentMedicalProblems", to: "/medical-problems",
        caption: "Recent medical problems",
        iconPath: "mdi-file-document-edit-outline", formCompleteness: "", showMenuItem: false,},
      tbFrmQOL: {
        id: "tbFrmQOL", to: "/qol",
        caption: "Your Quality of Life",
        iconPath: "mdi-file-document-edit-outline", formCompleteness: "", showMenuItem: false,},
      tbFrmPROMISNeuro: {
        id: "tbFrmPROMISNeuro", to: "/promis",
        caption: "How well you understand things",
        iconPath: "mdi-file-document-edit-outline", formCompleteness: "", showMenuItem: false,},
      tbFrmQoLEQ5D5L_EQ5D: {
        id: "tbFrmQoLEQ5D5L_EQ5D", to: "/general-health-eq5d",
        caption: "Your Health and Quality of Life",
        iconPath: "mdi-file-document-edit-outline", formCompleteness: "", showMenuItem: false,},
      tbFrmIPAQSF: {
        id: "tbFrmIPAQSF", to: "/ipaqsf",
        caption: "Your Activity Levels",
        iconPath: "mdi-file-document-edit-outline", formCompleteness: "", showMenuItem: false,},
      tbFrmYourOverallHealth: {
        id: "tbFrmYourOverallHealth", to: "/overall-health",
        caption: "Your Overall Health",
        iconPath: "mdi-file-document-edit-outline", formCompleteness: "", showMenuItem: false,},
      tbFrmHealthSocialCareResourceUse: {
        id: "tbFrmHealthSocialCareResourceUse", to: "/resource-use",
        caption: "Health and Social Care Resource Use",
        iconPath: "mdi-file-document-edit-outline", formCompleteness: "", showMenuItem: false,}
    };
    
    return {
      getFilteredMenu: function(enrolStatuses){
        return this.menuItems.filter(item => this.formIsApplicable(item.id,enrolStatuses)); 
      },
      menuItems: [
        "tbFrmChgOfContDtl",
        "tbFrmRecentMedicalProblems",
        "tbFrmQOL",
        "tbFrmPROMISNeuro",
        "tbFrmQoLEQ5D5L_EQ5D",
        "tbFrmIPAQSF",
        "tbFrmYourOverallHealth",
        "tbFrmHealthSocialCareResourceUse"
      ].map(dataTableID=>formDict[dataTableID]),
      formIsApplicable: function(dataTableID,enrolStatuses){
        switch(dataTableID){
          case 'tbFrmChgOfContDtl':
            return enrolStatuses.some(s => [107].includes(s));
          case 'tbFrmRecentMedicalProblems':
            return enrolStatuses.some(s => [107].includes(s));
          case 'tbFrmQOL':
            return enrolStatuses.some(s => [107].includes(s));
          case 'tbFrmPROMISNeuro':
            return enrolStatuses.some(s => [107].includes(s));
          case 'tbFrmQoLEQ5D5L_EQ5D':
            return enrolStatuses.some(s => [107].includes(s));
          case 'tbFrmIPAQSF':
            return enrolStatuses.some(s => [107].includes(s));
          case 'tbFrmYourOverallHealth':
            return enrolStatuses.some(s => [107].includes(s));
          case 'tbFrmHealthSocialCareResourceUse':
            return enrolStatuses.some(s => [107].includes(s));
          default:
            return false;
        }
      }
    };
  } else 
  if(eventID == 90){
    //########################################
    //12-month Questionnaire
    //########################################
    
    let formDict = {
      tbFrmChgOfContDtl: {
        id: "tbFrmChgOfContDtl", to: "/change-of-contact",
        caption: "Change of Contact Details",
        iconPath: "mdi-file-document-edit-outline", formCompleteness: "", showMenuItem: false,},
      tbFrmQOL: {
        id: "tbFrmQOL", to: "/qol",
        caption: "Your Quality of Life",
        iconPath: "mdi-file-document-edit-outline", formCompleteness: "", showMenuItem: false,},
      tbFrmPROMISNeuro: {
        id: "tbFrmPROMISNeuro", to: "/promis",
        caption: "How well you understand things",
        iconPath: "mdi-file-document-edit-outline", formCompleteness: "", showMenuItem: false,},
      tbFrmQoLEQ5D5L_EQ5D: {
        id: "tbFrmQoLEQ5D5L_EQ5D", to: "/general-health-eq5d",
        caption: "Your Health and Quality of Life",
        iconPath: "mdi-file-document-edit-outline", formCompleteness: "", showMenuItem: false,},
      tbFrmIPAQSF: {
        id: "tbFrmIPAQSF", to: "/ipaqsf",
        caption: "Your Activity Levels",
        iconPath: "mdi-file-document-edit-outline", formCompleteness: "", showMenuItem: false,},
      tbFrmYourOverallHealth: {
        id: "tbFrmYourOverallHealth", to: "/overall-health",
        caption: "Your Overall Health",
        iconPath: "mdi-file-document-edit-outline", formCompleteness: "", showMenuItem: false,},
      tbFrmHealthSocialCareResourceUse: {
        id: "tbFrmHealthSocialCareResourceUse", to: "/resource-use",
        caption: "Health and Social Care Resource Use",
        iconPath: "mdi-file-document-edit-outline", formCompleteness: "", showMenuItem: false,},
      tbFrmStudyResults: {
        id: "tbFrmStudyResults", to: "/study-results",
        caption: "Study Results",
        iconPath: "mdi-file-document-edit-outline", formCompleteness: "", showMenuItem: false,}
    };
    
    return {
      getFilteredMenu: function(enrolStatuses){
        return this.menuItems.filter(item => this.formIsApplicable(item.id,enrolStatuses)); 
      },
      menuItems: [
        "tbFrmChgOfContDtl",
        "tbFrmQOL",
        "tbFrmPROMISNeuro",
        "tbFrmQoLEQ5D5L_EQ5D",
        "tbFrmIPAQSF",
        "tbFrmYourOverallHealth",
        "tbFrmHealthSocialCareResourceUse",
        "tbFrmStudyResults"
      ].map(dataTableID=>formDict[dataTableID]),
      formIsApplicable: function(dataTableID,enrolStatuses){
        switch(dataTableID){
          case 'tbFrmChgOfContDtl':
            return enrolStatuses.some(s => [107].includes(s));
          case 'tbFrmQOL':
            return enrolStatuses.some(s => [107].includes(s));
          case 'tbFrmPROMISNeuro':
            return enrolStatuses.some(s => [107].includes(s));
          case 'tbFrmQoLEQ5D5L_EQ5D':
            return enrolStatuses.some(s => [107].includes(s));
          case 'tbFrmIPAQSF':
            return enrolStatuses.some(s => [107].includes(s));
          case 'tbFrmYourOverallHealth':
            return enrolStatuses.some(s => [107].includes(s));
          case 'tbFrmHealthSocialCareResourceUse':
            return enrolStatuses.some(s => [107].includes(s));
          case 'tbFrmStudyResults':
            return enrolStatuses.some(s => [107].includes(s));
          default:
            return false;
        }
      }
    };
  } else 
  if(eventID == 100){
    //########################################
    //Interview Consent Form
    //########################################
    
    let formDict = {
      tbFrmInterviewConsentForm: {
        id: "tbFrmInterviewConsentForm", to: "/interview-consent-form",
        caption: "Interview Consent Form",
        iconPath: "mdi-file-document-edit-outline", formCompleteness: "", showMenuItem: false,}
    };
    
    return {
      getFilteredMenu: function(enrolStatuses){
        return this.menuItems.filter(item => this.formIsApplicable(item.id,enrolStatuses)); 
      },
      menuItems: [
        "tbFrmInterviewConsentForm"
      ].map(dataTableID=>formDict[dataTableID]),
      formIsApplicable: function(dataTableID,enrolStatuses){
        switch(dataTableID){
          case 'tbFrmInterviewConsentForm':
            return enrolStatuses.some(s => [107].includes(s));
          default:
            return false;
        }
      }
    };
  } else {
    return null;
  }
}//DynamicCRF.vue-getMenuItemsForEventID END



//DynamicCRF.vue-eq5d-info BEGIN
export let eq5dInfoMap = {
  tbFrmQoLEQ5D5L_EQ5D: {
    crfTitle: 'Your Health and Quality of Life',
    heading: `Please select the ONE option that best describes your health TODAY.`,
    realTableID: 'tbFrmQoLEQ5D5L',
    timePointDataItemID: 'eqd_DummyTimePoint',
    allQuestionsRequired: true,
    mainQuestions: [
      {
        caption: `Mobility`,
        dataItemID: 'eqd_Mobility',
        options: [
          {value: 1,text: `I have no problems in walking about`},
          {value: 2,text: `I have slight problems in walking about`},
          {value: 3,text: `I have moderate problems in walking about`},
          {value: 4,text: `I have severe problems in walking about`},
          {value: 5,text: `I am unable to walk about`},
        ]
      },
      {
        caption: `Self-care`,
        dataItemID: 'eqd_SelfCare',
        options: [
          {value: 1,text: `I have no problems washing or dressing myself`},
          {value: 2,text: `I have slight problems washing or dressing myself`},
          {value: 3,text: `I have moderate problems washing or dressing myself`},
          {value: 4,text: `I have severe problems washing or dressing myself`},
          {value: 5,text: `I am unable to wash or dress myself`},
        ]
      },
      {
        caption: `Usual Activities (e.g. work, study, housework, family or leisure activities)`,
        dataItemID: 'eqd_UsualActivities',
        options: [
          {value: 1,text: `I have no problem doing my usual activities`},
          {value: 2,text: `I have slight problems doing my usual activities`},
          {value: 3,text: `I have moderate problems doing my usual activities`},
          {value: 4,text: `I have severe problems doing my usual activities`},
          {value: 5,text: `I am unable to do my usual activities`},
        ]
      },
      {
        caption: `Pain / discomfort`,
        dataItemID: 'eqd_PainDiscomfort',
        options: [
          {value: 1,text: `I have no pain or discomfort`},
          {value: 2,text: `I have slight pain or discomfort`},
          {value: 3,text: `I have moderate pain or discomfort`},
          {value: 4,text: `I have severe pain or discomfort`},
          {value: 5,text: `I have extreme pain or discomfort`},
        ]
      },
      {
        caption: `Anxiety / Depression`,
        dataItemID: 'eqd_AnxietyDepression',
        options: [
          {value: 1,text: `I am not anxious or depressed`},
          {value: 2,text: `I am slightly anxious or depressed`},
          {value: 3,text: `I am moderately anxious or depressed`},
          {value: 4,text: `I am severely anxious or depressed`},
          {value: 5,text: `I am extremely anxious or depressed`},
        ]
      },
    ],
    scaleQuestion: {
      caption: `<p><b>We would like to know how good or bad your health is TODAY.</b></p> <p><b>Please can you let us know, using a number from 0-100 where 100 is the best health you can imagine and 0 is the worst health you can imagine?</b></p>`,
      dataItemID: 'eqd_YourHealthToday',
      scaleCaptionLeft: `YOUR HEALTH TODAY`,
      scaleCaptionTop: `Please indicate on the scale how your health is TODAY.`
    },
  }
};
//DynamicCRF.vue-eq5d-info END


//DynamicCRF.vue-getEndOfFormDialogHtml BEGIN
export function getEndOfFormDialogHtml() {
  
  let isEndOfEvent = this.crfId == this.getMenuItems.at(-1).id;
  
  if(isEndOfEvent){
    switch(this.getFormAuthenticated){
    }
  }
  
}
//DynamicCRF.vue-getEndOfFormDialogHtml END

//DynamicCRF.vue-settings BEGIN
export let trialResourceAccount = 'RESTORE@warwick.ac.uk';
export let numQuestionsPerPage = {
  inDesktopMode: 3,
  inMobileMode: 1
};
export let hideDisabledQuestions = true;
//DynamicCRF.vue-settings END

//DynamicCRF.vue-updateTimePointText BEGIN
export function updateTimepointText() {
  let self = this;
  function do_replacements(oldText,newText){
    self.crfs[self.crfId].dataItems.forEach((item) => {
      switch(item.itemType){
        case "section-instruction":
          item.sectionTitle = item.sectionTitle.replaceAll(oldText,newText);
          break;
        case "data-item":
          item.controlCaption = item.controlCaption.replaceAll(oldText,newText);
          if(item.lookUpTable)
            item.lookUpTable.forEach(item => item.text = item.text.replaceAll(oldText,newText));
          break;
      }
    });
  }
  do_replacements("[[front-blurb]]",{
      "70": " <p><b>Hello and welcome!</b></p> <p>This is your <b>ReSTORe</b> study 3-month <b>questionnaire</b>. It should take you about <b>20-30 minutes</b> to <b>complete</b>. You can ask a <b>family member/friend</b> to <b>help</b> you.</p> <p>Your answers are really <b>important</b> to us. We <b>appreciate</b> your <b>time</b>.</p> <p>This weblink will be live for <b>4 weeks</b>. Please <b>complete</b> your <b>questionnaire</b> by <b>then</b>.</p> <p>If you get <b>tired</b>, you can leave the questionnaire and <b>come back later</b>. Your <b>answers</b> will be <b>saved</b>.</p> <p>To <b>restart</b> where you left off, just <b>click</b> on the same questionnaire <b>link</b> you were sent by <b>email/text</b>.</p> <p>You will get <b>confirmation</b> when you have <b>finished</b> your questionnaire.</p> <p>Please <b>call</b> us if you have any <b>questions</b> 02476 575 767. <b>We are here to help you.</b></p> <p><b>Thank you</b></p> <p>The <b>ReSTORe team.</b></p> ",
      "80": " <p><b>Hello and welcome!</b></p> <p>This is your <b>ReSTORe</b> study 6-month <b>questionnaire</b>. It should take you about <b>20-30 minutes</b> to <b>complete</b>. You can ask a <b>family member/friend</b> to <b>help</b> you.</p> <p>Your answers are really <b>important</b> to us. We <b>appreciate</b> your <b>time</b>.</p> <p>This weblink will be live for <b>4 weeks</b>. Please <b>complete</b> your <b>questionnaire</b> by <b>then</b>.</p> <p>If you get <b>tired</b>, you can leave the questionnaire and <b>come back later</b>. Your <b>answers</b> will be <b>saved</b>.</p> <p>To <b>restart</b> where you left off, just <b>click</b> on the same questionnaire <b>link</b> you were sent by <b>email/text</b>.</p> <p>You will get <b>confirmation</b> when you have <b>finished</b> your questionnaire.</p> <p>Please <b>call</b> us if you have any <b>questions</b> 02476 575 767. <b>We are here to help you.</b></p> <p><b>Thank you</b></p> <p>The <b>ReSTORe team.</b></p> ",
      "90": " <p><b>Hello and welcome!</b></p> <p>This is your <b>ReSTORe</b> study 12-month <b>questionnaire</b>. It should take you about <b>20-30 minutes</b> to <b>complete</b>. You can ask a <b>family member/friend</b> to <b>help</b> you.</p> <p>Your answers are really <b>important</b> to us. We <b>appreciate</b> your <b>time</b>.</p> <p>This weblink will be live for <b>4 weeks</b>. Please <b>complete</b> your <b>questionnaire</b> by <b>then</b>.</p> <p>If you get <b>tired</b>, you can leave the questionnaire and <b>come back later</b>. Your <b>answers</b> will be <b>saved</b>.</p> <p>To <b>restart</b> where you left off, just <b>click</b> on the same questionnaire <b>link</b> you were sent by <b>email/text</b>.</p> <p>You will get <b>confirmation</b> when you have <b>finished</b> your questionnaire.</p> <p>Please <b>call</b> us if you have any <b>questions</b> 02476 575 767. <b>We are here to help you.</b></p> <p><b>Thank you</b></p> <p>The <b>ReSTORe team.</b></p> ",
    }[this.getFormAuthenticated]
  );
  do_replacements("[[your-overall-health-dropdown]]",{
      "70": "three months",
      "80": "three months",
      "90": "six months",
    }[this.getFormAuthenticated]
  );
  do_replacements("{{3or6Months}}",{
      "70": "3 months",
      "80": "3 months",
      "90": "6 months",
    }[this.getFormAuthenticated]
  );
}
//DynamicCRF.vue-updateTimePointText END

//DynamicCRF.vue-DataItemInfo BEGIN
export function create_crfs() {
  return {
    tbFrmInterviewConsentForm:{
      crfTitle: "Interview Consent Form",
      tableName: "tbFrmInterviewConsentForm",
      timePointDataItem: "ics_DummyTimePoint",
      dataItems:[
        {
          id:"1",
          itemType:"section-instruction",
          sectionTitle:``,
          position: 0,
          visible: true,
        }, {
          id:"2",
          itemType:"section-instruction",
          sectionTitle:`Interview Consent Form Details`,
          position: 0,
          visible: true,
        }, {
          fgId:"2", position: 0, visible: true,
          controlCaption:`I confirm that I have read the ReSTORe Participant Information Sheet (V1.0 12Dec2024). The information sheet can be found on our website here: https://warwick.ac.uk/restorestudy. I have had the opportunity to consider the information and ask questions which have been answered satisfactorily.`,
          itemType:"data-item", dataItemId:"ics_ReadInformationSheet", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:true,
          lookUpTable:[
            {value:1, text:"No"},
            {value:2, text:"Yes"},
          ],
          lookupIsRequired:true,
          validationRules:[this.requiredRule,],
          controlEnabled:true,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"2", position: 0, visible: true,
          controlCaption:`I understand that my participation is voluntary and that I am free to withdraw at any time without giving a reason, and without my medical care or legal rights being affected.`,
          itemType:"data-item", dataItemId:"ics_ParticipationIsVoluntary", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:true,
          lookUpTable:[
            {value:1, text:"No"},
            {value:2, text:"Yes"},
          ],
          lookupIsRequired:true,
          validationRules:[this.requiredRule,],
          controlEnabled:true,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"2", position: 0, visible: true,
          controlCaption:`I understand that if I withdraw during the interview, data collected before my withdrawal will be kept with my permission, but no further data will be collected from me. After the interview, I understand that I have until data analysis begins to withdraw my data.`,
          itemType:"data-item", dataItemId:"ics_WithdrawDuringInterview", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:true,
          lookUpTable:[
            {value:1, text:"No"},
            {value:2, text:"Yes"},
          ],
          lookupIsRequired:true,
          validationRules:[this.requiredRule,],
          controlEnabled:true,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"2", position: 0, visible: true,
          controlCaption:`I agree to my interview being audio and/or video recorded.`,
          itemType:"data-item", dataItemId:"ics_InterviewAudioVideoRecorded", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:true,
          lookUpTable:[
            {value:1, text:"No"},
            {value:2, text:"Yes"},
          ],
          lookupIsRequired:true,
          validationRules:[this.requiredRule,],
          controlEnabled:true,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"2", position: 0, visible: true,
          controlCaption:`I understand that the interview may be typed up by a third-party service contracted to work on the study. The typed record (transcripts) will be anonymised, held securely, and only accessed by authorised study personnel. It will not be possible for me to be identified from this anonymised data.`,
          itemType:"data-item", dataItemId:"ics_TypedUpByThirdPartyService", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:true,
          lookUpTable:[
            {value:1, text:"No"},
            {value:2, text:"Yes"},
          ],
          lookupIsRequired:true,
          validationRules:[this.requiredRule,],
          controlEnabled:true,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"2", position: 0, visible: true,
          controlCaption:`I understand that if I record or say anything that may lead the researcher interviewing me to have concerns for my safety (or the safety of others) that they will have a duty of care to report this information to the relevant regulatory person/organisation.`,
          itemType:"data-item", dataItemId:"ics_ConcernsForSafety", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:true,
          lookUpTable:[
            {value:1, text:"No"},
            {value:2, text:"Yes"},
          ],
          lookupIsRequired:true,
          validationRules:[this.requiredRule,],
          controlEnabled:true,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"2", position: 0, visible: true,
          controlCaption:`I understand that brief, anonymous quotes or extracts from the interviews may be reproduced in academic and non-academic presentations and publications.`,
          itemType:"data-item", dataItemId:"ics_ReproducedPresentationsPublications", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:true,
          lookUpTable:[
            {value:1, text:"No"},
            {value:2, text:"Yes"},
          ],
          lookupIsRequired:true,
          validationRules:[this.requiredRule,],
          controlEnabled:true,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"2", position: 0, visible: true,
          controlCaption:`I understand that in future, the anonymous transcripts may be used for another study. If shared with other carefully selected researchers, this will be approved by a Research Ethics Committee.`,
          itemType:"data-item", dataItemId:"ics_TranscriptsForAnotherStudy", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:true,
          lookUpTable:[
            {value:1, text:"No"},
            {value:2, text:"Yes"},
          ],
          lookupIsRequired:true,
          validationRules:[this.requiredRule,],
          controlEnabled:true,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"2", position: 0, visible: true,
          controlCaption:`I agree to take part in an interview for the ReSTORe trial.`,
          itemType:"data-item", dataItemId:"ics_TakePartInInterview", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:true,
          lookUpTable:[
            {value:1, text:"No"},
            {value:2, text:"Yes"},
          ],
          lookupIsRequired:true,
          validationRules:[this.requiredRule,],
          controlEnabled:true,
          customError:false,
          customErrorMessage:'',
        },
      ]
    }, tbFrmYourOverallHealth:{
      crfTitle: "3-month Questionnaire - Section 5: Your Overall Health",
      tableName: "tbFrmYourOverallHealth",
      timePointDataItem: "yoh_DummyTimePoint",
      dataItems:[
        {
          id:"1",
          itemType:"section-instruction",
          sectionTitle:``,
          position: 0,
          visible: true,
        }, {
          id:"2",
          itemType:"section-instruction",
          sectionTitle:`Your Overall Health`,
          position: 0,
          visible: true,
        }, {
          fgId:"2", position: 0, visible: true,
          controlCaption:`Compared to <b>{{3or6Months}} ago</b>, how would you <b>rate</b> your <b>general health</b> now?`,
          itemType:"data-item", dataItemId:"yoh_GeneralHealthRate", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:true,
          lookUpTable:[
            {value:1, text:"Much better now than [[your-overall-health-dropdown]] ago"},
            {value:2, text:"Somewhat better now than [[your-overall-health-dropdown]] ago"},
            {value:3, text:"About the same"},
            {value:4, text:"Somewhat worse now than [[your-overall-health-dropdown]] ago"},
            {value:5, text:"Much worse now than [[your-overall-health-dropdown]] ago"},
          ],
          lookupIsRequired:false,
          validationRules:[],
          controlEnabled:true,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"2", position: 0, visible: true,
          controlCaption:`Have you <b>attended a stroke clinic</b> in the last <b>{{3or6Months}}</b>?`,
          itemType:"data-item", dataItemId:"yoh_AttendedStrokeClinic", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:true,
          lookUpTable:[
            {value:1, text:"No"},
            {value:2, text:"Yes"},
          ],
          lookupIsRequired:false,
          validationRules:[],
          controlEnabled:true,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"2", position: 0, visible: true,
          controlCaption:`Have you had <b>another stroke</b> in <b>the last {{3or6Months}}</b>?`,
          itemType:"data-item", dataItemId:"yoh_HadAnotherStroke", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:true,
          lookUpTable:[
            {value:1, text:"No"},
            {value:2, text:"Yes"},
          ],
          lookupIsRequired:false,
          validationRules:[],
          controlEnabled:true,
          customError:false,
          customErrorMessage:'',
        }, {
          id:"3",
          itemType:"section-instruction",
          sectionTitle:`Simplified Modified Rankin Scale`,
          position: 0,
          visible: true,
        }, {
          fgId:"3", position: 0, visible: true,
          controlCaption:`Could you <b>live</b> alone <b>without</b> any <b>help</b> from <b>another</b> person? This means being able to bath, use the toilet, shop, prepare or get meals, and manage finances.`,
          itemType:"data-item", dataItemId:"yoh_LiveAloneWithoutHelp", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:true,
          lookUpTable:[
            {value:1, text:"No"},
            {value:2, text:"Yes"},
          ],
          lookupIsRequired:true,
          validationRules:[this.requiredRule,],
          controlEnabled:true,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"3", position: 0, visible: true,
          controlCaption:`Can you <b>do everything</b> that you were <b>doing</b> right <b>before</b> your <b>stroke</b>, even if slower and not as much?`,
          itemType:"data-item", dataItemId:"yoh_DoEverythingRightBeforeStroke", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:true,
          lookUpTable:[
            {value:1, text:"No"},
            {value:2, text:"Yes"},
          ],
          lookupIsRequired:true,
          validationRules:[this.requiredRule,],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"3", position: 0, visible: true,
          controlCaption:`Are you <b>completely back</b> to the <b>way</b> you were right <b>before</b> your <b>stroke</b>?`,
          itemType:"data-item", dataItemId:"yoh_CompletelyBackBeforeStroke", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:true,
          lookUpTable:[
            {value:1, text:"No"},
            {value:2, text:"Yes"},
          ],
          lookupIsRequired:true,
          validationRules:[this.requiredRule,],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"3", position: 0, visible: true,
          controlCaption:`Can you <b>walk</b> from one <b>room</b> to another <b>without help</b> from another person?`,
          itemType:"data-item", dataItemId:"yoh_WalkWithoutHelp", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:true,
          lookUpTable:[
            {value:1, text:"No"},
            {value:2, text:"Yes"},
          ],
          lookupIsRequired:true,
          validationRules:[this.requiredRule,],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"3", position: 0, visible: true,
          controlCaption:`Can you <b>sit up</b> in <b>bed</b> <b>without</b> any <b>help</b>?`,
          itemType:"data-item", dataItemId:"yoh_SitUpInBedWithoutHelp", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:true,
          lookUpTable:[
            {value:1, text:"No"},
            {value:2, text:"Yes"},
          ],
          lookupIsRequired:true,
          validationRules:[this.requiredRule,],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        },
      ]
    }, tbFrmQOL:{
      crfTitle: "3-month Questionnaire - Section 1: Your Quality of Life",
      tableName: "tbFrmQOL",
      timePointDataItem: "qol_DummyTimePoint",
      dataItems:[
        {
          id:"1",
          itemType:"section-instruction",
          sectionTitle:``,
          position: 0,
          visible: true,
        }, {
          id:"2",
          itemType:"section-instruction",
          sectionTitle:`Physical Function`,
          pageSplitInDesktopMode: [4],
          position: 0,
          visible: true,
        }, {
          fgId:"2", position: 0, visible: true,
          controlCaption:`Are you able to <b>do chores</b> such as vacuuming or garden work?`,
          itemType:"data-item", dataItemId:"qol_PhysFuncChores", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:true,
          lookUpTable:[
            {value:5, text:"Without any difficulty"},
            {value:4, text:"With a little difficulty"},
            {value:3, text:"With some difficulty"},
            {value:2, text:"With much difficulty"},
            {value:1, text:"Unable to do"},
          ],
          lookupIsRequired:true,
          validationRules:[this.requiredRule,],
          controlEnabled:true,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"2", position: 0, visible: true,
          controlCaption:`Are you able to go up and down <b>stairs</b> at a <b>normal pace</b>?`,
          itemType:"data-item", dataItemId:"qol_PhysFuncStairs", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:true,
          lookUpTable:[
            {value:5, text:"Without any difficulty"},
            {value:4, text:"With a little difficulty"},
            {value:3, text:"With some difficulty"},
            {value:2, text:"With much difficulty"},
            {value:1, text:"Unable to do"},
          ],
          lookupIsRequired:true,
          validationRules:[this.requiredRule,],
          controlEnabled:true,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"2", position: 0, visible: true,
          controlCaption:`Are you able to go for <b>a walk</b> of at least <b>15 minutes</b>?`,
          itemType:"data-item", dataItemId:"qol_PhysFuncWalk", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:true,
          lookUpTable:[
            {value:5, text:"Without any difficulty"},
            {value:4, text:"With a little difficulty"},
            {value:3, text:"With some difficulty"},
            {value:2, text:"With much difficulty"},
            {value:1, text:"Unable to do"},
          ],
          lookupIsRequired:true,
          validationRules:[this.requiredRule,],
          controlEnabled:true,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"2", position: 0, visible: true,
          controlCaption:`Are you able to <b>run errands</b> and shop?`,
          itemType:"data-item", dataItemId:"qol_PhysFuncErrands", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:true,
          lookUpTable:[
            {value:5, text:"Without any difficulty"},
            {value:4, text:"With a little difficulty"},
            {value:3, text:"With some difficulty"},
            {value:2, text:"With much difficulty"},
            {value:1, text:"Unable to do"},
          ],
          lookupIsRequired:true,
          validationRules:[this.requiredRule,],
          controlEnabled:true,
          customError:false,
          customErrorMessage:'',
        }, {
          id:"3",
          itemType:"section-instruction",
          sectionTitle:`<p>Anxiety</p><p>In the past 7 days...</p>`,
          pageSplitInDesktopMode: [4],
          position: 0,
          visible: true,
        }, {
          fgId:"3", position: 0, visible: true,
          controlCaption:`I felt <b>fearful</b>`,
          itemType:"data-item", dataItemId:"qol_AnxFearful", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:true,
          lookUpTable:[
            {value:1, text:"Never"},
            {value:2, text:"Rarely"},
            {value:3, text:"Sometimes"},
            {value:4, text:"Often"},
            {value:5, text:"Always"},
          ],
          lookupIsRequired:true,
          validationRules:[this.requiredRule,],
          controlEnabled:true,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"3", position: 0, visible: true,
          controlCaption:`I found it <b>hard</b> to <b>focus</b> on anything other than my <b>anxiety</b>`,
          itemType:"data-item", dataItemId:"qol_AnxFocus", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:true,
          lookUpTable:[
            {value:1, text:"Never"},
            {value:2, text:"Rarely"},
            {value:3, text:"Sometimes"},
            {value:4, text:"Often"},
            {value:5, text:"Always"},
          ],
          lookupIsRequired:true,
          validationRules:[this.requiredRule,],
          controlEnabled:true,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"3", position: 0, visible: true,
          controlCaption:`My <b>worries overwhelmed</b> me`,
          itemType:"data-item", dataItemId:"qol_AnxWorries", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:true,
          lookUpTable:[
            {value:1, text:"Never"},
            {value:2, text:"Rarely"},
            {value:3, text:"Sometimes"},
            {value:4, text:"Often"},
            {value:5, text:"Always"},
          ],
          lookupIsRequired:true,
          validationRules:[this.requiredRule,],
          controlEnabled:true,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"3", position: 0, visible: true,
          controlCaption:`I felt <b>uneasy</b>`,
          itemType:"data-item", dataItemId:"qol_AnxUneasy", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:true,
          lookUpTable:[
            {value:1, text:"Never"},
            {value:2, text:"Rarely"},
            {value:3, text:"Sometimes"},
            {value:4, text:"Often"},
            {value:5, text:"Always"},
          ],
          lookupIsRequired:true,
          validationRules:[this.requiredRule,],
          controlEnabled:true,
          customError:false,
          customErrorMessage:'',
        }, {
          id:"4",
          itemType:"section-instruction",
          sectionTitle:`<p>Depression</p><p>In the past 7 days...</p>`,
          pageSplitInDesktopMode: [4],
          position: 0,
          visible: true,
        }, {
          fgId:"4", position: 0, visible: true,
          controlCaption:`I felt <b>worthless</b>`,
          itemType:"data-item", dataItemId:"qol_DeprWorthless", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:true,
          lookUpTable:[
            {value:1, text:"Never"},
            {value:2, text:"Rarely"},
            {value:3, text:"Sometimes"},
            {value:4, text:"Often"},
            {value:5, text:"Always"},
          ],
          lookupIsRequired:true,
          validationRules:[this.requiredRule,],
          controlEnabled:true,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"4", position: 0, visible: true,
          controlCaption:`I felt <b>helpless</b>`,
          itemType:"data-item", dataItemId:"qol_DeprHelpless", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:true,
          lookUpTable:[
            {value:1, text:"Never"},
            {value:2, text:"Rarely"},
            {value:3, text:"Sometimes"},
            {value:4, text:"Often"},
            {value:5, text:"Always"},
          ],
          lookupIsRequired:true,
          validationRules:[this.requiredRule,],
          controlEnabled:true,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"4", position: 0, visible: true,
          controlCaption:`I felt <b>depressed</b>`,
          itemType:"data-item", dataItemId:"qol_DeprDepressed", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:true,
          lookUpTable:[
            {value:1, text:"Never"},
            {value:2, text:"Rarely"},
            {value:3, text:"Sometimes"},
            {value:4, text:"Often"},
            {value:5, text:"Always"},
          ],
          lookupIsRequired:true,
          validationRules:[this.requiredRule,],
          controlEnabled:true,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"4", position: 0, visible: true,
          controlCaption:`I felt <b>hopeless</b>`,
          itemType:"data-item", dataItemId:"qol_DeprHopeless", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:true,
          lookUpTable:[
            {value:1, text:"Never"},
            {value:2, text:"Rarely"},
            {value:3, text:"Sometimes"},
            {value:4, text:"Often"},
            {value:5, text:"Always"},
          ],
          lookupIsRequired:true,
          validationRules:[this.requiredRule,],
          controlEnabled:true,
          customError:false,
          customErrorMessage:'',
        }, {
          id:"5",
          itemType:"section-instruction",
          sectionTitle:`<p>Fatigue</p><p>During the past 7 days...</p>`,
          pageSplitInDesktopMode: [4],
          position: 0,
          visible: true,
        }, {
          fgId:"5", position: 0, visible: true,
          controlCaption:`I feel <b>fatigued</b>`,
          itemType:"data-item", dataItemId:"qol_FatigFatigued", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:true,
          lookUpTable:[
            {value:1, text:"Not at all"},
            {value:2, text:"A little bit"},
            {value:3, text:"Somewhat"},
            {value:4, text:"Quite a bit"},
            {value:5, text:"Very much"},
          ],
          lookupIsRequired:true,
          validationRules:[this.requiredRule,],
          controlEnabled:true,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"5", position: 0, visible: true,
          controlCaption:`I have trouble <b>starting things</b> because I am <b>tired</b>`,
          itemType:"data-item", dataItemId:"qol_FatigTroubleStarting", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:true,
          lookUpTable:[
            {value:1, text:"Not at all"},
            {value:2, text:"A little bit"},
            {value:3, text:"Somewhat"},
            {value:4, text:"Quite a bit"},
            {value:5, text:"Very much"},
          ],
          lookupIsRequired:true,
          validationRules:[this.requiredRule,],
          controlEnabled:true,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"5", position: 0, visible: true,
          controlCaption:`How <b>run-down</b> did you feel on <b>average</b>?`,
          itemType:"data-item", dataItemId:"qol_FatigRunDown", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:true,
          lookUpTable:[
            {value:1, text:"Not at all"},
            {value:2, text:"A little bit"},
            {value:3, text:"Somewhat"},
            {value:4, text:"Quite a bit"},
            {value:5, text:"Very much"},
          ],
          lookupIsRequired:true,
          validationRules:[this.requiredRule,],
          controlEnabled:true,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"5", position: 0, visible: true,
          controlCaption:`How <b>fatigued</b> were you on <b>average</b>?`,
          itemType:"data-item", dataItemId:"qol_FatigHowFatigued", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:true,
          lookUpTable:[
            {value:1, text:"Not at all"},
            {value:2, text:"A little bit"},
            {value:3, text:"Somewhat"},
            {value:4, text:"Quite a bit"},
            {value:5, text:"Very much"},
          ],
          lookupIsRequired:true,
          validationRules:[this.requiredRule,],
          controlEnabled:true,
          customError:false,
          customErrorMessage:'',
        }, {
          id:"6",
          itemType:"section-instruction",
          sectionTitle:`<p>Sleep Disturbance</p><p>In the past 7 days...</p>`,
          pageSplitInDesktopMode: [4],
          position: 0,
          visible: true,
        }, {
          fgId:"6", position: 0, visible: true,
          controlCaption:`My <b>sleep quality</b> was`,
          itemType:"data-item", dataItemId:"qol_SleepQuality", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:true,
          lookUpTable:[
            {value:5, text:"Very poor"},
            {value:4, text:"Poor"},
            {value:3, text:"Fair"},
            {value:2, text:"Good"},
            {value:1, text:"Very good"},
          ],
          lookupIsRequired:true,
          validationRules:[this.requiredRule,],
          controlEnabled:true,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"6", position: 0, visible: true,
          controlCaption:`My <b>sleep</b> was <b>refreshing</b>`,
          itemType:"data-item", dataItemId:"qol_SleepRefreshing", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:true,
          lookUpTable:[
            {value:5, text:"Not at all"},
            {value:4, text:"A little bit"},
            {value:3, text:"Somewhat"},
            {value:2, text:"Quite a bit"},
            {value:1, text:"Very much"},
          ],
          lookupIsRequired:true,
          validationRules:[this.requiredRule,],
          controlEnabled:true,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"6", position: 0, visible: true,
          controlCaption:`I had a <b>problem</b> with my <b>sleep</b>`,
          itemType:"data-item", dataItemId:"qol_SleepProblem", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:true,
          lookUpTable:[
            {value:1, text:"Not at all"},
            {value:2, text:"A little bit"},
            {value:3, text:"Somewhat"},
            {value:4, text:"Quite a bit"},
            {value:5, text:"Very much"},
          ],
          lookupIsRequired:true,
          validationRules:[this.requiredRule,],
          controlEnabled:true,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"6", position: 0, visible: true,
          controlCaption:`I had <b>difficulty falling asleep</b>`,
          itemType:"data-item", dataItemId:"qol_SleepDifficulty", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:true,
          lookUpTable:[
            {value:1, text:"Not at all"},
            {value:2, text:"A little bit"},
            {value:3, text:"Somewhat"},
            {value:4, text:"Quite a bit"},
            {value:5, text:"Very much"},
          ],
          lookupIsRequired:true,
          validationRules:[this.requiredRule,],
          controlEnabled:true,
          customError:false,
          customErrorMessage:'',
        }, {
          id:"7",
          itemType:"section-instruction",
          sectionTitle:`Ability to Participate in Social Roles and Activities`,
          pageSplitInDesktopMode: [4],
          position: 0,
          visible: true,
        }, {
          fgId:"7", position: 0, visible: true,
          controlCaption:`I have <b>trouble</b> doing all of my <b>regular leisure activities</b> with others`,
          itemType:"data-item", dataItemId:"qol_SocAcLeisure", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:true,
          lookUpTable:[
            {value:5, text:"Never"},
            {value:4, text:"Rarely"},
            {value:3, text:"Sometimes"},
            {value:2, text:"Usually"},
            {value:1, text:"Always"},
          ],
          lookupIsRequired:true,
          validationRules:[this.requiredRule,],
          controlEnabled:true,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"7", position: 0, visible: true,
          controlCaption:`I have <b>trouble</b> doing all of the <b>family activities</b> that I want to do`,
          itemType:"data-item", dataItemId:"qol_SocAcFamily", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:true,
          lookUpTable:[
            {value:5, text:"Never"},
            {value:4, text:"Rarely"},
            {value:3, text:"Sometimes"},
            {value:2, text:"Usually"},
            {value:1, text:"Always"},
          ],
          lookupIsRequired:true,
          validationRules:[this.requiredRule,],
          controlEnabled:true,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"7", position: 0, visible: true,
          controlCaption:`I have <b>trouble</b> doing all of my <b>usual work</b> (include work at home)`,
          itemType:"data-item", dataItemId:"qol_SocAcWork", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:true,
          lookUpTable:[
            {value:5, text:"Never"},
            {value:4, text:"Rarely"},
            {value:3, text:"Sometimes"},
            {value:2, text:"Usually"},
            {value:1, text:"Always"},
          ],
          lookupIsRequired:true,
          validationRules:[this.requiredRule,],
          controlEnabled:true,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"7", position: 0, visible: true,
          controlCaption:`I have <b>trouble</b> doing all of the <b>activities</b> with <b>friends</b> that I want to do`,
          itemType:"data-item", dataItemId:"qol_SocAcFriends", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:true,
          lookUpTable:[
            {value:5, text:"Never"},
            {value:4, text:"Rarely"},
            {value:3, text:"Sometimes"},
            {value:2, text:"Usually"},
            {value:1, text:"Always"},
          ],
          lookupIsRequired:true,
          validationRules:[this.requiredRule,],
          controlEnabled:true,
          customError:false,
          customErrorMessage:'',
        }, {
          id:"8",
          itemType:"section-instruction",
          sectionTitle:`<p>Pain Interference</p><p>In the past 7 days...</p>`,
          pageSplitInDesktopMode: [4],
          position: 0,
          visible: true,
        }, {
          fgId:"8", position: 0, visible: true,
          controlCaption:`How much did <b>pain interfere</b> with your day to day <b>activities</b>?`,
          itemType:"data-item", dataItemId:"qol_PainDayToDayActivities", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:true,
          lookUpTable:[
            {value:1, text:"Not at all"},
            {value:2, text:"A little bit"},
            {value:3, text:"Somewhat"},
            {value:4, text:"Quite a bit"},
            {value:5, text:"Very much"},
          ],
          lookupIsRequired:true,
          validationRules:[this.requiredRule,],
          controlEnabled:true,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"8", position: 0, visible: true,
          controlCaption:`How much did <b>pain interfere</b> with work around the <b>home</b>?`,
          itemType:"data-item", dataItemId:"qol_PainWorkAroundHome", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:true,
          lookUpTable:[
            {value:1, text:"Not at all"},
            {value:2, text:"A little bit"},
            {value:3, text:"Somewhat"},
            {value:4, text:"Quite a bit"},
            {value:5, text:"Very much"},
          ],
          lookupIsRequired:true,
          validationRules:[this.requiredRule,],
          controlEnabled:true,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"8", position: 0, visible: true,
          controlCaption:`How much did <b>pain interfere</b> with your ability to participate in <b>social activities</b>?`,
          itemType:"data-item", dataItemId:"qol_PainSocialActivities", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:true,
          lookUpTable:[
            {value:1, text:"Not at all"},
            {value:2, text:"A little bit"},
            {value:3, text:"Somewhat"},
            {value:4, text:"Quite a bit"},
            {value:5, text:"Very much"},
          ],
          lookupIsRequired:true,
          validationRules:[this.requiredRule,],
          controlEnabled:true,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"8", position: 0, visible: true,
          controlCaption:`How much did <b>pain interfere</b> with your <b>household chores</b>?`,
          itemType:"data-item", dataItemId:"qol_PainHouseholdChores", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:true,
          lookUpTable:[
            {value:1, text:"Not at all"},
            {value:2, text:"A little bit"},
            {value:3, text:"Somewhat"},
            {value:4, text:"Quite a bit"},
            {value:5, text:"Very much"},
          ],
          lookupIsRequired:true,
          validationRules:[this.requiredRule,],
          controlEnabled:true,
          customError:false,
          customErrorMessage:'',
        }, {
          id:"9",
          itemType:"section-instruction",
          sectionTitle:`<p>Cognitive Function - Abilities.</p><p>In the past 7 days...</p>`,
          position: 0,
          visible: true,
        }, {
          fgId:"9", position: 0, visible: true,
          controlCaption:`I have been <b>able</b> to <b>concentrate</b>`,
          itemType:"data-item", dataItemId:"qol_CogFuncConcentrate", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:true,
          lookUpTable:[
            {value:1, text:"Not at all"},
            {value:2, text:"A little bit"},
            {value:3, text:"Somewhat"},
            {value:4, text:"Quite a bit"},
            {value:5, text:"Very much"},
          ],
          lookupIsRequired:true,
          validationRules:[this.requiredRule,],
          controlEnabled:true,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"9", position: 0, visible: true,
          controlCaption:`I have been able to <b>remember</b> to <b>do things</b>, like take medicine or buy something I needed`,
          itemType:"data-item", dataItemId:"qol_CogFuncRemember", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:true,
          lookUpTable:[
            {value:1, text:"Not at all"},
            {value:2, text:"A little bit"},
            {value:3, text:"Somewhat"},
            {value:4, text:"Quite a bit"},
            {value:5, text:"Very much"},
          ],
          lookupIsRequired:true,
          validationRules:[this.requiredRule,],
          controlEnabled:true,
          customError:false,
          customErrorMessage:'',
        }, {
          id:"10",
          itemType:"section-instruction",
          sectionTitle:`<p>Pain Intensity</p><p>In the past 7 days...</p>`,
          position: 0,
          visible: true,
        }, {
          fgId:"10", position: 0, visible: true,
          controlCaption:`How would you <b>rate</b> your pain on <b>average</b>? (Scale of 0 - 10)`,
          itemType:"data-item", dataItemId:"qol_PainIntensity", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:true,
          lookUpTable:[
            {value:0, text:"0 - No pain"},
            {value:1, text:"1"},
            {value:2, text:"2"},
            {value:3, text:"3"},
            {value:4, text:"4"},
            {value:5, text:"5"},
            {value:6, text:"6"},
            {value:7, text:"7"},
            {value:8, text:"8"},
            {value:9, text:"9"},
            {value:10, text:"10 - Worst pain imaginable"},
          ],
          lookupIsRequired:true,
          validationRules:[this.requiredRule,],
          controlEnabled:true,
          customError:false,
          customErrorMessage:'',
        },
      ]
    }, tbFrmPROMISNeuro:{
      crfTitle: "3-month Questionnaire - Section 2: How well you understand things",
      tableName: "tbFrmPROMISNeuro",
      timePointDataItem: "hwu_DummyTimePoint",
      dataItems:[
        {
          id:"1",
          itemType:"section-instruction",
          sectionTitle:``,
          position: 0,
          visible: true,
        }, {
          id:"2",
          itemType:"section-instruction",
          sectionTitle:`<p>Please <b>respond</b> to each <b>question</b> or statement by <b>marking one box</b> per row.</p> <p style="color:blue;font-size:16px">In the past 7 days...</p>`,
          footer:`<p style="font-size: 0.8rem"> ©2008-2020 David Cella on behalf of the National Institute for Neurological Disorders and Stroke (NINDS). Some content used with permission of the PROMIS Health Organization. </p>`,
          pageSplitInDesktopMode: [4],
          position: 0,
          visible: true,
        }, {
          fgId:"2", position: 0, visible: true,
          controlCaption:`I had to <b>read</b> something <b>several times</b> to <b>understand</b> it`,
          itemType:"data-item", dataItemId:"hwu_ReadSeveralTimes", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:true,
          lookUpTable:[
            {value:5, text:"Never"},
            {value:4, text:"Rarely (once)"},
            {value:3, text:"Sometimes (2-3 times)"},
            {value:2, text:"Often (once a day)"},
            {value:1, text:"Very often (several times a day)"},
          ],
          lookupIsRequired:true,
          validationRules:[this.requiredRule,],
          controlEnabled:true,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"2", position: 0, visible: true,
          controlCaption:`My <b>thinking</b> was <b>slow</b>`,
          itemType:"data-item", dataItemId:"hwu_ThinkingSlow", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:true,
          lookUpTable:[
            {value:5, text:"Never"},
            {value:4, text:"Rarely (once)"},
            {value:3, text:"Sometimes (2-3 times)"},
            {value:2, text:"Often (once a day)"},
            {value:1, text:"Very often (several times a day)"},
          ],
          lookupIsRequired:true,
          validationRules:[this.requiredRule,],
          controlEnabled:true,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"2", position: 0, visible: true,
          controlCaption:`I had to <b>work</b> really <b>hard</b> to <b>pay attention or</b> I would <b>make</b> a <b>mistake</b>`,
          itemType:"data-item", dataItemId:"hwu_AttentionMistake", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:true,
          lookUpTable:[
            {value:5, text:"Never"},
            {value:4, text:"Rarely (once)"},
            {value:3, text:"Sometimes (2-3 times)"},
            {value:2, text:"Often (once a day)"},
            {value:1, text:"Very often (several times a day)"},
          ],
          lookupIsRequired:true,
          validationRules:[this.requiredRule,],
          controlEnabled:true,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"2", position: 0, visible: true,
          controlCaption:`I had <b>trouble concentrating</b>`,
          itemType:"data-item", dataItemId:"hwu_TroubleConcentrating", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:true,
          lookUpTable:[
            {value:5, text:"Never"},
            {value:4, text:"Rarely (once)"},
            {value:3, text:"Sometimes (2-3 times)"},
            {value:2, text:"Often (once a day)"},
            {value:1, text:"Very often (several times a day)"},
          ],
          lookupIsRequired:true,
          validationRules:[this.requiredRule,],
          controlEnabled:true,
          customError:false,
          customErrorMessage:'',
        }, {
          id:"3",
          itemType:"section-instruction",
          sectionTitle:`How much DIFFICULTY do you currently have...`,
          footer:`<p style="font-size: 0.8rem"> ©2008-2020 David Cella on behalf of the National Institute for Neurological Disorders and Stroke (NINDS). Some content used with permission of the PROMIS Health Organization. </p>`,
          pageSplitInDesktopMode: [4],
          position: 0,
          visible: true,
        }, {
          fgId:"3", position: 0, visible: true,
          controlCaption:`<b>Reading</b> and <b>following complex instructions</b> (e.g. directions for a new medication)?`,
          itemType:"data-item", dataItemId:"hwu_ComplexInstructions", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:true,
          lookUpTable:[
            {value:5, text:"None"},
            {value:4, text:"A little"},
            {value:3, text:"Somewhat"},
            {value:2, text:"A lot"},
            {value:1, text:"Cannot do"},
          ],
          lookupIsRequired:true,
          validationRules:[this.requiredRule,],
          controlEnabled:true,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"3", position: 0, visible: true,
          controlCaption:`<b>Planning</b> for and <b>keeping</b> appointments that are <b>not part</b> of your <b>weekly routine</b>, (e.g. a therapy or doctor appointment, or a social gathering with friends and family)?`,
          itemType:"data-item", dataItemId:"hwu_Appointments", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:true,
          lookUpTable:[
            {value:5, text:"None"},
            {value:4, text:"A little"},
            {value:3, text:"Somewhat"},
            {value:2, text:"A lot"},
            {value:1, text:"Cannot do"},
          ],
          lookupIsRequired:true,
          validationRules:[this.requiredRule,],
          controlEnabled:true,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"3", position: 0, visible: true,
          controlCaption:`<b>Managing</b> your <b>time</b> to <b>do most</b> of your daily <b>activities</b>?`,
          itemType:"data-item", dataItemId:"hwu_ManagingTime", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:true,
          lookUpTable:[
            {value:5, text:"None"},
            {value:4, text:"A little"},
            {value:3, text:"Somewhat"},
            {value:2, text:"A lot"},
            {value:1, text:"Cannot do"},
          ],
          lookupIsRequired:true,
          validationRules:[this.requiredRule,],
          controlEnabled:true,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"3", position: 0, visible: true,
          controlCaption:`<b>Learning new tasks</b> or <b>instructions</b>?`,
          itemType:"data-item", dataItemId:"hwu_LearningNewTasks", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:true,
          lookUpTable:[
            {value:5, text:"None"},
            {value:4, text:"A little"},
            {value:3, text:"Somewhat"},
            {value:2, text:"A lot"},
            {value:1, text:"Cannot do"},
          ],
          lookupIsRequired:true,
          validationRules:[this.requiredRule,],
          controlEnabled:true,
          customError:false,
          customErrorMessage:'',
        },
      ]
    }, tbFrmQoLEQ5D5L_EQ5D:{
      crfTitle: "Your Health and Quality of Life",
      tableName: "tbFrmQoLEQ5D5L_EQ5D",
      timePointDataItem: "eqd_DummyTimePoint",
      dataItems:[
        {
          id:"1",
          itemType:"section-instruction",
          sectionTitle:``,
          position: 0,
          visible: true,
        }, {
          id:"2",
          itemType:"section-instruction",
          sectionTitle:`Please select the ONE option that best describes your health TODAY.`,
          position: 0,
          visible: true,
        }, {
          fgId:"2", position: 0, visible: true,
          controlCaption:`Mobility`,
          itemType:"data-item", dataItemId:"eqd_Mobility", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:true,
          lookUpTable:[
            {value:1, text:"I have no problems in walking about"},
            {value:2, text:"I have slight problems in walking about"},
            {value:3, text:"I have moderate problems in walking about"},
            {value:4, text:"I have severe problems in walking about"},
            {value:5, text:"I am unable to walk about"},
          ],
          lookupIsRequired:true,
          validationRules:[this.requiredRule,],
          controlEnabled:true,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"2", position: 0, visible: true,
          controlCaption:`Self-care`,
          itemType:"data-item", dataItemId:"eqd_SelfCare", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:true,
          lookUpTable:[
            {value:1, text:"I have no problems washing or dressing myself"},
            {value:2, text:"I have slight problems washing or dressing myself"},
            {value:3, text:"I have moderate problems washing or dressing myself"},
            {value:4, text:"I have severe problems washing or dressing myself"},
            {value:5, text:"I am unable to wash or dress myself"},
          ],
          lookupIsRequired:true,
          validationRules:[this.requiredRule,],
          controlEnabled:true,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"2", position: 0, visible: true,
          controlCaption:`Usual Activities (e.g. work, study, housework, family or leisure activities)`,
          itemType:"data-item", dataItemId:"eqd_UsualActivities", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:true,
          lookUpTable:[
            {value:1, text:"I have no problem doing my usual activities"},
            {value:2, text:"I have slight problems doing my usual activities"},
            {value:3, text:"I have moderate problems doing my usual activities"},
            {value:4, text:"I have severe problems doing my usual activities"},
            {value:5, text:"I am unable to do my usual activities"},
          ],
          lookupIsRequired:true,
          validationRules:[this.requiredRule,],
          controlEnabled:true,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"2", position: 0, visible: true,
          controlCaption:`Pain / discomfort`,
          itemType:"data-item", dataItemId:"eqd_PainDiscomfort", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:true,
          lookUpTable:[
            {value:1, text:"I have no pain or discomfort"},
            {value:2, text:"I have slight pain or discomfort"},
            {value:3, text:"I have moderate pain or discomfort"},
            {value:4, text:"I have severe pain or discomfort"},
            {value:5, text:"I have extreme pain or discomfort"},
          ],
          lookupIsRequired:true,
          validationRules:[this.requiredRule,],
          controlEnabled:true,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"2", position: 0, visible: true,
          controlCaption:`Anxiety / Depression`,
          itemType:"data-item", dataItemId:"eqd_AnxietyDepression", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:true,
          lookUpTable:[
            {value:1, text:"I am not anxious or depressed"},
            {value:2, text:"I am slightly anxious or depressed"},
            {value:3, text:"I am moderately anxious or depressed"},
            {value:4, text:"I am severely anxious or depressed"},
            {value:5, text:"I am extremely anxious or depressed"},
          ],
          lookupIsRequired:true,
          validationRules:[this.requiredRule,],
          controlEnabled:true,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"2", position: 0, visible: true,
          controlCaption:`<p><b>We would like to know how good or bad your health is TODAY.</b></p> <p><b>Please can you let us know, using a number from 0-100 where 100 is the best health you can imagine and 0 is the worst health you can imagine?</b></p>`,
          itemType:"data-item", dataItemId:"eqd_YourHealthToday", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'numeric',
          missingDataExclude:false,
          hasLookUpTable:false,
          validationRules:[this.tinyintRule,this.requiredRule,(v) => this.numberRangeRule(v,0,100),],
          controlEnabled:true,
          customError:false,
          customErrorMessage:'',
        },
      ]
    }, tbFrmIPAQSF:{
      crfTitle: "3-month Questionnaire - Section 4: Your Activity Levels",
      tableName: "tbFrmIPAQSF",
      timePointDataItem: "ipa_DummyTimePoint",
      dataItems:[
        {
          id:"1",
          itemType:"section-instruction",
          sectionTitle:``,
          position: 0,
          visible: true,
        }, {
          id:"2",
          itemType:"section-instruction",
          sectionTitle:`<p>INTERNATIONAL PHYSICAL ACTIVITY QUESTIONNAIRE</p><p><p>We are interested in finding out about the kinds of <b>physical activities</b> that people <b>do</b> as part of their <b>everyday lives</b>.</p> <br/> <p>The <b>questions</b> will ask you <b>about</b> the <b>time</b> you <b>spent</b> being <b>physically active</b> in the <b>last 7 days</b>. Please <b>answer</b> each question <b>even if</b> you do <b>not consider yourself</b> to be an <b>active</b> person.</p> <br/> <p>Please <b>think about</b> the <b>activities</b> you do at <b>work</b>, as part of your <b>house</b> and <b>yard work</b>, to <b>get</b> from <b>place to place</b>, and in your <b>spare time</b> for <b>recreation, exercise</b> or <b>sport</b>.</p> <br/> <p style="color:blue;font-size:16px">Think about all the <b>vigorous activities</b> that you did in the <b>last 7 days. Vigorous</b> physical activities refer to activities that take <b>hard physical effort</b> and make you <b>breathe much harder</b> than <b>normal</b>. Think <b>only</b> about those physical <b>activities</b> that you <b>did</b> for <b>at least 10 minutes</b> at a time.</p> </p>`,
          pageSplitInDesktopMode: [1,2],
          pageSplitInMobileMode: [1,2],
          position: 0,
          visible: true,
        }, {
          fgId:"2", position: 0, visible: true,
          controlCaption:`During the <b>last 7 days</b>, on <b>how many days</b> did you do <b>vigorous physical activities</b> like heavy lifting, digging, aerobics, or fast bicycling?`,
          itemType:"data-item", dataItemId:"ipa_VigorousDaysPerWeek", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:true,
          lookUpTable:[
            {value:1, text:"1 day per week"},
            {value:2, text:"2 days per week"},
            {value:3, text:"3 days per week"},
            {value:4, text:"4 days per week"},
            {value:5, text:"5 days per week"},
            {value:6, text:"6 days per week"},
            {value:7, text:"7 days per week"},
            {value:8, text:"No vigorous physical activities"},
          ],
          lookupIsRequired:false,
          validationRules:[],
          controlEnabled:true,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"2", position: 0, visible: true,
          controlCaption:`Do you know how much <b>time</b> you spend doing <b>vigorous physical activities</b>?`,
          itemType:"data-item", dataItemId:"ipa_VigorousActivityTime", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:true,
          lookUpTable:[
            {value:1, text:"Don't know/Not sure"},
            {value:2, text:"Yes"},
          ],
          lookupIsRequired:false,
          validationRules:[],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"2", position: 0, visible: true,
          controlCaption:`How much <b>time</b> did you <b>usually spend</b> doing <b>vigorous physical activities</b> on <b>one</b> of those <b>days</b>? - minutes`,
          itemType:"data-item", dataItemId:"ipa_VigorousMinutesV2", dataItemValue:"",
          dataType:"int", length:false,
          prefix:'', suffix:'minutes per day',
          inputmode:'numeric',
          missingDataExclude:false,
          hasLookUpTable:false,
          validationRules:[this.intRule,(v) => this.numberRangeRule(v,0,9999),],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          id:"3",
          itemType:"section-instruction",
          sectionTitle:`Think about all the <b>moderate activities</b> that you did in the <b>last 7 days</b>. <b>Moderate</b> activities refer to activities that take <b>moderate physical effort</b> and make you <b>breathe somewhat harder</b> than <b>normal</b>. Think <b>only</b> about those physical <b>activities</b> that you <b>did</b> for <b>at least 10 minutes</b> at a time.`,
          pageSplitInDesktopMode: [1,2],
          pageSplitInMobileMode: [1,2],
          position: 0,
          visible: true,
        }, {
          fgId:"3", position: 0, visible: true,
          controlCaption:`During the <b>last 7 days</b>, on <b>how many days</b> did you do <b>moderate physical activities</b> like carrying light loads, bicycling at a regular pace, or doubles tennis? Do not include walking.`,
          itemType:"data-item", dataItemId:"ipa_ModerateDaysPerWeek", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:true,
          lookUpTable:[
            {value:1, text:"1 day per week"},
            {value:2, text:"2 days per week"},
            {value:3, text:"3 days per week"},
            {value:4, text:"4 days per week"},
            {value:5, text:"5 days per week"},
            {value:6, text:"6 days per week"},
            {value:7, text:"7 days per week"},
            {value:8, text:"No moderate physical activities"},
          ],
          lookupIsRequired:false,
          validationRules:[],
          controlEnabled:true,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"3", position: 0, visible: true,
          controlCaption:`Do you know how much <b>time</b> you spend doing <b>moderate physical activities</b>?`,
          itemType:"data-item", dataItemId:"ipa_ModerateActivityTime", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:true,
          lookUpTable:[
            {value:1, text:"Don't know/Not sure"},
            {value:2, text:"Yes"},
          ],
          lookupIsRequired:false,
          validationRules:[],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"3", position: 0, visible: true,
          controlCaption:`How much <b>time</b> did you <b>usually spend</b> doing <b>moderate physical activities</b> on <b>one</b> of those <b>days</b>? - minutes`,
          itemType:"data-item", dataItemId:"ipa_ModerateMinutesV2", dataItemValue:"",
          dataType:"int", length:false,
          prefix:'', suffix:'minutes per day',
          inputmode:'numeric',
          missingDataExclude:false,
          hasLookUpTable:false,
          validationRules:[this.intRule,(v) => this.numberRangeRule(v,0,9999),],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          id:"4",
          itemType:"section-instruction",
          sectionTitle:`Think about the <b>time</b> you spent <b>walking</b> in the <b>last 7 days</b>. This includes at <b>work</b> and at <b>home</b>, walking to <b>travel</b> from place to place, and any <b>other walking</b> that you have done <b>solely</b> for <b>recreation, sport, exercise</b>, or <b>leisure</b>.`,
          pageSplitInDesktopMode: [1,2],
          pageSplitInMobileMode: [1,2],
          position: 0,
          visible: true,
        }, {
          fgId:"4", position: 0, visible: true,
          controlCaption:`During the <b>last 7 days</b>, on <b>how many days</b> did you <b>walk</b> for <b>at least 10 minutes</b> at a time?`,
          itemType:"data-item", dataItemId:"ipa_WalkingDaysPerWeek", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:true,
          lookUpTable:[
            {value:1, text:"1 day per week"},
            {value:2, text:"2 days per week"},
            {value:3, text:"3 days per week"},
            {value:4, text:"4 days per week"},
            {value:5, text:"5 days per week"},
            {value:6, text:"6 days per week"},
            {value:7, text:"7 days per week"},
            {value:8, text:"No walking"},
          ],
          lookupIsRequired:false,
          validationRules:[],
          controlEnabled:true,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"4", position: 0, visible: true,
          controlCaption:`Do you know how much <b>time</b> you spend <b>walking</b>?`,
          itemType:"data-item", dataItemId:"ipa_WalkingTime", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:true,
          lookUpTable:[
            {value:1, text:"Don't know/Not sure"},
            {value:2, text:"Yes"},
          ],
          lookupIsRequired:false,
          validationRules:[],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"4", position: 0, visible: true,
          controlCaption:`How much <b>time</b> did you <b>usually spend walking</b> on <b>one</b> of those <b>days</b>? - minutes`,
          itemType:"data-item", dataItemId:"ipa_WalkingMinutesV2", dataItemValue:"",
          dataType:"int", length:false,
          prefix:'', suffix:'minutes per day',
          inputmode:'numeric',
          missingDataExclude:false,
          hasLookUpTable:false,
          validationRules:[this.intRule,(v) => this.numberRangeRule(v,0,9999),],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          id:"5",
          itemType:"section-instruction",
          sectionTitle:`The last question is about the <b>time</b> you <b>spent sitting</b> on <b>weekdays</b> during the <b>last 7 days</b>. Include time spent at <b>work</b>, at <b>home</b>, while <b>doing course work</b> and during <b>leisure</b> time. This may <b>include</b> time spent <b>sitting at</b> a <b>desk, visiting friends, reading</b>, or <b>sitting</b> or <b>lying down</b> to <b>watch television</b>.`,
          pageSplitInDesktopMode: [2],
          pageSplitInMobileMode: [2],
          position: 0,
          visible: true,
        }, {
          fgId:"5", position: 0, visible: true,
          controlCaption:`Do you know how much <b>time</b> you spend <b>sitting</b> on a <b>week day</b>?`,
          itemType:"data-item", dataItemId:"ipa_SittingTime", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:true,
          lookUpTable:[
            {value:1, text:"Don't know/Not sure"},
            {value:2, text:"Yes"},
          ],
          lookupIsRequired:false,
          validationRules:[],
          controlEnabled:true,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"5", position: 0, visible: true,
          controlCaption:`During the <b>last 7 days</b>, <b>how much time</b> did you spend <b>sitting</b> on a <b>week day</b>? - minutes`,
          itemType:"data-item", dataItemId:"ipa_SittingMinutesV2", dataItemValue:"",
          dataType:"int", length:false,
          prefix:'', suffix:'minutes per day',
          inputmode:'numeric',
          missingDataExclude:false,
          hasLookUpTable:false,
          validationRules:[this.intRule,(v) => this.numberRangeRule(v,0,9999),],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        },
      ]
    }, tbFrmChgOfContDtl:{
      crfTitle: "3-month Questionnaire - Change of Contact Details",
      tableName: "tbFrmChgOfContDtl",
      timePointDataItem: "ccd_DummyTimePoint",
      dataItems:[
        {
          id:"1",
          itemType:"section-instruction",
          sectionTitle:`[[front-blurb]]`,
          position: 0,
          visible: true,
        }, {
          id:"2",
          itemType:"section-instruction",
          sectionTitle:``,
          position: 0,
          visible: true,
        }, {
          id:"3",
          itemType:"section-instruction",
          sectionTitle:`Change of Contact Details`,
          pageSplitInMobileMode: [1,3,3,2,2,1,2,4,1,3],
          position: 0,
          visible: true,
        }, {
          fgId:"3", position: 0, visible: true,
          controlCaption:`Has your <b>address changed</b> in the last <b>{{3or6Months}}</b>?`,
          itemType:"data-item", dataItemId:"ccd_AddressChanged", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:true,
          lookUpTable:[
            {value:1, text:"No"},
            {value:2, text:"Yes"},
          ],
          lookupIsRequired:true,
          validationRules:[this.requiredRule,],
          controlEnabled:true,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"3", position: 0, visible: true,
          controlCaption:`House name/number`,
          itemType:"data-item", dataItemId:"ccd_HouseNameNumber", dataItemValue:"",
          dataType:"nvarchar", length:100,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:false,
          validationRules:[this.requiredRule,],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"3", position: 0, visible: true,
          controlCaption:`Street`,
          itemType:"data-item", dataItemId:"ccd_Street", dataItemValue:"",
          dataType:"nvarchar", length:100,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:false,
          validationRules:[this.requiredRule,],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"3", position: 0, visible: true,
          controlCaption:`Town/City`,
          itemType:"data-item", dataItemId:"ccd_TownCity", dataItemValue:"",
          dataType:"nvarchar", length:50,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:false,
          validationRules:[this.requiredRule,],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"3", position: 0, visible: true,
          controlCaption:`County`,
          itemType:"data-item", dataItemId:"ccd_County", dataItemValue:"",
          dataType:"nvarchar", length:50,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:false,
          validationRules:[this.requiredRule,],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"3", position: 0, visible: true,
          controlCaption:`Country`,
          itemType:"data-item", dataItemId:"ccd_Country", dataItemValue:"",
          dataType:"nvarchar", length:50,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:false,
          validationRules:[this.requiredRule,],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"3", position: 0, visible: true,
          controlCaption:`Postcode`,
          itemType:"data-item", dataItemId:"ccd_Postcode", dataItemValue:"",
          dataType:"nvarchar", length:50,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:false,
          validationRules:[this.requiredRule,this.postcodeRule,],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"3", position: 0, visible: true,
          controlCaption:`Has your <b>mobile phone number changed</b> in the last {{3or6Months}}/is it due to <b>change soon</b>?`,
          itemType:"data-item", dataItemId:"ccd_MobileNumberChanged", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:true,
          lookUpTable:[
            {value:1, text:"No"},
            {value:2, text:"Yes"},
          ],
          lookupIsRequired:true,
          validationRules:[this.requiredRule,],
          controlEnabled:true,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"3", position: 0, visible: true,
          controlCaption:`Mobile Number`,
          itemType:"data-item", dataItemId:"ccd_MobileTelNo", dataItemValue:"",
          dataType:"nvarchar", length:11,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:false,
          validationRules:[this.requiredRule,(v) => this.regExpRule(v,'^(07\\d{9})$','Invalid mobile number'),],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"3", position: 0, visible: true,
          controlCaption:`Has your <b>email address changed</b> in the last {{3or6Months}}/is it due to <b>change to soon</b>?`,
          itemType:"data-item", dataItemId:"ccd_EmailAddressChanged", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:true,
          lookUpTable:[
            {value:1, text:"No"},
            {value:2, text:"Yes"},
          ],
          lookupIsRequired:true,
          validationRules:[this.requiredRule,],
          controlEnabled:true,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"3", position: 0, visible: true,
          controlCaption:`Email address`,
          itemType:"data-item", dataItemId:"ccd_Email", dataItemValue:"",
          dataType:"nvarchar", length:100,
          prefix:'', suffix:'',
          inputmode:'email',
          missingDataExclude:false,
          hasLookUpTable:false,
          validationRules:[this.requiredRule,this.emailRule,],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"3", position: 0, visible: true,
          controlCaption:`Have the <b>contact details<b> for your <b>GP or GP Practice changed</b> in the last {{3or6Months}}?`,
          itemType:"data-item", dataItemId:"ccd_GPChanged", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:true,
          lookUpTable:[
            {value:1, text:"No"},
            {value:2, text:"Yes"},
          ],
          lookupIsRequired:true,
          validationRules:[this.requiredRule,],
          controlEnabled:true,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"3", position: 0, visible: true,
          controlCaption:`GP Name`,
          itemType:"data-item", dataItemId:"ccd_GPName", dataItemValue:"",
          dataType:"nvarchar", length:200,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:false,
          validationRules:[this.requiredRule,],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"3", position: 0, visible: true,
          controlCaption:`GP Practice`,
          itemType:"data-item", dataItemId:"ccd_GPPractice", dataItemValue:"",
          dataType:"nvarchar", length:200,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:false,
          validationRules:[this.requiredRule,],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"3", position: 0, visible: true,
          controlCaption:`GP Street Address`,
          itemType:"data-item", dataItemId:"ccd_GPStreetAddress", dataItemValue:"",
          dataType:"nvarchar", length:200,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:false,
          validationRules:[this.requiredRule,],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"3", position: 0, visible: true,
          controlCaption:`GP Town/City`,
          itemType:"data-item", dataItemId:"ccd_GPTownCity", dataItemValue:"",
          dataType:"nvarchar", length:50,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:false,
          validationRules:[this.requiredRule,],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"3", position: 0, visible: true,
          controlCaption:`GP Postcode`,
          itemType:"data-item", dataItemId:"ccd_GPPostcode", dataItemValue:"",
          dataType:"nvarchar", length:50,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:false,
          validationRules:[this.requiredRule,this.postcodeRule,],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"3", position: 0, visible: true,
          controlCaption:`GP Phone Number`,
          itemType:"data-item", dataItemId:"ccd_GPPhoneNo", dataItemValue:"",
          dataType:"nvarchar", length:11,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:false,
          validationRules:[this.requiredRule,this.phoneNumberRule,],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"3", position: 0, visible: true,
          controlCaption:`Have the <b>contact details</b> for your <b>next of kin changed</b> in the last {{3or6Months}}?`,
          itemType:"data-item", dataItemId:"ccd_NextOfKinChanged", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:true,
          lookUpTable:[
            {value:1, text:"No"},
            {value:2, text:"Yes"},
          ],
          lookupIsRequired:true,
          validationRules:[this.requiredRule,],
          controlEnabled:true,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"3", position: 0, visible: true,
          controlCaption:`Next of kin First Name`,
          itemType:"data-item", dataItemId:"ccd_NextOfKinFirstName", dataItemValue:"",
          dataType:"nvarchar", length:50,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:false,
          validationRules:[this.requiredRule,this.nameRule,],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"3", position: 0, visible: true,
          controlCaption:`Next of kin Surname`,
          itemType:"data-item", dataItemId:"ccd_NextOfKinSurname", dataItemValue:"",
          dataType:"nvarchar", length:50,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:false,
          validationRules:[this.requiredRule,this.nameRule,],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"3", position: 0, visible: true,
          controlCaption:`Next of kin Phone Number`,
          itemType:"data-item", dataItemId:"ccd_NextOfKinPhoneNo", dataItemValue:"",
          dataType:"nvarchar", length:11,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:false,
          validationRules:[this.requiredRule,this.phoneNumberRule,],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        },
      ]
    }, tbFrmRecentMedicalProblems:{
      crfTitle: "3-month Questionnaire - Recent medical problems",
      tableName: "tbFrmRecentMedicalProblems",
      timePointDataItem: "rmp_DummyTimePoint",
      dataItems:[
        {
          id:"1",
          itemType:"section-instruction",
          sectionTitle:``,
          position: 0,
          visible: true,
        }, {
          id:"2",
          itemType:"section-instruction",
          sectionTitle:`Recent medical problems`,
          position: 0,
          visible: true,
        }, {
          fgId:"2", position: 0, visible: true,
          controlCaption:`In the last <b>{{3or6Months}}</b>, have you had any <b>major health problems</b>? E.g. been <b>admitted to hospital</b>, had a <b>life-threatening medical event</b>, or had a major <b>disability or illness</b>?`,
          itemType:"data-item", dataItemId:"rmp_NextOfKinChanged", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:true,
          lookUpTable:[
            {value:1, text:"No"},
            {value:2, text:"Yes"},
          ],
          lookupIsRequired:true,
          validationRules:[this.requiredRule,],
          controlEnabled:true,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"2", position: 0, visible: true,
          controlCaption:`Please give <b>details</b> of <b>all recent major health problems</b> in the <b>box</b> below.`,
          itemType:"data-item", dataItemId:"rmp_NextOfKinChangedSpecify", dataItemValue:"",
          dataType:"nvarchar", length:300,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:false,
          validationRules:[this.requiredRule,],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        },
      ]
    }, tbFrmHealthSocialCareResourceUse:{
      crfTitle: "3-month Questionnaire - Section 6: Health and Social Care Resource Use",
      tableName: "tbFrmHealthSocialCareResourceUse",
      timePointDataItem: "hsr_DummyTimePoint",
      dataItems:[
        {
          id:"1",
          itemType:"section-instruction",
          sectionTitle:``,
          position: 0,
          visible: true,
        }, {
          id:"2",
          itemType:"section-instruction",
          sectionTitle:`<p>Please <b>think back</b> over the times that you have <b>used the NHS</b> in the last <b>{{3or6Months}}</b>. If you are unsure about any answers, please write what you <b>remember</b>.</p> <br/><p>This section asks you about any hospital, accident and emergency or nursing home visits you have had.</p> <br/><p><b>Inpatient Care</b></p>`,
          position: 0,
          visible: true,
        }, {
          fgId:"2", position: 0, visible: true,
          controlCaption:`In the last <b>{{3or6Months}}</b>, have you stayed <b>overnight</b> at <b>hospital</b>?`,
          itemType:"data-item", dataItemId:"hsr_StayedOvernightHospital", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:true,
          lookUpTable:[
            {value:1, text:"No"},
            {value:2, text:"Yes"},
          ],
          lookupIsRequired:false,
          validationRules:[],
          controlEnabled:true,
          customError:false,
          customErrorMessage:'',
        }, {
          id:"3",
          itemType:"section-instruction",
          sectionTitle:`<p>Please give the details of each stay below</p><p>Hospital stay 1</p>`,
          pageSplitInMobileMode: [2],
          position: 0,
          visible: true,
        }, {
          fgId:"4", position: 0, visible: true,
          controlCaption:`Number of <b>days</b> in hospital`,
          itemType:"data-item", dataItemId:"ich_NumOfDays__1", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'numeric',
          missingDataExclude:false,
          hasLookUpTable:false,
          validationRules:[this.tinyintRule,],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"4", position: 0, visible: true,
          controlCaption:`Type of <b>ward</b> (e.g. medical ward, respiratory ward)`,
          itemType:"data-item", dataItemId:"ich_TypeOfWard__1", dataItemValue:"",
          dataType:"nvarchar", length:200,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:false,
          validationRules:[],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          id:"4",
          itemType:"section-instruction",
          sectionTitle:`Please give the details of each stay below`,
          position: 0,
          visible: true,
        }, {
          fgId:"6", position: 0, visible: true,
          controlCaption:`Have you had any more <b>overnight</b> stays in hospital in the last <b>{{3or6Months}}</b>?`,
          itemType:"data-item", dataItemId:"hsr_StayedOvernightHospitalContinued__2", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:true,
          lookUpTable:[
            {value:1, text:"No"},
            {value:2, text:"Yes"},
          ],
          lookupIsRequired:true,
          validationRules:[this.requiredRule,],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          id:"5",
          itemType:"section-instruction",
          sectionTitle:`<p>Please give the details of each stay below</p><p>Hospital stay 2</p>`,
          pageSplitInMobileMode: [2],
          position: 0,
          visible: true,
        }, {
          fgId:"8", position: 0, visible: true,
          controlCaption:`Number of <b>days</b> in hospital`,
          itemType:"data-item", dataItemId:"ich_NumOfDays__2", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'numeric',
          missingDataExclude:false,
          hasLookUpTable:false,
          validationRules:[this.tinyintRule,],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"8", position: 0, visible: true,
          controlCaption:`Type of <b>ward</b> (e.g. medical ward, respiratory ward)`,
          itemType:"data-item", dataItemId:"ich_TypeOfWard__2", dataItemValue:"",
          dataType:"nvarchar", length:200,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:false,
          validationRules:[],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          id:"6",
          itemType:"section-instruction",
          sectionTitle:`Please give the details of each stay below`,
          position: 0,
          visible: true,
        }, {
          fgId:"10", position: 0, visible: true,
          controlCaption:`Have you had any more <b>overnight</b> stays in hospital in the last <b>{{3or6Months}}</b>?`,
          itemType:"data-item", dataItemId:"hsr_StayedOvernightHospitalContinued__3", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:true,
          lookUpTable:[
            {value:1, text:"No"},
            {value:2, text:"Yes"},
          ],
          lookupIsRequired:true,
          validationRules:[this.requiredRule,],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          id:"7",
          itemType:"section-instruction",
          sectionTitle:`<p>Please give the details of each stay below</p><p>Hospital stay 3</p>`,
          pageSplitInMobileMode: [2],
          position: 0,
          visible: true,
        }, {
          fgId:"12", position: 0, visible: true,
          controlCaption:`Number of <b>days</b> in hospital`,
          itemType:"data-item", dataItemId:"ich_NumOfDays__3", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'numeric',
          missingDataExclude:false,
          hasLookUpTable:false,
          validationRules:[this.tinyintRule,],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"12", position: 0, visible: true,
          controlCaption:`Type of <b>ward</b> (e.g. medical ward, respiratory ward)`,
          itemType:"data-item", dataItemId:"ich_TypeOfWard__3", dataItemValue:"",
          dataType:"nvarchar", length:200,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:false,
          validationRules:[],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          id:"8",
          itemType:"section-instruction",
          sectionTitle:`Please give the details of each stay below`,
          position: 0,
          visible: true,
        }, {
          fgId:"14", position: 0, visible: true,
          controlCaption:`Have you had any more <b>overnight</b> stays in hospital in the last <b>{{3or6Months}}</b>?`,
          itemType:"data-item", dataItemId:"hsr_StayedOvernightHospitalContinued__4", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:true,
          lookUpTable:[
            {value:1, text:"No"},
            {value:2, text:"Yes"},
          ],
          lookupIsRequired:true,
          validationRules:[this.requiredRule,],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          id:"9",
          itemType:"section-instruction",
          sectionTitle:`<p>Please give the details of each stay below</p><p>Hospital stay 4</p>`,
          pageSplitInMobileMode: [2],
          position: 0,
          visible: true,
        }, {
          fgId:"16", position: 0, visible: true,
          controlCaption:`Number of <b>days</b> in hospital`,
          itemType:"data-item", dataItemId:"ich_NumOfDays__4", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'numeric',
          missingDataExclude:false,
          hasLookUpTable:false,
          validationRules:[this.tinyintRule,],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"16", position: 0, visible: true,
          controlCaption:`Type of <b>ward</b> (e.g. medical ward, respiratory ward)`,
          itemType:"data-item", dataItemId:"ich_TypeOfWard__4", dataItemValue:"",
          dataType:"nvarchar", length:200,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:false,
          validationRules:[],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          id:"10",
          itemType:"section-instruction",
          sectionTitle:`Please give the details of each stay below`,
          position: 0,
          visible: true,
        }, {
          fgId:"18", position: 0, visible: true,
          controlCaption:`Have you had any more <b>overnight</b> stays in hospital in the last <b>{{3or6Months}}</b>?`,
          itemType:"data-item", dataItemId:"hsr_StayedOvernightHospitalContinued__5", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:true,
          lookUpTable:[
            {value:1, text:"No"},
            {value:2, text:"Yes"},
          ],
          lookupIsRequired:true,
          validationRules:[this.requiredRule,],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          id:"11",
          itemType:"section-instruction",
          sectionTitle:`<p>Please give the details of each stay below</p><p>Hospital stay 5</p>`,
          pageSplitInMobileMode: [2],
          position: 0,
          visible: true,
        }, {
          fgId:"20", position: 0, visible: true,
          controlCaption:`Number of <b>days</b> in hospital`,
          itemType:"data-item", dataItemId:"ich_NumOfDays__5", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'numeric',
          missingDataExclude:false,
          hasLookUpTable:false,
          validationRules:[this.tinyintRule,],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"20", position: 0, visible: true,
          controlCaption:`Type of <b>ward</b> (e.g. medical ward, respiratory ward)`,
          itemType:"data-item", dataItemId:"ich_TypeOfWard__5", dataItemValue:"",
          dataType:"nvarchar", length:200,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:false,
          validationRules:[],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          id:"12",
          itemType:"section-instruction",
          sectionTitle:`Please give the details of each stay below`,
          position: 0,
          visible: true,
        }, {
          fgId:"22", position: 0, visible: true,
          controlCaption:`Have you had any more <b>overnight</b> stays in hospital in the last <b>{{3or6Months}}</b>?`,
          itemType:"data-item", dataItemId:"hsr_StayedOvernightHospitalContinued__6", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:true,
          lookUpTable:[
            {value:1, text:"No"},
            {value:2, text:"Yes"},
          ],
          lookupIsRequired:true,
          validationRules:[this.requiredRule,],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          id:"13",
          itemType:"section-instruction",
          sectionTitle:`<p>Please give the details of each stay below</p><p>Hospital stay 6</p>`,
          pageSplitInMobileMode: [2],
          position: 0,
          visible: true,
        }, {
          fgId:"24", position: 0, visible: true,
          controlCaption:`Number of <b>days</b> in hospital`,
          itemType:"data-item", dataItemId:"ich_NumOfDays__6", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'numeric',
          missingDataExclude:false,
          hasLookUpTable:false,
          validationRules:[this.tinyintRule,],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"24", position: 0, visible: true,
          controlCaption:`Type of <b>ward</b> (e.g. medical ward, respiratory ward)`,
          itemType:"data-item", dataItemId:"ich_TypeOfWard__6", dataItemValue:"",
          dataType:"nvarchar", length:200,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:false,
          validationRules:[],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          id:"14",
          itemType:"section-instruction",
          sectionTitle:`Please give the details of each stay below`,
          position: 0,
          visible: true,
        }, {
          fgId:"26", position: 0, visible: true,
          controlCaption:`Have you had any more <b>overnight</b> stays in hospital in the last <b>{{3or6Months}}</b>?`,
          itemType:"data-item", dataItemId:"hsr_StayedOvernightHospitalContinued__7", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:true,
          lookUpTable:[
            {value:1, text:"No"},
            {value:2, text:"Yes"},
          ],
          lookupIsRequired:true,
          validationRules:[this.requiredRule,],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          id:"15",
          itemType:"section-instruction",
          sectionTitle:`<p>Please give the details of each stay below</p><p>Hospital stay 7</p>`,
          pageSplitInMobileMode: [2],
          position: 0,
          visible: true,
        }, {
          fgId:"28", position: 0, visible: true,
          controlCaption:`Number of <b>days</b> in hospital`,
          itemType:"data-item", dataItemId:"ich_NumOfDays__7", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'numeric',
          missingDataExclude:false,
          hasLookUpTable:false,
          validationRules:[this.tinyintRule,],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"28", position: 0, visible: true,
          controlCaption:`Type of <b>ward</b> (e.g. medical ward, respiratory ward)`,
          itemType:"data-item", dataItemId:"ich_TypeOfWard__7", dataItemValue:"",
          dataType:"nvarchar", length:200,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:false,
          validationRules:[],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          id:"16",
          itemType:"section-instruction",
          sectionTitle:`Please give the details of each stay below`,
          position: 0,
          visible: true,
        }, {
          fgId:"30", position: 0, visible: true,
          controlCaption:`Have you had any more <b>overnight</b> stays in hospital in the last <b>{{3or6Months}}</b>?`,
          itemType:"data-item", dataItemId:"hsr_StayedOvernightHospitalContinued__8", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:true,
          lookUpTable:[
            {value:1, text:"No"},
            {value:2, text:"Yes"},
          ],
          lookupIsRequired:true,
          validationRules:[this.requiredRule,],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          id:"17",
          itemType:"section-instruction",
          sectionTitle:`<p>Please give the details of each stay below</p><p>Hospital stay 8</p>`,
          pageSplitInMobileMode: [2],
          position: 0,
          visible: true,
        }, {
          fgId:"32", position: 0, visible: true,
          controlCaption:`Number of <b>days</b> in hospital`,
          itemType:"data-item", dataItemId:"ich_NumOfDays__8", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'numeric',
          missingDataExclude:false,
          hasLookUpTable:false,
          validationRules:[this.tinyintRule,],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"32", position: 0, visible: true,
          controlCaption:`Type of <b>ward</b> (e.g. medical ward, respiratory ward)`,
          itemType:"data-item", dataItemId:"ich_TypeOfWard__8", dataItemValue:"",
          dataType:"nvarchar", length:200,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:false,
          validationRules:[],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          id:"18",
          itemType:"section-instruction",
          sectionTitle:`Please give the details of each stay below`,
          position: 0,
          visible: true,
        }, {
          fgId:"34", position: 0, visible: true,
          controlCaption:`Have you had any more <b>overnight</b> stays in hospital in the last <b>{{3or6Months}}</b>?`,
          itemType:"data-item", dataItemId:"hsr_StayedOvernightHospitalContinued__9", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:true,
          lookUpTable:[
            {value:1, text:"No"},
            {value:2, text:"Yes"},
          ],
          lookupIsRequired:true,
          validationRules:[this.requiredRule,],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          id:"19",
          itemType:"section-instruction",
          sectionTitle:`<p>Please give the details of each stay below</p><p>Hospital stay 9</p>`,
          pageSplitInMobileMode: [2],
          position: 0,
          visible: true,
        }, {
          fgId:"36", position: 0, visible: true,
          controlCaption:`Number of <b>days</b> in hospital`,
          itemType:"data-item", dataItemId:"ich_NumOfDays__9", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'numeric',
          missingDataExclude:false,
          hasLookUpTable:false,
          validationRules:[this.tinyintRule,],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"36", position: 0, visible: true,
          controlCaption:`Type of <b>ward</b> (e.g. medical ward, respiratory ward)`,
          itemType:"data-item", dataItemId:"ich_TypeOfWard__9", dataItemValue:"",
          dataType:"nvarchar", length:200,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:false,
          validationRules:[],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          id:"20",
          itemType:"section-instruction",
          sectionTitle:`Please give the details of each stay below`,
          position: 0,
          visible: true,
        }, {
          fgId:"38", position: 0, visible: true,
          controlCaption:`Have you had any more <b>overnight</b> stays in hospital in the last <b>{{3or6Months}}</b>?`,
          itemType:"data-item", dataItemId:"hsr_StayedOvernightHospitalContinued__10", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:true,
          lookUpTable:[
            {value:1, text:"No"},
            {value:2, text:"Yes"},
          ],
          lookupIsRequired:true,
          validationRules:[this.requiredRule,],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          id:"21",
          itemType:"section-instruction",
          sectionTitle:`<p>Please give the details of each stay below</p><p>Hospital stay 10</p>`,
          pageSplitInMobileMode: [2],
          position: 0,
          visible: true,
        }, {
          fgId:"40", position: 0, visible: true,
          controlCaption:`Number of <b>days</b> in hospital`,
          itemType:"data-item", dataItemId:"ich_NumOfDays__10", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'numeric',
          missingDataExclude:false,
          hasLookUpTable:false,
          validationRules:[this.tinyintRule,],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"40", position: 0, visible: true,
          controlCaption:`Type of <b>ward</b> (e.g. medical ward, respiratory ward)`,
          itemType:"data-item", dataItemId:"ich_TypeOfWard__10", dataItemValue:"",
          dataType:"nvarchar", length:200,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:false,
          validationRules:[],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          id:"22",
          itemType:"section-instruction",
          sectionTitle:``,
          position: 0,
          visible: true,
        }, {
          id:"23",
          itemType:"section-instruction",
          sectionTitle:`Outpatient Care`,
          position: 0,
          visible: true,
        }, {
          fgId:"43", position: 0, visible: true,
          controlCaption:`In the last <b>{{3or6Months}}</b>, have you made any <b>visits</b> to <b>hospital</b> as an <b>outpatient</b>?`,
          itemType:"data-item", dataItemId:"hsr_VisitHospitalOutpatient", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:true,
          lookUpTable:[
            {value:1, text:"No"},
            {value:2, text:"Yes"},
          ],
          lookupIsRequired:false,
          validationRules:[],
          controlEnabled:true,
          customError:false,
          customErrorMessage:'',
        }, {
          id:"24",
          itemType:"section-instruction",
          sectionTitle:`Please give the details of visit 1`,
          position: 0,
          visible: true,
        }, {
          fgId:"45", position: 0, visible: true,
          controlCaption:`<b>Reason(s)</b> for outpatient <b>visit</b> (e.g. cardiology appointment)`,
          itemType:"data-item", dataItemId:"ohv_Reason__1", dataItemValue:"",
          dataType:"nvarchar", length:1000,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:false,
          validationRules:[],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          id:"25",
          itemType:"section-instruction",
          sectionTitle:`Please give the details of each visit below`,
          position: 0,
          visible: true,
        }, {
          fgId:"47", position: 0, visible: true,
          controlCaption:`Have you made any more <b>visits</b> to <b>hospital</b> as an <b>outpatient</b> in the last <b>{{3or6Months}}</b>?`,
          itemType:"data-item", dataItemId:"hsr_VisitHospitalOutpatientContinued__2", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:true,
          lookUpTable:[
            {value:1, text:"No"},
            {value:2, text:"Yes"},
          ],
          lookupIsRequired:true,
          validationRules:[this.requiredRule,],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          id:"26",
          itemType:"section-instruction",
          sectionTitle:`Please give the details of visit 2`,
          position: 0,
          visible: true,
        }, {
          fgId:"49", position: 0, visible: true,
          controlCaption:`<b>Reason(s)</b> for outpatient <b>visit</b> (e.g. cardiology appointment)`,
          itemType:"data-item", dataItemId:"ohv_Reason__2", dataItemValue:"",
          dataType:"nvarchar", length:1000,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:false,
          validationRules:[],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          id:"27",
          itemType:"section-instruction",
          sectionTitle:`Please give the details of each visit below`,
          position: 0,
          visible: true,
        }, {
          fgId:"51", position: 0, visible: true,
          controlCaption:`Have you made any more <b>visits</b> to <b>hospital</b> as an <b>outpatient</b> in the last <b>{{3or6Months}}</b>?`,
          itemType:"data-item", dataItemId:"hsr_VisitHospitalOutpatientContinued__3", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:true,
          lookUpTable:[
            {value:1, text:"No"},
            {value:2, text:"Yes"},
          ],
          lookupIsRequired:true,
          validationRules:[this.requiredRule,],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          id:"28",
          itemType:"section-instruction",
          sectionTitle:`Please give the details of visit 3`,
          position: 0,
          visible: true,
        }, {
          fgId:"53", position: 0, visible: true,
          controlCaption:`<b>Reason(s)</b> for outpatient <b>visit</b> (e.g. cardiology appointment)`,
          itemType:"data-item", dataItemId:"ohv_Reason__3", dataItemValue:"",
          dataType:"nvarchar", length:1000,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:false,
          validationRules:[],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          id:"29",
          itemType:"section-instruction",
          sectionTitle:`Please give the details of each visit below`,
          position: 0,
          visible: true,
        }, {
          fgId:"55", position: 0, visible: true,
          controlCaption:`Have you made any more <b>visits</b> to <b>hospital</b> as an <b>outpatient</b> in the last <b>{{3or6Months}}</b>?`,
          itemType:"data-item", dataItemId:"hsr_VisitHospitalOutpatientContinued__4", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:true,
          lookUpTable:[
            {value:1, text:"No"},
            {value:2, text:"Yes"},
          ],
          lookupIsRequired:true,
          validationRules:[this.requiredRule,],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          id:"30",
          itemType:"section-instruction",
          sectionTitle:`Please give the details of visit 4`,
          position: 0,
          visible: true,
        }, {
          fgId:"57", position: 0, visible: true,
          controlCaption:`<b>Reason(s)</b> for outpatient <b>visit</b> (e.g. cardiology appointment)`,
          itemType:"data-item", dataItemId:"ohv_Reason__4", dataItemValue:"",
          dataType:"nvarchar", length:1000,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:false,
          validationRules:[],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          id:"31",
          itemType:"section-instruction",
          sectionTitle:`Please give the details of each visit below`,
          position: 0,
          visible: true,
        }, {
          fgId:"59", position: 0, visible: true,
          controlCaption:`Have you made any more <b>visits</b> to <b>hospital</b> as an <b>outpatient</b> in the last <b>{{3or6Months}}</b>?`,
          itemType:"data-item", dataItemId:"hsr_VisitHospitalOutpatientContinued__5", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:true,
          lookUpTable:[
            {value:1, text:"No"},
            {value:2, text:"Yes"},
          ],
          lookupIsRequired:true,
          validationRules:[this.requiredRule,],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          id:"32",
          itemType:"section-instruction",
          sectionTitle:`Please give the details of visit 5`,
          position: 0,
          visible: true,
        }, {
          fgId:"61", position: 0, visible: true,
          controlCaption:`<b>Reason(s)</b> for outpatient <b>visit</b> (e.g. cardiology appointment)`,
          itemType:"data-item", dataItemId:"ohv_Reason__5", dataItemValue:"",
          dataType:"nvarchar", length:1000,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:false,
          validationRules:[],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          id:"33",
          itemType:"section-instruction",
          sectionTitle:`Please give the details of each visit below`,
          position: 0,
          visible: true,
        }, {
          fgId:"63", position: 0, visible: true,
          controlCaption:`Have you made any more <b>visits</b> to <b>hospital</b> as an <b>outpatient</b> in the last <b>{{3or6Months}}</b>?`,
          itemType:"data-item", dataItemId:"hsr_VisitHospitalOutpatientContinued__6", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:true,
          lookUpTable:[
            {value:1, text:"No"},
            {value:2, text:"Yes"},
          ],
          lookupIsRequired:true,
          validationRules:[this.requiredRule,],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          id:"34",
          itemType:"section-instruction",
          sectionTitle:`Please give the details of visit 6`,
          position: 0,
          visible: true,
        }, {
          fgId:"65", position: 0, visible: true,
          controlCaption:`<b>Reason(s)</b> for outpatient <b>visit</b> (e.g. cardiology appointment)`,
          itemType:"data-item", dataItemId:"ohv_Reason__6", dataItemValue:"",
          dataType:"nvarchar", length:1000,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:false,
          validationRules:[],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          id:"35",
          itemType:"section-instruction",
          sectionTitle:`Please give the details of each visit below`,
          position: 0,
          visible: true,
        }, {
          fgId:"67", position: 0, visible: true,
          controlCaption:`Have you made any more <b>visits</b> to <b>hospital</b> as an <b>outpatient</b> in the last <b>{{3or6Months}}</b>?`,
          itemType:"data-item", dataItemId:"hsr_VisitHospitalOutpatientContinued__7", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:true,
          lookUpTable:[
            {value:1, text:"No"},
            {value:2, text:"Yes"},
          ],
          lookupIsRequired:true,
          validationRules:[this.requiredRule,],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          id:"36",
          itemType:"section-instruction",
          sectionTitle:`Please give the details of visit 7`,
          position: 0,
          visible: true,
        }, {
          fgId:"69", position: 0, visible: true,
          controlCaption:`<b>Reason(s)</b> for outpatient <b>visit</b> (e.g. cardiology appointment)`,
          itemType:"data-item", dataItemId:"ohv_Reason__7", dataItemValue:"",
          dataType:"nvarchar", length:1000,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:false,
          validationRules:[],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          id:"37",
          itemType:"section-instruction",
          sectionTitle:`Please give the details of each visit below`,
          position: 0,
          visible: true,
        }, {
          fgId:"71", position: 0, visible: true,
          controlCaption:`Have you made any more <b>visits</b> to <b>hospital</b> as an <b>outpatient</b> in the last <b>{{3or6Months}}</b>?`,
          itemType:"data-item", dataItemId:"hsr_VisitHospitalOutpatientContinued__8", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:true,
          lookUpTable:[
            {value:1, text:"No"},
            {value:2, text:"Yes"},
          ],
          lookupIsRequired:true,
          validationRules:[this.requiredRule,],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          id:"38",
          itemType:"section-instruction",
          sectionTitle:`Please give the details of visit 8`,
          position: 0,
          visible: true,
        }, {
          fgId:"73", position: 0, visible: true,
          controlCaption:`<b>Reason(s)</b> for outpatient <b>visit</b> (e.g. cardiology appointment)`,
          itemType:"data-item", dataItemId:"ohv_Reason__8", dataItemValue:"",
          dataType:"nvarchar", length:1000,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:false,
          validationRules:[],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          id:"39",
          itemType:"section-instruction",
          sectionTitle:`Please give the details of each visit below`,
          position: 0,
          visible: true,
        }, {
          fgId:"75", position: 0, visible: true,
          controlCaption:`Have you made any more <b>visits</b> to <b>hospital</b> as an <b>outpatient</b> in the last <b>{{3or6Months}}</b>?`,
          itemType:"data-item", dataItemId:"hsr_VisitHospitalOutpatientContinued__9", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:true,
          lookUpTable:[
            {value:1, text:"No"},
            {value:2, text:"Yes"},
          ],
          lookupIsRequired:true,
          validationRules:[this.requiredRule,],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          id:"40",
          itemType:"section-instruction",
          sectionTitle:`Please give the details of visit 9`,
          position: 0,
          visible: true,
        }, {
          fgId:"77", position: 0, visible: true,
          controlCaption:`<b>Reason(s)</b> for outpatient <b>visit</b> (e.g. cardiology appointment)`,
          itemType:"data-item", dataItemId:"ohv_Reason__9", dataItemValue:"",
          dataType:"nvarchar", length:1000,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:false,
          validationRules:[],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          id:"41",
          itemType:"section-instruction",
          sectionTitle:`Please give the details of each visit below`,
          position: 0,
          visible: true,
        }, {
          fgId:"79", position: 0, visible: true,
          controlCaption:`Have you made any more <b>visits</b> to <b>hospital</b> as an <b>outpatient</b> in the last <b>{{3or6Months}}</b>?`,
          itemType:"data-item", dataItemId:"hsr_VisitHospitalOutpatientContinued__10", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:true,
          lookUpTable:[
            {value:1, text:"No"},
            {value:2, text:"Yes"},
          ],
          lookupIsRequired:true,
          validationRules:[this.requiredRule,],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          id:"42",
          itemType:"section-instruction",
          sectionTitle:`Please give the details of visit 10`,
          position: 0,
          visible: true,
        }, {
          fgId:"81", position: 0, visible: true,
          controlCaption:`<b>Reason(s)</b> for outpatient <b>visit</b> (e.g. cardiology appointment)`,
          itemType:"data-item", dataItemId:"ohv_Reason__10", dataItemValue:"",
          dataType:"nvarchar", length:1000,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:false,
          validationRules:[],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          id:"43",
          itemType:"section-instruction",
          sectionTitle:``,
          position: 0,
          visible: true,
        }, {
          id:"44",
          itemType:"section-instruction",
          sectionTitle:`Accident & Emergency (A&E)`,
          position: 0,
          visible: true,
        }, {
          fgId:"84", position: 0, visible: true,
          controlCaption:`In the last <b>{{3or6Months}}</b>, have you gone to <b>Accident & Emergency</b> (A&E)?`,
          itemType:"data-item", dataItemId:"hsr_ToAE", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:true,
          lookUpTable:[
            {value:1, text:"No"},
            {value:2, text:"Yes"},
          ],
          lookupIsRequired:false,
          validationRules:[],
          controlEnabled:true,
          customError:false,
          customErrorMessage:'',
        }, {
          id:"45",
          itemType:"section-instruction",
          sectionTitle:`Details of A&E visit 1`,
          position: 0,
          visible: true,
        }, {
          fgId:"86", position: 0, visible: true,
          controlCaption:`<b>Reason(s)</b> for A&E <b>visit</b>`,
          itemType:"data-item", dataItemId:"aev_Reason__1", dataItemValue:"",
          dataType:"nvarchar", length:200,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:false,
          validationRules:[],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          id:"46",
          itemType:"section-instruction",
          sectionTitle:`Please give the details of each A&E visit below`,
          position: 0,
          visible: true,
        }, {
          fgId:"88", position: 0, visible: true,
          controlCaption:`Have you made any more visits to <b>Accident & Emergency</b> (A&E) in the last <b>{{3or6Months}}</b>?`,
          itemType:"data-item", dataItemId:"hsr_ToAEContinued__2", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:true,
          lookUpTable:[
            {value:1, text:"No"},
            {value:2, text:"Yes"},
          ],
          lookupIsRequired:true,
          validationRules:[this.requiredRule,],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          id:"47",
          itemType:"section-instruction",
          sectionTitle:`Details of A&E visit 2`,
          position: 0,
          visible: true,
        }, {
          fgId:"90", position: 0, visible: true,
          controlCaption:`<b>Reason(s)</b> for A&E <b>visit</b>`,
          itemType:"data-item", dataItemId:"aev_Reason__2", dataItemValue:"",
          dataType:"nvarchar", length:200,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:false,
          validationRules:[],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          id:"48",
          itemType:"section-instruction",
          sectionTitle:`Please give the details of each A&E visit below`,
          position: 0,
          visible: true,
        }, {
          fgId:"92", position: 0, visible: true,
          controlCaption:`Have you made any more visits to <b>Accident & Emergency</b> (A&E) in the last <b>{{3or6Months}}</b>?`,
          itemType:"data-item", dataItemId:"hsr_ToAEContinued__3", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:true,
          lookUpTable:[
            {value:1, text:"No"},
            {value:2, text:"Yes"},
          ],
          lookupIsRequired:true,
          validationRules:[this.requiredRule,],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          id:"49",
          itemType:"section-instruction",
          sectionTitle:`Details of A&E visit 3`,
          position: 0,
          visible: true,
        }, {
          fgId:"94", position: 0, visible: true,
          controlCaption:`<b>Reason(s)</b> for A&E <b>visit</b>`,
          itemType:"data-item", dataItemId:"aev_Reason__3", dataItemValue:"",
          dataType:"nvarchar", length:200,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:false,
          validationRules:[],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          id:"50",
          itemType:"section-instruction",
          sectionTitle:`Please give the details of each A&E visit below`,
          position: 0,
          visible: true,
        }, {
          fgId:"96", position: 0, visible: true,
          controlCaption:`Have you made any more visits to <b>Accident & Emergency</b> (A&E) in the last <b>{{3or6Months}}</b>?`,
          itemType:"data-item", dataItemId:"hsr_ToAEContinued__4", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:true,
          lookUpTable:[
            {value:1, text:"No"},
            {value:2, text:"Yes"},
          ],
          lookupIsRequired:true,
          validationRules:[this.requiredRule,],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          id:"51",
          itemType:"section-instruction",
          sectionTitle:`Details of A&E visit 4`,
          position: 0,
          visible: true,
        }, {
          fgId:"98", position: 0, visible: true,
          controlCaption:`<b>Reason(s)</b> for A&E <b>visit</b>`,
          itemType:"data-item", dataItemId:"aev_Reason__4", dataItemValue:"",
          dataType:"nvarchar", length:200,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:false,
          validationRules:[],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          id:"52",
          itemType:"section-instruction",
          sectionTitle:`Please give the details of each A&E visit below`,
          position: 0,
          visible: true,
        }, {
          fgId:"100", position: 0, visible: true,
          controlCaption:`Have you made any more visits to <b>Accident & Emergency</b> (A&E) in the last <b>{{3or6Months}}</b>?`,
          itemType:"data-item", dataItemId:"hsr_ToAEContinued__5", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:true,
          lookUpTable:[
            {value:1, text:"No"},
            {value:2, text:"Yes"},
          ],
          lookupIsRequired:true,
          validationRules:[this.requiredRule,],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          id:"53",
          itemType:"section-instruction",
          sectionTitle:`Details of A&E visit 5`,
          position: 0,
          visible: true,
        }, {
          fgId:"102", position: 0, visible: true,
          controlCaption:`<b>Reason(s)</b> for A&E <b>visit</b>`,
          itemType:"data-item", dataItemId:"aev_Reason__5", dataItemValue:"",
          dataType:"nvarchar", length:200,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:false,
          validationRules:[],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          id:"54",
          itemType:"section-instruction",
          sectionTitle:`Please give the details of each A&E visit below`,
          position: 0,
          visible: true,
        }, {
          fgId:"104", position: 0, visible: true,
          controlCaption:`Have you made any more visits to <b>Accident & Emergency</b> (A&E) in the last <b>{{3or6Months}}</b>?`,
          itemType:"data-item", dataItemId:"hsr_ToAEContinued__6", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:true,
          lookUpTable:[
            {value:1, text:"No"},
            {value:2, text:"Yes"},
          ],
          lookupIsRequired:true,
          validationRules:[this.requiredRule,],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          id:"55",
          itemType:"section-instruction",
          sectionTitle:`Details of A&E visit 6`,
          position: 0,
          visible: true,
        }, {
          fgId:"106", position: 0, visible: true,
          controlCaption:`<b>Reason(s)</b> for A&E <b>visit</b>`,
          itemType:"data-item", dataItemId:"aev_Reason__6", dataItemValue:"",
          dataType:"nvarchar", length:200,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:false,
          validationRules:[],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          id:"56",
          itemType:"section-instruction",
          sectionTitle:`Please give the details of each A&E visit below`,
          position: 0,
          visible: true,
        }, {
          fgId:"108", position: 0, visible: true,
          controlCaption:`Have you made any more visits to <b>Accident & Emergency</b> (A&E) in the last <b>{{3or6Months}}</b>?`,
          itemType:"data-item", dataItemId:"hsr_ToAEContinued__7", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:true,
          lookUpTable:[
            {value:1, text:"No"},
            {value:2, text:"Yes"},
          ],
          lookupIsRequired:true,
          validationRules:[this.requiredRule,],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          id:"57",
          itemType:"section-instruction",
          sectionTitle:`Details of A&E visit 7`,
          position: 0,
          visible: true,
        }, {
          fgId:"110", position: 0, visible: true,
          controlCaption:`<b>Reason(s)</b> for A&E <b>visit</b>`,
          itemType:"data-item", dataItemId:"aev_Reason__7", dataItemValue:"",
          dataType:"nvarchar", length:200,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:false,
          validationRules:[],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          id:"58",
          itemType:"section-instruction",
          sectionTitle:`Please give the details of each A&E visit below`,
          position: 0,
          visible: true,
        }, {
          fgId:"112", position: 0, visible: true,
          controlCaption:`Have you made any more visits to <b>Accident & Emergency</b> (A&E) in the last <b>{{3or6Months}}</b>?`,
          itemType:"data-item", dataItemId:"hsr_ToAEContinued__8", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:true,
          lookUpTable:[
            {value:1, text:"No"},
            {value:2, text:"Yes"},
          ],
          lookupIsRequired:true,
          validationRules:[this.requiredRule,],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          id:"59",
          itemType:"section-instruction",
          sectionTitle:`Details of A&E visit 8`,
          position: 0,
          visible: true,
        }, {
          fgId:"114", position: 0, visible: true,
          controlCaption:`<b>Reason(s)</b> for A&E <b>visit</b>`,
          itemType:"data-item", dataItemId:"aev_Reason__8", dataItemValue:"",
          dataType:"nvarchar", length:200,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:false,
          validationRules:[],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          id:"60",
          itemType:"section-instruction",
          sectionTitle:`Please give the details of each A&E visit below`,
          position: 0,
          visible: true,
        }, {
          fgId:"116", position: 0, visible: true,
          controlCaption:`Have you made any more visits to <b>Accident & Emergency</b> (A&E) in the last <b>{{3or6Months}}</b>?`,
          itemType:"data-item", dataItemId:"hsr_ToAEContinued__9", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:true,
          lookUpTable:[
            {value:1, text:"No"},
            {value:2, text:"Yes"},
          ],
          lookupIsRequired:true,
          validationRules:[this.requiredRule,],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          id:"61",
          itemType:"section-instruction",
          sectionTitle:`Details of A&E visit 9`,
          position: 0,
          visible: true,
        }, {
          fgId:"118", position: 0, visible: true,
          controlCaption:`<b>Reason(s)</b> for A&E <b>visit</b>`,
          itemType:"data-item", dataItemId:"aev_Reason__9", dataItemValue:"",
          dataType:"nvarchar", length:200,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:false,
          validationRules:[],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          id:"62",
          itemType:"section-instruction",
          sectionTitle:`Please give the details of each A&E visit below`,
          position: 0,
          visible: true,
        }, {
          fgId:"120", position: 0, visible: true,
          controlCaption:`Have you made any more visits to <b>Accident & Emergency</b> (A&E) in the last <b>{{3or6Months}}</b>?`,
          itemType:"data-item", dataItemId:"hsr_ToAEContinued__10", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:true,
          lookUpTable:[
            {value:1, text:"No"},
            {value:2, text:"Yes"},
          ],
          lookupIsRequired:true,
          validationRules:[this.requiredRule,],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          id:"63",
          itemType:"section-instruction",
          sectionTitle:`Details of A&E visit 10`,
          position: 0,
          visible: true,
        }, {
          fgId:"122", position: 0, visible: true,
          controlCaption:`<b>Reason(s)</b> for A&E <b>visit</b>`,
          itemType:"data-item", dataItemId:"aev_Reason__10", dataItemValue:"",
          dataType:"nvarchar", length:200,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:false,
          validationRules:[],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          id:"64",
          itemType:"section-instruction",
          sectionTitle:``,
          position: 0,
          visible: true,
        }, {
          id:"65",
          itemType:"section-instruction",
          sectionTitle:`Nursing Home Care`,
          position: 0,
          visible: true,
        }, {
          fgId:"125", position: 0, visible: true,
          controlCaption:`In the last <b>{{3or6Months}}</b>, have you made any <b>day care visits</b> (as a patient), or have you <b>stayed overnight</b> at a <b>publicly funded nursing care home</b>?`,
          itemType:"data-item", dataItemId:"hsr_NursingHomeCareDayCareVisit", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:true,
          lookUpTable:[
            {value:1, text:"No"},
            {value:2, text:"Yes"},
          ],
          lookupIsRequired:false,
          validationRules:[],
          controlEnabled:true,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"125", position: 0, visible: true,
          controlCaption:`Nursing care home (stayed overnight) - number of <b>days</b> admitted`,
          itemType:"data-item", dataItemId:"hsr_NursingHomeCareDaysAdmitted", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'numeric',
          missingDataExclude:false,
          hasLookUpTable:false,
          validationRules:[this.tinyintRule,],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"125", position: 0, visible: true,
          controlCaption:`Nursing care home (Day care) - number of <b>visits</b>`,
          itemType:"data-item", dataItemId:"hsr_NursingHomeCareNumOfVisits", dataItemValue:"",
          dataType:"int", length:false,
          prefix:'', suffix:'',
          inputmode:'numeric',
          missingDataExclude:false,
          hasLookUpTable:false,
          validationRules:[this.intRule,(v) => this.numberRangeRule(v,0,9999),],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          id:"66",
          itemType:"section-instruction",
          sectionTitle:`This section asks you about care you received at <b>home</b> or your <b>GP surgery</b>`,
          position: 0,
          visible: true,
        }, {
          fgId:"126", position: 0, visible: true,
          controlCaption:`In the last <b>{{3or6Months}}</b>, have you seen any <b>health professionals outside</b> of <b>hospital</b>?`,
          itemType:"data-item", dataItemId:"hsr_SeenHealthProfessionals", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:true,
          lookUpTable:[
            {value:1, text:"No"},
            {value:2, text:"Yes"},
          ],
          lookupIsRequired:false,
          validationRules:[],
          controlEnabled:true,
          customError:false,
          customErrorMessage:'',
        }, {
          id:"67",
          itemType:"section-instruction",
          sectionTitle:`<p>Please tell us each professional you have seen and how often</p> <p><b>Type</b> of <b>health professional</b> you have seen/contacted over the last {{3or6Months}}</p>`,
          pageSplitInMobileMode: [3,3,3,3,3,3,3,3,3,3,3,3,1],
          position: 0,
          visible: true,
        }, {
          fgId:"127", position: 0, visible: true,
          controlCaption:`GP Visits in surgery`,
          itemType:"data-item", dataItemId:"hsr_GPSurgeryVisits", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:true,
          lookUpTable:[
            {value:1, text:"No"},
            {value:2, text:"Yes"},
          ],
          lookupIsRequired:false,
          validationRules:[],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"127", position: 0, visible: true,
          controlCaption:`Number of <b>visits</b>`,
          itemType:"data-item", dataItemId:"hsr_GPSurgeryVisitsNumOfVisits", dataItemValue:"",
          dataType:"int", length:false,
          prefix:'', suffix:'',
          inputmode:'numeric',
          missingDataExclude:false,
          hasLookUpTable:false,
          validationRules:[this.intRule,(v) => this.numberRangeRule(v,0,9999),],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"127", position: 0, visible: true,
          controlCaption:`Average <b>time (minutes)</b> spent per <b>visit</b>`,
          itemType:"data-item", dataItemId:"hsr_GPSurgeryVisitsAverageTimeSpent", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'numeric',
          missingDataExclude:false,
          hasLookUpTable:false,
          validationRules:[this.tinyintRule,],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"127", position: 0, visible: true,
          controlCaption:`GP home visits`,
          itemType:"data-item", dataItemId:"hsr_GPHomeVisits", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:true,
          lookUpTable:[
            {value:1, text:"No"},
            {value:2, text:"Yes"},
          ],
          lookupIsRequired:false,
          validationRules:[],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"127", position: 0, visible: true,
          controlCaption:`Number of <b>visits</b>`,
          itemType:"data-item", dataItemId:"hsr_GPHomeVisitsNumOfVisits", dataItemValue:"",
          dataType:"int", length:false,
          prefix:'', suffix:'',
          inputmode:'numeric',
          missingDataExclude:false,
          hasLookUpTable:false,
          validationRules:[this.intRule,(v) => this.numberRangeRule(v,0,9999),],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"127", position: 0, visible: true,
          controlCaption:`Average <b>time (minutes)</b> spent per <b>visit</b>`,
          itemType:"data-item", dataItemId:"hsr_GPHomeVisitsAverageTimeSpent", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'numeric',
          missingDataExclude:false,
          hasLookUpTable:false,
          validationRules:[this.tinyintRule,],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"127", position: 0, visible: true,
          controlCaption:`GP telephone contacts`,
          itemType:"data-item", dataItemId:"hsr_GPTelContacts", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:true,
          lookUpTable:[
            {value:1, text:"No"},
            {value:2, text:"Yes"},
          ],
          lookupIsRequired:false,
          validationRules:[],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"127", position: 0, visible: true,
          controlCaption:`Number of <b>visits</b>`,
          itemType:"data-item", dataItemId:"hsr_GPTelContactsNumOfVisits", dataItemValue:"",
          dataType:"int", length:false,
          prefix:'', suffix:'',
          inputmode:'numeric',
          missingDataExclude:false,
          hasLookUpTable:false,
          validationRules:[this.intRule,(v) => this.numberRangeRule(v,0,9999),],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"127", position: 0, visible: true,
          controlCaption:`Average <b>time (minutes)</b> spent per <b>visit</b>`,
          itemType:"data-item", dataItemId:"hsr_GPTelContactsAverageTimeSpent", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'numeric',
          missingDataExclude:false,
          hasLookUpTable:false,
          validationRules:[this.tinyintRule,],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"127", position: 0, visible: true,
          controlCaption:`GP video consultation`,
          itemType:"data-item", dataItemId:"hsr_GPVideoConsultation", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:true,
          lookUpTable:[
            {value:1, text:"No"},
            {value:2, text:"Yes"},
          ],
          lookupIsRequired:false,
          validationRules:[],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"127", position: 0, visible: true,
          controlCaption:`Number of <b>visits</b>`,
          itemType:"data-item", dataItemId:"hsr_GPVideoConsultationNumOfVisits", dataItemValue:"",
          dataType:"int", length:false,
          prefix:'', suffix:'',
          inputmode:'numeric',
          missingDataExclude:false,
          hasLookUpTable:false,
          validationRules:[this.intRule,(v) => this.numberRangeRule(v,0,9999),],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"127", position: 0, visible: true,
          controlCaption:`Average <b>time (minutes)</b> spent per <b>visit</b>`,
          itemType:"data-item", dataItemId:"hsr_GPVideoConsultationAverageTimeSpent", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'numeric',
          missingDataExclude:false,
          hasLookUpTable:false,
          validationRules:[this.tinyintRule,],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"127", position: 0, visible: true,
          controlCaption:`Practice nurse contacts`,
          itemType:"data-item", dataItemId:"hsr_PracticeNurseContacts", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:true,
          lookUpTable:[
            {value:1, text:"No"},
            {value:2, text:"Yes"},
          ],
          lookupIsRequired:false,
          validationRules:[],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"127", position: 0, visible: true,
          controlCaption:`Number of <b>visits</b>`,
          itemType:"data-item", dataItemId:"hsr_PracticeNurseContactsNumOfVisits", dataItemValue:"",
          dataType:"int", length:false,
          prefix:'', suffix:'',
          inputmode:'numeric',
          missingDataExclude:false,
          hasLookUpTable:false,
          validationRules:[this.intRule,(v) => this.numberRangeRule(v,0,9999),],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"127", position: 0, visible: true,
          controlCaption:`Average <b>time (minutes)</b> spent per <b>visit</b>`,
          itemType:"data-item", dataItemId:"hsr_PracticeNurseContactsAverageTimeSpent", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'numeric',
          missingDataExclude:false,
          hasLookUpTable:false,
          validationRules:[this.tinyintRule,],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"127", position: 0, visible: true,
          controlCaption:`District nurse contacts`,
          itemType:"data-item", dataItemId:"hsr_DistrictNurseContacts", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:true,
          lookUpTable:[
            {value:1, text:"No"},
            {value:2, text:"Yes"},
          ],
          lookupIsRequired:false,
          validationRules:[],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"127", position: 0, visible: true,
          controlCaption:`Number of <b>visits</b>`,
          itemType:"data-item", dataItemId:"hsr_DistrictNurseContactsNumOfVisits", dataItemValue:"",
          dataType:"int", length:false,
          prefix:'', suffix:'',
          inputmode:'numeric',
          missingDataExclude:false,
          hasLookUpTable:false,
          validationRules:[this.intRule,(v) => this.numberRangeRule(v,0,9999),],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"127", position: 0, visible: true,
          controlCaption:`Average <b>time (minutes)</b> spent per <b>visit</b>`,
          itemType:"data-item", dataItemId:"hsr_DistrictNurseContactsAverageTimeSpent", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'numeric',
          missingDataExclude:false,
          hasLookUpTable:false,
          validationRules:[this.tinyintRule,],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"127", position: 0, visible: true,
          controlCaption:`Physiotherapy contacts or visits`,
          itemType:"data-item", dataItemId:"hsr_PhysiotherapyContactsVisits", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:true,
          lookUpTable:[
            {value:1, text:"No"},
            {value:2, text:"Yes"},
          ],
          lookupIsRequired:false,
          validationRules:[],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"127", position: 0, visible: true,
          controlCaption:`Number of <b>visits</b>`,
          itemType:"data-item", dataItemId:"hsr_PhysiotherapyContactsVisitsNumOfVisits", dataItemValue:"",
          dataType:"int", length:false,
          prefix:'', suffix:'',
          inputmode:'numeric',
          missingDataExclude:false,
          hasLookUpTable:false,
          validationRules:[this.intRule,(v) => this.numberRangeRule(v,0,9999),],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"127", position: 0, visible: true,
          controlCaption:`Average <b>time (minutes)</b> spent per <b>visit</b>`,
          itemType:"data-item", dataItemId:"hsr_PhysiotherapyContactsVisitsAverageTimeSpent", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'numeric',
          missingDataExclude:false,
          hasLookUpTable:false,
          validationRules:[this.tinyintRule,],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"127", position: 0, visible: true,
          controlCaption:`Calls to NHS Direct`,
          itemType:"data-item", dataItemId:"hsr_CallsToNHSDirect", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:true,
          lookUpTable:[
            {value:1, text:"No"},
            {value:2, text:"Yes"},
          ],
          lookupIsRequired:false,
          validationRules:[],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"127", position: 0, visible: true,
          controlCaption:`Number of <b>visits</b>`,
          itemType:"data-item", dataItemId:"hsr_CallsToNHSDirectNumOfVisits", dataItemValue:"",
          dataType:"int", length:false,
          prefix:'', suffix:'',
          inputmode:'numeric',
          missingDataExclude:false,
          hasLookUpTable:false,
          validationRules:[this.intRule,(v) => this.numberRangeRule(v,0,9999),],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"127", position: 0, visible: true,
          controlCaption:`Average <b>time (minutes)</b> spent per <b>visit</b>`,
          itemType:"data-item", dataItemId:"hsr_CallsToNHSDirectAverageTimeSpent", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'numeric',
          missingDataExclude:false,
          hasLookUpTable:false,
          validationRules:[this.tinyintRule,],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"127", position: 0, visible: true,
          controlCaption:`Calls for ambulance or paramedic`,
          itemType:"data-item", dataItemId:"hsr_CallsToAmbulance", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:true,
          lookUpTable:[
            {value:1, text:"No"},
            {value:2, text:"Yes"},
          ],
          lookupIsRequired:false,
          validationRules:[],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"127", position: 0, visible: true,
          controlCaption:`Number of <b>visits</b>`,
          itemType:"data-item", dataItemId:"hsr_CallsToAmbulanceNumOfVisits", dataItemValue:"",
          dataType:"int", length:false,
          prefix:'', suffix:'',
          inputmode:'numeric',
          missingDataExclude:false,
          hasLookUpTable:false,
          validationRules:[this.intRule,(v) => this.numberRangeRule(v,0,9999),],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"127", position: 0, visible: true,
          controlCaption:`Average <b>time (minutes)</b> spent per <b>visit</b>`,
          itemType:"data-item", dataItemId:"hsr_CallsToAmbulanceAverageTimeSpent", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'numeric',
          missingDataExclude:false,
          hasLookUpTable:false,
          validationRules:[this.tinyintRule,],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"127", position: 0, visible: true,
          controlCaption:`Occupational therapy contacts`,
          itemType:"data-item", dataItemId:"hsr_OccupationalTherapyContacts", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:true,
          lookUpTable:[
            {value:1, text:"No"},
            {value:2, text:"Yes"},
          ],
          lookupIsRequired:false,
          validationRules:[],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"127", position: 0, visible: true,
          controlCaption:`Number of <b>visits</b>`,
          itemType:"data-item", dataItemId:"hsr_OccupationalTherapyContactsNumOfVisits", dataItemValue:"",
          dataType:"int", length:false,
          prefix:'', suffix:'',
          inputmode:'numeric',
          missingDataExclude:false,
          hasLookUpTable:false,
          validationRules:[this.intRule,(v) => this.numberRangeRule(v,0,9999),],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"127", position: 0, visible: true,
          controlCaption:`Average <b>time (minutes)</b> spent per <b>visit</b>`,
          itemType:"data-item", dataItemId:"hsr_OccupationalTherapyContactsAverageTimeSpent", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'numeric',
          missingDataExclude:false,
          hasLookUpTable:false,
          validationRules:[this.tinyintRule,],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"127", position: 0, visible: true,
          controlCaption:`Speech and language therapy`,
          itemType:"data-item", dataItemId:"hsr_SpeechLanguageTherapy", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:true,
          lookUpTable:[
            {value:1, text:"No"},
            {value:2, text:"Yes"},
          ],
          lookupIsRequired:false,
          validationRules:[],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"127", position: 0, visible: true,
          controlCaption:`Number of <b>visits</b>`,
          itemType:"data-item", dataItemId:"hsr_SpeechLanguageTherapyNumOfVisits", dataItemValue:"",
          dataType:"int", length:false,
          prefix:'', suffix:'',
          inputmode:'numeric',
          missingDataExclude:false,
          hasLookUpTable:false,
          validationRules:[this.intRule,(v) => this.numberRangeRule(v,0,9999),],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"127", position: 0, visible: true,
          controlCaption:`Average <b>time (minutes)</b> spent per <b>visit</b>`,
          itemType:"data-item", dataItemId:"hsr_SpeechLanguageTherapyAverageTimeSpent", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'numeric',
          missingDataExclude:false,
          hasLookUpTable:false,
          validationRules:[this.tinyintRule,],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"127", position: 0, visible: true,
          controlCaption:`Psychology or mental health services`,
          itemType:"data-item", dataItemId:"hsr_PsychologyServices", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:true,
          lookUpTable:[
            {value:1, text:"No"},
            {value:2, text:"Yes"},
          ],
          lookupIsRequired:false,
          validationRules:[],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"127", position: 0, visible: true,
          controlCaption:`Number of <b>visits</b>`,
          itemType:"data-item", dataItemId:"hsr_PsychologyServicesNumOfVisits", dataItemValue:"",
          dataType:"int", length:false,
          prefix:'', suffix:'',
          inputmode:'numeric',
          missingDataExclude:false,
          hasLookUpTable:false,
          validationRules:[this.intRule,(v) => this.numberRangeRule(v,0,9999),],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"127", position: 0, visible: true,
          controlCaption:`Average <b>time (minutes)</b> spent per <b>visit</b>`,
          itemType:"data-item", dataItemId:"hsr_PsychologyServicesAverageTimeSpent", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'numeric',
          missingDataExclude:false,
          hasLookUpTable:false,
          validationRules:[this.tinyintRule,],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"127", position: 0, visible: true,
          controlCaption:`Have you seen/contacted any <b>other type</b> of health profession over the last {{3or6Months}}?`,
          itemType:"data-item", dataItemId:"hsr_TypeOfHealthProfOther", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:true,
          lookUpTable:[
            {value:1, text:"No"},
            {value:2, text:"Yes"},
          ],
          lookupIsRequired:false,
          validationRules:[],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          id:"68",
          itemType:"section-instruction",
          sectionTitle:`<p>Please tell us each professional you have seen and how often</p> <p><b>Type</b> of <b>health professional</b> you have seen/contacted over the last {{3or6Months}}</p>`,
          pageSplitInMobileMode: [3],
          position: 0,
          visible: true,
        }, {
          fgId:"129", position: 0, visible: true,
          controlCaption:`<b>Other type</b> of <b>health professional</b> you have seen/contacted over the last {{3or6Months}}`,
          itemType:"data-item", dataItemId:"hpo_TypeOfHealthProfessionals__1", dataItemValue:"",
          dataType:"nvarchar", length:200,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:false,
          validationRules:[],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"129", position: 0, visible: true,
          controlCaption:`Number of <b>visits</b>`,
          itemType:"data-item", dataItemId:"hpo_NumOfVisits__1", dataItemValue:"",
          dataType:"int", length:false,
          prefix:'', suffix:'',
          inputmode:'numeric',
          missingDataExclude:false,
          hasLookUpTable:false,
          validationRules:[this.intRule,(v) => this.numberRangeRule(v,0,9999),],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"129", position: 0, visible: true,
          controlCaption:`Average <b>time (minutes)</b> spent per <b>visit</b>`,
          itemType:"data-item", dataItemId:"hpo_AverageTimeSpent__1", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'numeric',
          missingDataExclude:false,
          hasLookUpTable:false,
          validationRules:[this.tinyintRule,],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          id:"69",
          itemType:"section-instruction",
          sectionTitle:`<p>Please tell us each professional you have seen and how often</p> <p><b>Type</b> of <b>health professional</b> you have seen/contacted over the last {{3or6Months}}</p>`,
          position: 0,
          visible: true,
        }, {
          fgId:"131", position: 0, visible: true,
          controlCaption:`Have you seen/contacted any <b>other type</b> of health professional over the last {{3or6Months}}?`,
          itemType:"data-item", dataItemId:"hsr_TypeOfHealthProfOtherContinued__2", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:true,
          lookUpTable:[
            {value:1, text:"No"},
            {value:2, text:"Yes"},
          ],
          lookupIsRequired:true,
          validationRules:[this.requiredRule,],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          id:"70",
          itemType:"section-instruction",
          sectionTitle:`<p>Please tell us each professional you have seen and how often</p> <p><b>Type</b> of <b>health professional</b> you have seen/contacted over the last {{3or6Months}}</p>`,
          pageSplitInMobileMode: [3],
          position: 0,
          visible: true,
        }, {
          fgId:"133", position: 0, visible: true,
          controlCaption:`<b>Other type</b> of <b>health professional</b> you have seen/contacted over the last {{3or6Months}}`,
          itemType:"data-item", dataItemId:"hpo_TypeOfHealthProfessionals__2", dataItemValue:"",
          dataType:"nvarchar", length:200,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:false,
          validationRules:[],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"133", position: 0, visible: true,
          controlCaption:`Number of <b>visits</b>`,
          itemType:"data-item", dataItemId:"hpo_NumOfVisits__2", dataItemValue:"",
          dataType:"int", length:false,
          prefix:'', suffix:'',
          inputmode:'numeric',
          missingDataExclude:false,
          hasLookUpTable:false,
          validationRules:[this.intRule,(v) => this.numberRangeRule(v,0,9999),],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"133", position: 0, visible: true,
          controlCaption:`Average <b>time (minutes)</b> spent per <b>visit</b>`,
          itemType:"data-item", dataItemId:"hpo_AverageTimeSpent__2", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'numeric',
          missingDataExclude:false,
          hasLookUpTable:false,
          validationRules:[this.tinyintRule,],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          id:"71",
          itemType:"section-instruction",
          sectionTitle:`<p>Please tell us each professional you have seen and how often</p> <p><b>Type</b> of <b>health professional</b> you have seen/contacted over the last {{3or6Months}}</p>`,
          position: 0,
          visible: true,
        }, {
          fgId:"135", position: 0, visible: true,
          controlCaption:`Have you seen/contacted any <b>other type</b> of health professional over the last {{3or6Months}}?`,
          itemType:"data-item", dataItemId:"hsr_TypeOfHealthProfOtherContinued__3", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:true,
          lookUpTable:[
            {value:1, text:"No"},
            {value:2, text:"Yes"},
          ],
          lookupIsRequired:true,
          validationRules:[this.requiredRule,],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          id:"72",
          itemType:"section-instruction",
          sectionTitle:`<p>Please tell us each professional you have seen and how often</p> <p><b>Type</b> of <b>health professional</b> you have seen/contacted over the last {{3or6Months}}</p>`,
          pageSplitInMobileMode: [3],
          position: 0,
          visible: true,
        }, {
          fgId:"137", position: 0, visible: true,
          controlCaption:`<b>Other type</b> of <b>health professional</b> you have seen/contacted over the last {{3or6Months}}`,
          itemType:"data-item", dataItemId:"hpo_TypeOfHealthProfessionals__3", dataItemValue:"",
          dataType:"nvarchar", length:200,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:false,
          validationRules:[],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"137", position: 0, visible: true,
          controlCaption:`Number of <b>visits</b>`,
          itemType:"data-item", dataItemId:"hpo_NumOfVisits__3", dataItemValue:"",
          dataType:"int", length:false,
          prefix:'', suffix:'',
          inputmode:'numeric',
          missingDataExclude:false,
          hasLookUpTable:false,
          validationRules:[this.intRule,(v) => this.numberRangeRule(v,0,9999),],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"137", position: 0, visible: true,
          controlCaption:`Average <b>time (minutes)</b> spent per <b>visit</b>`,
          itemType:"data-item", dataItemId:"hpo_AverageTimeSpent__3", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'numeric',
          missingDataExclude:false,
          hasLookUpTable:false,
          validationRules:[this.tinyintRule,],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          id:"73",
          itemType:"section-instruction",
          sectionTitle:``,
          position: 0,
          visible: true,
        }, {
          id:"74",
          itemType:"section-instruction",
          sectionTitle:`This section asks you about any <b>social services</b> or <b>equipment/aids</b> you have had to use`,
          position: 0,
          visible: true,
        }, {
          fgId:"140", position: 0, visible: true,
          controlCaption:`In the last <b>{{3or6Months}}</b>, have you had any <b>social services</b> to make your <b>day-to-day</b> life <b>easier? e.g. meals on wheels, care at home</b>.`,
          itemType:"data-item", dataItemId:"hsr_HaveSocialServices", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:true,
          lookUpTable:[
            {value:1, text:"No"},
            {value:2, text:"Yes"},
          ],
          lookupIsRequired:false,
          validationRules:[],
          controlEnabled:true,
          customError:false,
          customErrorMessage:'',
        }, {
          id:"75",
          itemType:"section-instruction",
          sectionTitle:`<p>Please give each service you have used below, and the number and hours of visits you have had.</p>`,
          pageSplitInDesktopMode: [3,3,3,3,4],
          pageSplitInMobileMode: [3,3,3,3,4],
          position: 0,
          visible: true,
        }, {
          fgId:"141", position: 0, visible: true,
          controlCaption:`Meals on wheels`,
          itemType:"data-item", dataItemId:"hsr_MealsOnWheels", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:true,
          lookUpTable:[
            {value:1, text:"No"},
            {value:2, text:"Yes"},
          ],
          lookupIsRequired:false,
          validationRules:[],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"141", position: 0, visible: true,
          controlCaption:`Number of <b>visits</b>`,
          itemType:"data-item", dataItemId:"hsr_MealsOnWheelsNumOfVisits", dataItemValue:"",
          dataType:"int", length:false,
          prefix:'', suffix:'',
          inputmode:'numeric',
          missingDataExclude:false,
          hasLookUpTable:false,
          validationRules:[this.intRule,(v) => this.numberRangeRule(v,0,9999),],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"141", position: 0, visible: true,
          controlCaption:`Average <b>time (hours)</b> spent per <b>visit</b>`,
          itemType:"data-item", dataItemId:"hsr_MealsOnWheelsAverageTimeSpent", dataItemValue:"",
          dataType:"decimal", length:false,
          prefix:'', suffix:'',
          inputmode:'decimal',
          missingDataExclude:false,
          hasLookUpTable:false,
          validationRules:[this.decimalRule,],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"141", position: 0, visible: true,
          controlCaption:`Laundry service`,
          itemType:"data-item", dataItemId:"hsr_LaundryService", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:true,
          lookUpTable:[
            {value:1, text:"No"},
            {value:2, text:"Yes"},
          ],
          lookupIsRequired:false,
          validationRules:[],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"141", position: 0, visible: true,
          controlCaption:`Number of <b>visits</b>`,
          itemType:"data-item", dataItemId:"hsr_LaundryServiceNumOfVisits", dataItemValue:"",
          dataType:"int", length:false,
          prefix:'', suffix:'',
          inputmode:'numeric',
          missingDataExclude:false,
          hasLookUpTable:false,
          validationRules:[this.intRule,(v) => this.numberRangeRule(v,0,9999),],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"141", position: 0, visible: true,
          controlCaption:`Average <b>time (hours)</b> spent per <b>visit</b>`,
          itemType:"data-item", dataItemId:"hsr_LaundryServiceAverageTimeSpent", dataItemValue:"",
          dataType:"decimal", length:false,
          prefix:'', suffix:'',
          inputmode:'decimal',
          missingDataExclude:false,
          hasLookUpTable:false,
          validationRules:[this.decimalRule,],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"141", position: 0, visible: true,
          controlCaption:`Social worker contacts`,
          itemType:"data-item", dataItemId:"hsr_SocialWorkerContacts", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:true,
          lookUpTable:[
            {value:1, text:"No"},
            {value:2, text:"Yes"},
          ],
          lookupIsRequired:false,
          validationRules:[],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"141", position: 0, visible: true,
          controlCaption:`Number of <b>visits</b>`,
          itemType:"data-item", dataItemId:"hsr_SocialWorkerContactsNumOfVisits", dataItemValue:"",
          dataType:"int", length:false,
          prefix:'', suffix:'',
          inputmode:'numeric',
          missingDataExclude:false,
          hasLookUpTable:false,
          validationRules:[this.intRule,(v) => this.numberRangeRule(v,0,9999),],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"141", position: 0, visible: true,
          controlCaption:`Average <b>time (hours)</b> spent per <b>visit</b>`,
          itemType:"data-item", dataItemId:"hsr_SocialWorkerContactsAverageTimeSpent", dataItemValue:"",
          dataType:"decimal", length:false,
          prefix:'', suffix:'',
          inputmode:'decimal',
          missingDataExclude:false,
          hasLookUpTable:false,
          validationRules:[this.decimalRule,],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"141", position: 0, visible: true,
          controlCaption:`Care worker contacts, including help at home`,
          itemType:"data-item", dataItemId:"hsr_CareWorkerContacts", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:true,
          lookUpTable:[
            {value:1, text:"No"},
            {value:2, text:"Yes"},
          ],
          lookupIsRequired:false,
          validationRules:[],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"141", position: 0, visible: true,
          controlCaption:`Number of <b>visits</b>`,
          itemType:"data-item", dataItemId:"hsr_CareWorkerContactsNumOfVisits", dataItemValue:"",
          dataType:"int", length:false,
          prefix:'', suffix:'',
          inputmode:'numeric',
          missingDataExclude:false,
          hasLookUpTable:false,
          validationRules:[this.intRule,(v) => this.numberRangeRule(v,0,9999),],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"141", position: 0, visible: true,
          controlCaption:`Average <b>time (hours)</b> spent per <b>visit</b>`,
          itemType:"data-item", dataItemId:"hsr_CareWorkerContactsAverageTimeSpent", dataItemValue:"",
          dataType:"decimal", length:false,
          prefix:'', suffix:'',
          inputmode:'decimal',
          missingDataExclude:false,
          hasLookUpTable:false,
          validationRules:[this.decimalRule,],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"141", position: 0, visible: true,
          controlCaption:`Other`,
          itemType:"data-item", dataItemId:"hsr_HaveSocialServicesOther", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:true,
          lookUpTable:[
            {value:1, text:"No"},
            {value:2, text:"Yes"},
          ],
          lookupIsRequired:false,
          validationRules:[],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"141", position: 0, visible: true,
          controlCaption:`Please specify`,
          itemType:"data-item", dataItemId:"hsr_HaveSocialServicesOtherSpecify", dataItemValue:"",
          dataType:"nvarchar", length:200,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:false,
          validationRules:[],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"141", position: 0, visible: true,
          controlCaption:`Number of <b>visits</b>`,
          itemType:"data-item", dataItemId:"hsr_HaveSocialServicesOtherNumOfVisits", dataItemValue:"",
          dataType:"int", length:false,
          prefix:'', suffix:'',
          inputmode:'numeric',
          missingDataExclude:false,
          hasLookUpTable:false,
          validationRules:[this.intRule,(v) => this.numberRangeRule(v,0,9999),],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"141", position: 0, visible: true,
          controlCaption:`Average <b>time (hours)</b> spent per <b>visit</b>`,
          itemType:"data-item", dataItemId:"hsr_HaveSocialServicesOtherAverageTimeSpent", dataItemValue:"",
          dataType:"decimal", length:false,
          prefix:'', suffix:'',
          inputmode:'decimal',
          missingDataExclude:false,
          hasLookUpTable:false,
          validationRules:[this.decimalRule,],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          id:"76",
          itemType:"section-instruction",
          sectionTitle:`Special Equipment or Aids`,
          position: 0,
          visible: true,
        }, {
          fgId:"142", position: 0, visible: true,
          controlCaption:`In the last <b>{{3or6Months}}</b>, have you used any new <b>special equipment</b> or aids for <b>health problems</b> related to having a <b>stroke</b>?`,
          itemType:"data-item", dataItemId:"hsr_HaveUsedNewSpecialEquipment", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:true,
          lookUpTable:[
            {value:1, text:"No"},
            {value:2, text:"Yes"},
          ],
          lookupIsRequired:false,
          validationRules:[],
          controlEnabled:true,
          customError:false,
          customErrorMessage:'',
        }, {
          id:"77",
          itemType:"section-instruction",
          sectionTitle:`<p>Please complete <b>each equipment</b>/aid you have <b>used</b> below. If the type of service is not listed, then please <b>type</b> this in.</p> <p><br/><b>Type</b> of new <b>equipment</b> or <b>aid</b> used</p>`,
          pageSplitInDesktopMode: [3,3,3,3,3,3,4],
          pageSplitInMobileMode: [3,3,3,3,3,3,4],
          position: 0,
          visible: true,
        }, {
          fgId:"143", position: 0, visible: true,
          controlCaption:`Home adaptations (e.g. hand rail or ramp)`,
          itemType:"data-item", dataItemId:"hsr_HomeAdaptations", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:true,
          lookUpTable:[
            {value:1, text:"No"},
            {value:2, text:"Yes"},
          ],
          lookupIsRequired:false,
          validationRules:[],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"143", position: 0, visible: true,
          controlCaption:`<b>Who provided</b> it? (e.g. NHS health services, social services, paid for myself)`,
          itemType:"data-item", dataItemId:"hsr_HomeAdaptationsWhoProvided", dataItemValue:"",
          dataType:"nvarchar", length:200,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:false,
          validationRules:[],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"143", position: 0, visible: true,
          controlCaption:`<b>Cost</b> to you (if none, please write &apos;0&apos;)`,
          itemType:"data-item", dataItemId:"hsr_HomeAdaptationsCost", dataItemValue:"",
          dataType:"int", length:false,
          prefix:'£', suffix:'',
          inputmode:'numeric',
          missingDataExclude:false,
          hasLookUpTable:false,
          validationRules:[this.intRule,],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"143", position: 0, visible: true,
          controlCaption:`Bathing aids`,
          itemType:"data-item", dataItemId:"hsr_BathingAids", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:true,
          lookUpTable:[
            {value:1, text:"No"},
            {value:2, text:"Yes"},
          ],
          lookupIsRequired:false,
          validationRules:[],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"143", position: 0, visible: true,
          controlCaption:`<b>Who provided</b> it? (e.g. NHS health services, social services, paid for myself)`,
          itemType:"data-item", dataItemId:"hsr_BathingAidsWhoProvided", dataItemValue:"",
          dataType:"nvarchar", length:200,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:false,
          validationRules:[],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"143", position: 0, visible: true,
          controlCaption:`<b>Cost</b> to you (if none, please write &apos;0&apos;)`,
          itemType:"data-item", dataItemId:"hsr_BathingAidsCost", dataItemValue:"",
          dataType:"int", length:false,
          prefix:'£', suffix:'',
          inputmode:'numeric',
          missingDataExclude:false,
          hasLookUpTable:false,
          validationRules:[this.intRule,],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"143", position: 0, visible: true,
          controlCaption:`Stair lifts`,
          itemType:"data-item", dataItemId:"hsr_StairLifts", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:true,
          lookUpTable:[
            {value:1, text:"No"},
            {value:2, text:"Yes"},
          ],
          lookupIsRequired:false,
          validationRules:[],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"143", position: 0, visible: true,
          controlCaption:`<b>Who provided</b> it? (e.g. NHS health services, social services, paid for myself)`,
          itemType:"data-item", dataItemId:"hsr_StairLiftsWhoProvided", dataItemValue:"",
          dataType:"nvarchar", length:200,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:false,
          validationRules:[],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"143", position: 0, visible: true,
          controlCaption:`<b>Cost</b> to you (if none, please write &apos;0&apos;)`,
          itemType:"data-item", dataItemId:"hsr_StairLiftsCost", dataItemValue:"",
          dataType:"int", length:false,
          prefix:'£', suffix:'',
          inputmode:'numeric',
          missingDataExclude:false,
          hasLookUpTable:false,
          validationRules:[this.intRule,],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"143", position: 0, visible: true,
          controlCaption:`Wheelchair (manual/electric)`,
          itemType:"data-item", dataItemId:"hsr_Wheelchair", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:true,
          lookUpTable:[
            {value:1, text:"No"},
            {value:2, text:"Yes"},
          ],
          lookupIsRequired:false,
          validationRules:[],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"143", position: 0, visible: true,
          controlCaption:`<b>Who provided</b> it? (e.g. NHS health services, social services, paid for myself)`,
          itemType:"data-item", dataItemId:"hsr_WheelchairWhoProvided", dataItemValue:"",
          dataType:"nvarchar", length:200,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:false,
          validationRules:[],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"143", position: 0, visible: true,
          controlCaption:`<b>Cost</b> to you (if none, please write &apos;0&apos;)`,
          itemType:"data-item", dataItemId:"hsr_WheelchairCost", dataItemValue:"",
          dataType:"int", length:false,
          prefix:'£', suffix:'',
          inputmode:'numeric',
          missingDataExclude:false,
          hasLookUpTable:false,
          validationRules:[this.intRule,],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"143", position: 0, visible: true,
          controlCaption:`Walking aids`,
          itemType:"data-item", dataItemId:"hsr_WalkingAids", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:true,
          lookUpTable:[
            {value:1, text:"No"},
            {value:2, text:"Yes"},
          ],
          lookupIsRequired:false,
          validationRules:[],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"143", position: 0, visible: true,
          controlCaption:`<b>Who provided</b> it? (e.g. NHS health services, social services, paid for myself)`,
          itemType:"data-item", dataItemId:"hsr_WalkingAidsWhoProvided", dataItemValue:"",
          dataType:"nvarchar", length:200,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:false,
          validationRules:[],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"143", position: 0, visible: true,
          controlCaption:`<b>Cost</b> to you (if none, please write &apos;0&apos;)`,
          itemType:"data-item", dataItemId:"hsr_WalkingAidsCost", dataItemValue:"",
          dataType:"int", length:false,
          prefix:'£', suffix:'',
          inputmode:'numeric',
          missingDataExclude:false,
          hasLookUpTable:false,
          validationRules:[this.intRule,],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"143", position: 0, visible: true,
          controlCaption:`Feeding aids`,
          itemType:"data-item", dataItemId:"hsr_FeedingAids", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:true,
          lookUpTable:[
            {value:1, text:"No"},
            {value:2, text:"Yes"},
          ],
          lookupIsRequired:false,
          validationRules:[],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"143", position: 0, visible: true,
          controlCaption:`<b>Who provided</b> it? (e.g. NHS health services, social services, paid for myself)`,
          itemType:"data-item", dataItemId:"hsr_FeedingAidsWhoProvided", dataItemValue:"",
          dataType:"nvarchar", length:200,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:false,
          validationRules:[],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"143", position: 0, visible: true,
          controlCaption:`<b>Cost</b> to you (if none, please write &apos;0&apos;)`,
          itemType:"data-item", dataItemId:"hsr_FeedingAidsCost", dataItemValue:"",
          dataType:"int", length:false,
          prefix:'£', suffix:'',
          inputmode:'numeric',
          missingDataExclude:false,
          hasLookUpTable:false,
          validationRules:[this.intRule,],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"143", position: 0, visible: true,
          controlCaption:`Other`,
          itemType:"data-item", dataItemId:"hsr_HaveUsedNewSpecialEquipmentOther", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:true,
          lookUpTable:[
            {value:1, text:"No"},
            {value:2, text:"Yes"},
          ],
          lookupIsRequired:false,
          validationRules:[],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"143", position: 0, visible: true,
          controlCaption:`Please specify`,
          itemType:"data-item", dataItemId:"hsr_HaveUsedNewSpecialEquipmentOtherSpecify", dataItemValue:"",
          dataType:"nvarchar", length:200,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:false,
          validationRules:[],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"143", position: 0, visible: true,
          controlCaption:`<b>Who provided</b> it? (e.g. NHS health services, social services, paid for myself)`,
          itemType:"data-item", dataItemId:"hsr_HaveUsedNewSpecialEquipmentOtherWhoProvided", dataItemValue:"",
          dataType:"nvarchar", length:200,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:false,
          validationRules:[],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"143", position: 0, visible: true,
          controlCaption:`<b>Cost</b> to you (if none, please write &apos;0&apos;)`,
          itemType:"data-item", dataItemId:"hsr_HaveUsedNewSpecialEquipmentOtherCost", dataItemValue:"",
          dataType:"int", length:false,
          prefix:'£', suffix:'',
          inputmode:'numeric',
          missingDataExclude:false,
          hasLookUpTable:false,
          validationRules:[this.intRule,],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          id:"78",
          itemType:"section-instruction",
          sectionTitle:`This section asks about your medication use`,
          position: 0,
          visible: true,
        }, {
          fgId:"144", position: 0, visible: true,
          controlCaption:`<p>Have you started taking any <b>new</b> prescribed <b>medicine</b> (given by a doctor) <b>regularly</b> in the last {{3or6Months}}?</p> <p>Please only include new medicines for any of the following health problems: <ul> <li>Heart or circulation</li> <li>Chest or breathing</li> <li>Kidney or bladder</li> <li>Stomach, bowel or abdomen</li> <li>Endocrine (e.g. diabetes, thyroid, hormones)</li> <li>Musculoskeletal (muscles, bones, tendons, ligaments)</li> <li>Brain or nervous system</li> <li>Blood or clotting problems</li> <li>Blood pressure</li> <li>Cholesterol</li> </ul> <p>`,
          itemType:"data-item", dataItemId:"hsr_TakingNewPrescribedMedicine", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:true,
          lookUpTable:[
            {value:1, text:"No"},
            {value:2, text:"Yes"},
          ],
          lookupIsRequired:false,
          validationRules:[],
          controlEnabled:true,
          customError:false,
          customErrorMessage:'',
        }, {
          id:"79",
          itemType:"section-instruction",
          sectionTitle:`<p>Details of <b>new</b> prescribed <b>medicine</b> (given by a doctor) <b>regularly</b> in the last {{3or6Months}}</p> <p>Please only include new medicines for any of the following health problems: <ul> <li>Heart or circulation</li> <li>Chest or breathing</li> <li>Kidney or bladder</li> <li>Stomach, bowel or abdomen</li> <li>Endocrine (e.g. diabetes, thyroid, hormones)</li> <li>Musculoskeletal (muscles, bones, tendons, ligaments)</li> <li>Brain or nervous system</li> <li>Blood or clotting problems</li> <li>Blood pressure</li> <li>Cholesterol</li> </ul> <p>`,
          pageSplitInDesktopMode: [4],
          pageSplitInMobileMode: [4],
          position: 0,
          visible: true,
        }, {
          fgId:"146", position: 0, visible: true,
          controlCaption:`<b>Medicine name</b> (e.g. Aspirin)`,
          itemType:"data-item", dataItemId:"tpm_MedicineName__1", dataItemValue:"",
          dataType:"nvarchar", length:200,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:false,
          validationRules:[],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"146", position: 0, visible: true,
          controlCaption:`Type and <b>dose</b> (e.g. tablet 75mg)`,
          itemType:"data-item", dataItemId:"tpm_TypeAndDose__1", dataItemValue:"",
          dataType:"nvarchar", length:200,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:false,
          validationRules:[],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"146", position: 0, visible: true,
          controlCaption:`Was this medicine <b>bought by you or prescribed</b>?`,
          itemType:"data-item", dataItemId:"tpm_MedicineBoughtPrescribed__1", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:true,
          lookUpTable:[
            {value:1, text:"Bought by you"},
            {value:2, text:"Prescribed"},
          ],
          lookupIsRequired:false,
          validationRules:[],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"146", position: 0, visible: true,
          controlCaption:`<b>How many times</b> was the medicine <b>bought</b> or <b>prescribed</b>?`,
          itemType:"data-item", dataItemId:"tpm_NumOfTimesBoughtPrescribed__1", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'numeric',
          missingDataExclude:false,
          hasLookUpTable:false,
          validationRules:[this.tinyintRule,],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          id:"80",
          itemType:"section-instruction",
          sectionTitle:`Details of <b>new</b> prescribed <b>medicine</b> (given by a doctor) <b>regularly</b> in the last {{3or6Months}}`,
          position: 0,
          visible: true,
        }, {
          fgId:"148", position: 0, visible: true,
          controlCaption:`Have you started taking any more <b>new</b> prescribed <b>medicine</b> (given by a doctor) <b>regularly</b> in the last {{3or6Months}}?`,
          itemType:"data-item", dataItemId:"hsr_TakingNewPrescribedMedicineContinued__2", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:true,
          lookUpTable:[
            {value:1, text:"No"},
            {value:2, text:"Yes"},
          ],
          lookupIsRequired:true,
          validationRules:[this.requiredRule,],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          id:"81",
          itemType:"section-instruction",
          sectionTitle:`<p>Details of <b>new</b> prescribed <b>medicine</b> (given by a doctor) <b>regularly</b> in the last {{3or6Months}}</p> <p>Please only include new medicines for any of the following health problems: <ul> <li>Heart or circulation</li> <li>Chest or breathing</li> <li>Kidney or bladder</li> <li>Stomach, bowel or abdomen</li> <li>Endocrine (e.g. diabetes, thyroid, hormones)</li> <li>Musculoskeletal (muscles, bones, tendons, ligaments)</li> <li>Brain or nervous system</li> <li>Blood or clotting problems</li> <li>Blood pressure</li> <li>Cholesterol</li> </ul> <p>`,
          pageSplitInDesktopMode: [4],
          pageSplitInMobileMode: [4],
          position: 0,
          visible: true,
        }, {
          fgId:"150", position: 0, visible: true,
          controlCaption:`<b>Medicine name</b> (e.g. Aspirin)`,
          itemType:"data-item", dataItemId:"tpm_MedicineName__2", dataItemValue:"",
          dataType:"nvarchar", length:200,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:false,
          validationRules:[],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"150", position: 0, visible: true,
          controlCaption:`Type and <b>dose</b> (e.g. tablet 75mg)`,
          itemType:"data-item", dataItemId:"tpm_TypeAndDose__2", dataItemValue:"",
          dataType:"nvarchar", length:200,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:false,
          validationRules:[],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"150", position: 0, visible: true,
          controlCaption:`Was this medicine <b>bought by you or prescribed</b>?`,
          itemType:"data-item", dataItemId:"tpm_MedicineBoughtPrescribed__2", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:true,
          lookUpTable:[
            {value:1, text:"Bought by you"},
            {value:2, text:"Prescribed"},
          ],
          lookupIsRequired:false,
          validationRules:[],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"150", position: 0, visible: true,
          controlCaption:`<b>How many times</b> was the medicine <b>bought</b> or <b>prescribed</b>?`,
          itemType:"data-item", dataItemId:"tpm_NumOfTimesBoughtPrescribed__2", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'numeric',
          missingDataExclude:false,
          hasLookUpTable:false,
          validationRules:[this.tinyintRule,],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          id:"82",
          itemType:"section-instruction",
          sectionTitle:`Details of <b>new</b> prescribed <b>medicine</b> (given by a doctor) <b>regularly</b> in the last {{3or6Months}}`,
          position: 0,
          visible: true,
        }, {
          fgId:"152", position: 0, visible: true,
          controlCaption:`Have you started taking any more <b>new</b> prescribed <b>medicine</b> (given by a doctor) <b>regularly</b> in the last {{3or6Months}}?`,
          itemType:"data-item", dataItemId:"hsr_TakingNewPrescribedMedicineContinued__3", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:true,
          lookUpTable:[
            {value:1, text:"No"},
            {value:2, text:"Yes"},
          ],
          lookupIsRequired:true,
          validationRules:[this.requiredRule,],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          id:"83",
          itemType:"section-instruction",
          sectionTitle:`<p>Details of <b>new</b> prescribed <b>medicine</b> (given by a doctor) <b>regularly</b> in the last {{3or6Months}}</p> <p>Please only include new medicines for any of the following health problems: <ul> <li>Heart or circulation</li> <li>Chest or breathing</li> <li>Kidney or bladder</li> <li>Stomach, bowel or abdomen</li> <li>Endocrine (e.g. diabetes, thyroid, hormones)</li> <li>Musculoskeletal (muscles, bones, tendons, ligaments)</li> <li>Brain or nervous system</li> <li>Blood or clotting problems</li> <li>Blood pressure</li> <li>Cholesterol</li> </ul> <p>`,
          pageSplitInDesktopMode: [4],
          pageSplitInMobileMode: [4],
          position: 0,
          visible: true,
        }, {
          fgId:"154", position: 0, visible: true,
          controlCaption:`<b>Medicine name</b> (e.g. Aspirin)`,
          itemType:"data-item", dataItemId:"tpm_MedicineName__3", dataItemValue:"",
          dataType:"nvarchar", length:200,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:false,
          validationRules:[],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"154", position: 0, visible: true,
          controlCaption:`Type and <b>dose</b> (e.g. tablet 75mg)`,
          itemType:"data-item", dataItemId:"tpm_TypeAndDose__3", dataItemValue:"",
          dataType:"nvarchar", length:200,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:false,
          validationRules:[],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"154", position: 0, visible: true,
          controlCaption:`Was this medicine <b>bought by you or prescribed</b>?`,
          itemType:"data-item", dataItemId:"tpm_MedicineBoughtPrescribed__3", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:true,
          lookUpTable:[
            {value:1, text:"Bought by you"},
            {value:2, text:"Prescribed"},
          ],
          lookupIsRequired:false,
          validationRules:[],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"154", position: 0, visible: true,
          controlCaption:`<b>How many times</b> was the medicine <b>bought</b> or <b>prescribed</b>?`,
          itemType:"data-item", dataItemId:"tpm_NumOfTimesBoughtPrescribed__3", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'numeric',
          missingDataExclude:false,
          hasLookUpTable:false,
          validationRules:[this.tinyintRule,],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          id:"84",
          itemType:"section-instruction",
          sectionTitle:`Details of <b>new</b> prescribed <b>medicine</b> (given by a doctor) <b>regularly</b> in the last {{3or6Months}}`,
          position: 0,
          visible: true,
        }, {
          fgId:"156", position: 0, visible: true,
          controlCaption:`Have you started taking any more <b>new</b> prescribed <b>medicine</b> (given by a doctor) <b>regularly</b> in the last {{3or6Months}}?`,
          itemType:"data-item", dataItemId:"hsr_TakingNewPrescribedMedicineContinued__4", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:true,
          lookUpTable:[
            {value:1, text:"No"},
            {value:2, text:"Yes"},
          ],
          lookupIsRequired:true,
          validationRules:[this.requiredRule,],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          id:"85",
          itemType:"section-instruction",
          sectionTitle:`<p>Details of <b>new</b> prescribed <b>medicine</b> (given by a doctor) <b>regularly</b> in the last {{3or6Months}}</p> <p>Please only include new medicines for any of the following health problems: <ul> <li>Heart or circulation</li> <li>Chest or breathing</li> <li>Kidney or bladder</li> <li>Stomach, bowel or abdomen</li> <li>Endocrine (e.g. diabetes, thyroid, hormones)</li> <li>Musculoskeletal (muscles, bones, tendons, ligaments)</li> <li>Brain or nervous system</li> <li>Blood or clotting problems</li> <li>Blood pressure</li> <li>Cholesterol</li> </ul> <p>`,
          pageSplitInDesktopMode: [4],
          pageSplitInMobileMode: [4],
          position: 0,
          visible: true,
        }, {
          fgId:"158", position: 0, visible: true,
          controlCaption:`<b>Medicine name</b> (e.g. Aspirin)`,
          itemType:"data-item", dataItemId:"tpm_MedicineName__4", dataItemValue:"",
          dataType:"nvarchar", length:200,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:false,
          validationRules:[],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"158", position: 0, visible: true,
          controlCaption:`Type and <b>dose</b> (e.g. tablet 75mg)`,
          itemType:"data-item", dataItemId:"tpm_TypeAndDose__4", dataItemValue:"",
          dataType:"nvarchar", length:200,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:false,
          validationRules:[],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"158", position: 0, visible: true,
          controlCaption:`Was this medicine <b>bought by you or prescribed</b>?`,
          itemType:"data-item", dataItemId:"tpm_MedicineBoughtPrescribed__4", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:true,
          lookUpTable:[
            {value:1, text:"Bought by you"},
            {value:2, text:"Prescribed"},
          ],
          lookupIsRequired:false,
          validationRules:[],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"158", position: 0, visible: true,
          controlCaption:`<b>How many times</b> was the medicine <b>bought</b> or <b>prescribed</b>?`,
          itemType:"data-item", dataItemId:"tpm_NumOfTimesBoughtPrescribed__4", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'numeric',
          missingDataExclude:false,
          hasLookUpTable:false,
          validationRules:[this.tinyintRule,],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          id:"86",
          itemType:"section-instruction",
          sectionTitle:`Details of <b>new</b> prescribed <b>medicine</b> (given by a doctor) <b>regularly</b> in the last {{3or6Months}}`,
          position: 0,
          visible: true,
        }, {
          fgId:"160", position: 0, visible: true,
          controlCaption:`Have you started taking any more <b>new</b> prescribed <b>medicine</b> (given by a doctor) <b>regularly</b> in the last {{3or6Months}}?`,
          itemType:"data-item", dataItemId:"hsr_TakingNewPrescribedMedicineContinued__5", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:true,
          lookUpTable:[
            {value:1, text:"No"},
            {value:2, text:"Yes"},
          ],
          lookupIsRequired:true,
          validationRules:[this.requiredRule,],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          id:"87",
          itemType:"section-instruction",
          sectionTitle:`<p>Details of <b>new</b> prescribed <b>medicine</b> (given by a doctor) <b>regularly</b> in the last {{3or6Months}}</p> <p>Please only include new medicines for any of the following health problems: <ul> <li>Heart or circulation</li> <li>Chest or breathing</li> <li>Kidney or bladder</li> <li>Stomach, bowel or abdomen</li> <li>Endocrine (e.g. diabetes, thyroid, hormones)</li> <li>Musculoskeletal (muscles, bones, tendons, ligaments)</li> <li>Brain or nervous system</li> <li>Blood or clotting problems</li> <li>Blood pressure</li> <li>Cholesterol</li> </ul> <p>`,
          pageSplitInDesktopMode: [4],
          pageSplitInMobileMode: [4],
          position: 0,
          visible: true,
        }, {
          fgId:"162", position: 0, visible: true,
          controlCaption:`<b>Medicine name</b> (e.g. Aspirin)`,
          itemType:"data-item", dataItemId:"tpm_MedicineName__5", dataItemValue:"",
          dataType:"nvarchar", length:200,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:false,
          validationRules:[],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"162", position: 0, visible: true,
          controlCaption:`Type and <b>dose</b> (e.g. tablet 75mg)`,
          itemType:"data-item", dataItemId:"tpm_TypeAndDose__5", dataItemValue:"",
          dataType:"nvarchar", length:200,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:false,
          validationRules:[],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"162", position: 0, visible: true,
          controlCaption:`Was this medicine <b>bought by you or prescribed</b>?`,
          itemType:"data-item", dataItemId:"tpm_MedicineBoughtPrescribed__5", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:true,
          lookUpTable:[
            {value:1, text:"Bought by you"},
            {value:2, text:"Prescribed"},
          ],
          lookupIsRequired:false,
          validationRules:[],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"162", position: 0, visible: true,
          controlCaption:`<b>How many times</b> was the medicine <b>bought</b> or <b>prescribed</b>?`,
          itemType:"data-item", dataItemId:"tpm_NumOfTimesBoughtPrescribed__5", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'numeric',
          missingDataExclude:false,
          hasLookUpTable:false,
          validationRules:[this.tinyintRule,],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          id:"88",
          itemType:"section-instruction",
          sectionTitle:`Details of <b>new</b> prescribed <b>medicine</b> (given by a doctor) <b>regularly</b> in the last {{3or6Months}}`,
          position: 0,
          visible: true,
        }, {
          fgId:"164", position: 0, visible: true,
          controlCaption:`Have you started taking any more <b>new</b> prescribed <b>medicine</b> (given by a doctor) <b>regularly</b> in the last {{3or6Months}}?`,
          itemType:"data-item", dataItemId:"hsr_TakingNewPrescribedMedicineContinued__6", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:true,
          lookUpTable:[
            {value:1, text:"No"},
            {value:2, text:"Yes"},
          ],
          lookupIsRequired:true,
          validationRules:[this.requiredRule,],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          id:"89",
          itemType:"section-instruction",
          sectionTitle:`<p>Details of <b>new</b> prescribed <b>medicine</b> (given by a doctor) <b>regularly</b> in the last {{3or6Months}}</p> <p>Please only include new medicines for any of the following health problems: <ul> <li>Heart or circulation</li> <li>Chest or breathing</li> <li>Kidney or bladder</li> <li>Stomach, bowel or abdomen</li> <li>Endocrine (e.g. diabetes, thyroid, hormones)</li> <li>Musculoskeletal (muscles, bones, tendons, ligaments)</li> <li>Brain or nervous system</li> <li>Blood or clotting problems</li> <li>Blood pressure</li> <li>Cholesterol</li> </ul> <p>`,
          pageSplitInDesktopMode: [4],
          pageSplitInMobileMode: [4],
          position: 0,
          visible: true,
        }, {
          fgId:"166", position: 0, visible: true,
          controlCaption:`<b>Medicine name</b> (e.g. Aspirin)`,
          itemType:"data-item", dataItemId:"tpm_MedicineName__6", dataItemValue:"",
          dataType:"nvarchar", length:200,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:false,
          validationRules:[],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"166", position: 0, visible: true,
          controlCaption:`Type and <b>dose</b> (e.g. tablet 75mg)`,
          itemType:"data-item", dataItemId:"tpm_TypeAndDose__6", dataItemValue:"",
          dataType:"nvarchar", length:200,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:false,
          validationRules:[],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"166", position: 0, visible: true,
          controlCaption:`Was this medicine <b>bought by you or prescribed</b>?`,
          itemType:"data-item", dataItemId:"tpm_MedicineBoughtPrescribed__6", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:true,
          lookUpTable:[
            {value:1, text:"Bought by you"},
            {value:2, text:"Prescribed"},
          ],
          lookupIsRequired:false,
          validationRules:[],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"166", position: 0, visible: true,
          controlCaption:`<b>How many times</b> was the medicine <b>bought</b> or <b>prescribed</b>?`,
          itemType:"data-item", dataItemId:"tpm_NumOfTimesBoughtPrescribed__6", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'numeric',
          missingDataExclude:false,
          hasLookUpTable:false,
          validationRules:[this.tinyintRule,],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          id:"90",
          itemType:"section-instruction",
          sectionTitle:`Details of <b>new</b> prescribed <b>medicine</b> (given by a doctor) <b>regularly</b> in the last {{3or6Months}}`,
          position: 0,
          visible: true,
        }, {
          fgId:"168", position: 0, visible: true,
          controlCaption:`Have you started taking any more <b>new</b> prescribed <b>medicine</b> (given by a doctor) <b>regularly</b> in the last {{3or6Months}}?`,
          itemType:"data-item", dataItemId:"hsr_TakingNewPrescribedMedicineContinued__7", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:true,
          lookUpTable:[
            {value:1, text:"No"},
            {value:2, text:"Yes"},
          ],
          lookupIsRequired:true,
          validationRules:[this.requiredRule,],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          id:"91",
          itemType:"section-instruction",
          sectionTitle:`<p>Details of <b>new</b> prescribed <b>medicine</b> (given by a doctor) <b>regularly</b> in the last {{3or6Months}}</p> <p>Please only include new medicines for any of the following health problems: <ul> <li>Heart or circulation</li> <li>Chest or breathing</li> <li>Kidney or bladder</li> <li>Stomach, bowel or abdomen</li> <li>Endocrine (e.g. diabetes, thyroid, hormones)</li> <li>Musculoskeletal (muscles, bones, tendons, ligaments)</li> <li>Brain or nervous system</li> <li>Blood or clotting problems</li> <li>Blood pressure</li> <li>Cholesterol</li> </ul> <p>`,
          pageSplitInDesktopMode: [4],
          pageSplitInMobileMode: [4],
          position: 0,
          visible: true,
        }, {
          fgId:"170", position: 0, visible: true,
          controlCaption:`<b>Medicine name</b> (e.g. Aspirin)`,
          itemType:"data-item", dataItemId:"tpm_MedicineName__7", dataItemValue:"",
          dataType:"nvarchar", length:200,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:false,
          validationRules:[],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"170", position: 0, visible: true,
          controlCaption:`Type and <b>dose</b> (e.g. tablet 75mg)`,
          itemType:"data-item", dataItemId:"tpm_TypeAndDose__7", dataItemValue:"",
          dataType:"nvarchar", length:200,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:false,
          validationRules:[],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"170", position: 0, visible: true,
          controlCaption:`Was this medicine <b>bought by you or prescribed</b>?`,
          itemType:"data-item", dataItemId:"tpm_MedicineBoughtPrescribed__7", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:true,
          lookUpTable:[
            {value:1, text:"Bought by you"},
            {value:2, text:"Prescribed"},
          ],
          lookupIsRequired:false,
          validationRules:[],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"170", position: 0, visible: true,
          controlCaption:`<b>How many times</b> was the medicine <b>bought</b> or <b>prescribed</b>?`,
          itemType:"data-item", dataItemId:"tpm_NumOfTimesBoughtPrescribed__7", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'numeric',
          missingDataExclude:false,
          hasLookUpTable:false,
          validationRules:[this.tinyintRule,],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          id:"92",
          itemType:"section-instruction",
          sectionTitle:`Details of <b>new</b> prescribed <b>medicine</b> (given by a doctor) <b>regularly</b> in the last {{3or6Months}}`,
          position: 0,
          visible: true,
        }, {
          fgId:"172", position: 0, visible: true,
          controlCaption:`Have you started taking any more <b>new</b> prescribed <b>medicine</b> (given by a doctor) <b>regularly</b> in the last {{3or6Months}}?`,
          itemType:"data-item", dataItemId:"hsr_TakingNewPrescribedMedicineContinued__8", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:true,
          lookUpTable:[
            {value:1, text:"No"},
            {value:2, text:"Yes"},
          ],
          lookupIsRequired:true,
          validationRules:[this.requiredRule,],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          id:"93",
          itemType:"section-instruction",
          sectionTitle:`<p>Details of <b>new</b> prescribed <b>medicine</b> (given by a doctor) <b>regularly</b> in the last {{3or6Months}}</p> <p>Please only include new medicines for any of the following health problems: <ul> <li>Heart or circulation</li> <li>Chest or breathing</li> <li>Kidney or bladder</li> <li>Stomach, bowel or abdomen</li> <li>Endocrine (e.g. diabetes, thyroid, hormones)</li> <li>Musculoskeletal (muscles, bones, tendons, ligaments)</li> <li>Brain or nervous system</li> <li>Blood or clotting problems</li> <li>Blood pressure</li> <li>Cholesterol</li> </ul> <p>`,
          pageSplitInDesktopMode: [4],
          pageSplitInMobileMode: [4],
          position: 0,
          visible: true,
        }, {
          fgId:"174", position: 0, visible: true,
          controlCaption:`<b>Medicine name</b> (e.g. Aspirin)`,
          itemType:"data-item", dataItemId:"tpm_MedicineName__8", dataItemValue:"",
          dataType:"nvarchar", length:200,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:false,
          validationRules:[],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"174", position: 0, visible: true,
          controlCaption:`Type and <b>dose</b> (e.g. tablet 75mg)`,
          itemType:"data-item", dataItemId:"tpm_TypeAndDose__8", dataItemValue:"",
          dataType:"nvarchar", length:200,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:false,
          validationRules:[],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"174", position: 0, visible: true,
          controlCaption:`Was this medicine <b>bought by you or prescribed</b>?`,
          itemType:"data-item", dataItemId:"tpm_MedicineBoughtPrescribed__8", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:true,
          lookUpTable:[
            {value:1, text:"Bought by you"},
            {value:2, text:"Prescribed"},
          ],
          lookupIsRequired:false,
          validationRules:[],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"174", position: 0, visible: true,
          controlCaption:`<b>How many times</b> was the medicine <b>bought</b> or <b>prescribed</b>?`,
          itemType:"data-item", dataItemId:"tpm_NumOfTimesBoughtPrescribed__8", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'numeric',
          missingDataExclude:false,
          hasLookUpTable:false,
          validationRules:[this.tinyintRule,],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          id:"94",
          itemType:"section-instruction",
          sectionTitle:`Details of <b>new</b> prescribed <b>medicine</b> (given by a doctor) <b>regularly</b> in the last {{3or6Months}}`,
          position: 0,
          visible: true,
        }, {
          fgId:"176", position: 0, visible: true,
          controlCaption:`Have you started taking any more <b>new</b> prescribed <b>medicine</b> (given by a doctor) <b>regularly</b> in the last {{3or6Months}}?`,
          itemType:"data-item", dataItemId:"hsr_TakingNewPrescribedMedicineContinued__9", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:true,
          lookUpTable:[
            {value:1, text:"No"},
            {value:2, text:"Yes"},
          ],
          lookupIsRequired:true,
          validationRules:[this.requiredRule,],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          id:"95",
          itemType:"section-instruction",
          sectionTitle:`<p>Details of <b>new</b> prescribed <b>medicine</b> (given by a doctor) <b>regularly</b> in the last {{3or6Months}}</p> <p>Please only include new medicines for any of the following health problems: <ul> <li>Heart or circulation</li> <li>Chest or breathing</li> <li>Kidney or bladder</li> <li>Stomach, bowel or abdomen</li> <li>Endocrine (e.g. diabetes, thyroid, hormones)</li> <li>Musculoskeletal (muscles, bones, tendons, ligaments)</li> <li>Brain or nervous system</li> <li>Blood or clotting problems</li> <li>Blood pressure</li> <li>Cholesterol</li> </ul> <p>`,
          pageSplitInDesktopMode: [4],
          pageSplitInMobileMode: [4],
          position: 0,
          visible: true,
        }, {
          fgId:"178", position: 0, visible: true,
          controlCaption:`<b>Medicine name</b> (e.g. Aspirin)`,
          itemType:"data-item", dataItemId:"tpm_MedicineName__9", dataItemValue:"",
          dataType:"nvarchar", length:200,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:false,
          validationRules:[],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"178", position: 0, visible: true,
          controlCaption:`Type and <b>dose</b> (e.g. tablet 75mg)`,
          itemType:"data-item", dataItemId:"tpm_TypeAndDose__9", dataItemValue:"",
          dataType:"nvarchar", length:200,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:false,
          validationRules:[],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"178", position: 0, visible: true,
          controlCaption:`Was this medicine <b>bought by you or prescribed</b>?`,
          itemType:"data-item", dataItemId:"tpm_MedicineBoughtPrescribed__9", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:true,
          lookUpTable:[
            {value:1, text:"Bought by you"},
            {value:2, text:"Prescribed"},
          ],
          lookupIsRequired:false,
          validationRules:[],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"178", position: 0, visible: true,
          controlCaption:`<b>How many times</b> was the medicine <b>bought</b> or <b>prescribed</b>?`,
          itemType:"data-item", dataItemId:"tpm_NumOfTimesBoughtPrescribed__9", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'numeric',
          missingDataExclude:false,
          hasLookUpTable:false,
          validationRules:[this.tinyintRule,],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          id:"96",
          itemType:"section-instruction",
          sectionTitle:`Details of <b>new</b> prescribed <b>medicine</b> (given by a doctor) <b>regularly</b> in the last {{3or6Months}}`,
          position: 0,
          visible: true,
        }, {
          fgId:"180", position: 0, visible: true,
          controlCaption:`Have you started taking any more <b>new</b> prescribed <b>medicine</b> (given by a doctor) <b>regularly</b> in the last {{3or6Months}}?`,
          itemType:"data-item", dataItemId:"hsr_TakingNewPrescribedMedicineContinued__10", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:true,
          lookUpTable:[
            {value:1, text:"No"},
            {value:2, text:"Yes"},
          ],
          lookupIsRequired:true,
          validationRules:[this.requiredRule,],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          id:"97",
          itemType:"section-instruction",
          sectionTitle:`<p>Details of <b>new</b> prescribed <b>medicine</b> (given by a doctor) <b>regularly</b> in the last {{3or6Months}}</p> <p>Please only include new medicines for any of the following health problems: <ul> <li>Heart or circulation</li> <li>Chest or breathing</li> <li>Kidney or bladder</li> <li>Stomach, bowel or abdomen</li> <li>Endocrine (e.g. diabetes, thyroid, hormones)</li> <li>Musculoskeletal (muscles, bones, tendons, ligaments)</li> <li>Brain or nervous system</li> <li>Blood or clotting problems</li> <li>Blood pressure</li> <li>Cholesterol</li> </ul> <p>`,
          pageSplitInDesktopMode: [4],
          pageSplitInMobileMode: [4],
          position: 0,
          visible: true,
        }, {
          fgId:"182", position: 0, visible: true,
          controlCaption:`<b>Medicine name</b> (e.g. Aspirin)`,
          itemType:"data-item", dataItemId:"tpm_MedicineName__10", dataItemValue:"",
          dataType:"nvarchar", length:200,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:false,
          validationRules:[],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"182", position: 0, visible: true,
          controlCaption:`Type and <b>dose</b> (e.g. tablet 75mg)`,
          itemType:"data-item", dataItemId:"tpm_TypeAndDose__10", dataItemValue:"",
          dataType:"nvarchar", length:200,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:false,
          validationRules:[],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"182", position: 0, visible: true,
          controlCaption:`Was this medicine <b>bought by you or prescribed</b>?`,
          itemType:"data-item", dataItemId:"tpm_MedicineBoughtPrescribed__10", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:true,
          lookUpTable:[
            {value:1, text:"Bought by you"},
            {value:2, text:"Prescribed"},
          ],
          lookupIsRequired:false,
          validationRules:[],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"182", position: 0, visible: true,
          controlCaption:`<b>How many times</b> was the medicine <b>bought</b> or <b>prescribed</b>?`,
          itemType:"data-item", dataItemId:"tpm_NumOfTimesBoughtPrescribed__10", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'numeric',
          missingDataExclude:false,
          hasLookUpTable:false,
          validationRules:[this.tinyintRule,],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          id:"98",
          itemType:"section-instruction",
          sectionTitle:``,
          position: 0,
          visible: true,
        }, {
          id:"99",
          itemType:"section-instruction",
          sectionTitle:`This section asks you about expenses you have had that related to health care visits, and any private care you might have received`,
          position: 0,
          visible: true,
        }, {
          fgId:"185", position: 0, visible: true,
          controlCaption:`Over the last <b>{{3or6Months}}</b>, have you used any <b>health services</b> that you <b>paid</b> for <b>yourself</b>, or paid by private insurance? Please do <b>not</b> include any treatment paid for by the <b>NHS</b>.`,
          itemType:"data-item", dataItemId:"hsr_HaveUsedHealthServices", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:true,
          lookUpTable:[
            {value:1, text:"No"},
            {value:2, text:"Yes"},
          ],
          lookupIsRequired:false,
          validationRules:[],
          controlEnabled:true,
          customError:false,
          customErrorMessage:'',
        }, {
          id:"100",
          itemType:"section-instruction",
          sectionTitle:`<p>Please give the private service that you used.</p> <p><b>Type</b> of private treatment</p>`,
          pageSplitInDesktopMode: [3,3,3,3,3,4],
          pageSplitInMobileMode: [3,3,3,3,3,4],
          position: 0,
          visible: true,
        }, {
          fgId:"186", position: 0, visible: true,
          controlCaption:`Physiotherapy`,
          itemType:"data-item", dataItemId:"hsr_Physiotherapy", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:true,
          lookUpTable:[
            {value:1, text:"No"},
            {value:2, text:"Yes"},
          ],
          lookupIsRequired:false,
          validationRules:[],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"186", position: 0, visible: true,
          controlCaption:`<b>Number<b> of contacts`,
          itemType:"data-item", dataItemId:"hsr_PhysiotherapyNumOfContacts", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'numeric',
          missingDataExclude:false,
          hasLookUpTable:false,
          validationRules:[this.tinyintRule,],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"186", position: 0, visible: true,
          controlCaption:`How much did this <b>cost</b> you?`,
          itemType:"data-item", dataItemId:"hsr_PhysiotherapyCost", dataItemValue:"",
          dataType:"int", length:false,
          prefix:'£', suffix:'',
          inputmode:'numeric',
          missingDataExclude:false,
          hasLookUpTable:false,
          validationRules:[this.intRule,],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"186", position: 0, visible: true,
          controlCaption:`Psychology`,
          itemType:"data-item", dataItemId:"hsr_Psychology", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:true,
          lookUpTable:[
            {value:1, text:"No"},
            {value:2, text:"Yes"},
          ],
          lookupIsRequired:false,
          validationRules:[],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"186", position: 0, visible: true,
          controlCaption:`<b>Number<b> of contacts`,
          itemType:"data-item", dataItemId:"hsr_PsychologyNumOfContacts", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'numeric',
          missingDataExclude:false,
          hasLookUpTable:false,
          validationRules:[this.tinyintRule,],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"186", position: 0, visible: true,
          controlCaption:`How much did this <b>cost</b> you?`,
          itemType:"data-item", dataItemId:"hsr_PsychologyCost", dataItemValue:"",
          dataType:"int", length:false,
          prefix:'£', suffix:'',
          inputmode:'numeric',
          missingDataExclude:false,
          hasLookUpTable:false,
          validationRules:[this.intRule,],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"186", position: 0, visible: true,
          controlCaption:`Private care home`,
          itemType:"data-item", dataItemId:"hsr_PrivateCareHome", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:true,
          lookUpTable:[
            {value:1, text:"No"},
            {value:2, text:"Yes"},
          ],
          lookupIsRequired:false,
          validationRules:[],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"186", position: 0, visible: true,
          controlCaption:`<b>Number<b> of contacts`,
          itemType:"data-item", dataItemId:"hsr_PrivateCareHomeNumOfContacts", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'numeric',
          missingDataExclude:false,
          hasLookUpTable:false,
          validationRules:[this.tinyintRule,],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"186", position: 0, visible: true,
          controlCaption:`How much did this <b>cost</b> you?`,
          itemType:"data-item", dataItemId:"hsr_PrivateCareHomeCost", dataItemValue:"",
          dataType:"int", length:false,
          prefix:'£', suffix:'',
          inputmode:'numeric',
          missingDataExclude:false,
          hasLookUpTable:false,
          validationRules:[this.intRule,],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"186", position: 0, visible: true,
          controlCaption:`Private carer`,
          itemType:"data-item", dataItemId:"hsr_PrivateCarer", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:true,
          lookUpTable:[
            {value:1, text:"No"},
            {value:2, text:"Yes"},
          ],
          lookupIsRequired:false,
          validationRules:[],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"186", position: 0, visible: true,
          controlCaption:`<b>Number<b> of contacts`,
          itemType:"data-item", dataItemId:"hsr_PrivateCarerNumOfContacts", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'numeric',
          missingDataExclude:false,
          hasLookUpTable:false,
          validationRules:[this.tinyintRule,],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"186", position: 0, visible: true,
          controlCaption:`How much did this <b>cost</b> you?`,
          itemType:"data-item", dataItemId:"hsr_PrivateCarerCost", dataItemValue:"",
          dataType:"int", length:false,
          prefix:'£', suffix:'',
          inputmode:'numeric',
          missingDataExclude:false,
          hasLookUpTable:false,
          validationRules:[this.intRule,],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"186", position: 0, visible: true,
          controlCaption:`Child carer`,
          itemType:"data-item", dataItemId:"hsr_ChildCarer", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:true,
          lookUpTable:[
            {value:1, text:"No"},
            {value:2, text:"Yes"},
          ],
          lookupIsRequired:false,
          validationRules:[],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"186", position: 0, visible: true,
          controlCaption:`<b>Number<b> of contacts`,
          itemType:"data-item", dataItemId:"hsr_ChildCarerNumOfContacts", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'numeric',
          missingDataExclude:false,
          hasLookUpTable:false,
          validationRules:[this.tinyintRule,],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"186", position: 0, visible: true,
          controlCaption:`How much did this <b>cost</b> you?`,
          itemType:"data-item", dataItemId:"hsr_ChildCarerCost", dataItemValue:"",
          dataType:"int", length:false,
          prefix:'£', suffix:'',
          inputmode:'numeric',
          missingDataExclude:false,
          hasLookUpTable:false,
          validationRules:[this.intRule,],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"186", position: 0, visible: true,
          controlCaption:`Other`,
          itemType:"data-item", dataItemId:"hsr_HaveUsedHealthServicesOther", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:true,
          lookUpTable:[
            {value:1, text:"No"},
            {value:2, text:"Yes"},
          ],
          lookupIsRequired:false,
          validationRules:[],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"186", position: 0, visible: true,
          controlCaption:`Please specify`,
          itemType:"data-item", dataItemId:"hsr_HaveUsedHealthServicesOtherSpecify", dataItemValue:"",
          dataType:"nvarchar", length:200,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:false,
          validationRules:[],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"186", position: 0, visible: true,
          controlCaption:`<b>Number<b> of contacts`,
          itemType:"data-item", dataItemId:"hsr_HaveUsedHealthServicesOtherNumOfContacts", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'numeric',
          missingDataExclude:false,
          hasLookUpTable:false,
          validationRules:[this.tinyintRule,],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"186", position: 0, visible: true,
          controlCaption:`How much did this <b>cost</b> you?`,
          itemType:"data-item", dataItemId:"hsr_HaveUsedHealthServicesOtherCost", dataItemValue:"",
          dataType:"int", length:false,
          prefix:'£', suffix:'',
          inputmode:'numeric',
          missingDataExclude:false,
          hasLookUpTable:false,
          validationRules:[this.intRule,],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          id:"101",
          itemType:"section-instruction",
          sectionTitle:`This section asks you about expenses you have had that related to health care visits, and any private care you might have received`,
          position: 0,
          visible: true,
        }, {
          fgId:"187", position: 0, visible: true,
          controlCaption:`Over the last <b>{{3or6Months}}</b>, have you <b>paid</b> for <b>travelling</b> to <b>health services</b>? Please include <b>travel costs</b> for both <b>NHS and private services</b>`,
          itemType:"data-item", dataItemId:"hsr_HavePaidTravellingHealthServices", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:true,
          lookUpTable:[
            {value:1, text:"No"},
            {value:2, text:"Yes"},
          ],
          lookupIsRequired:false,
          validationRules:[],
          controlEnabled:true,
          customError:false,
          customErrorMessage:'',
        }, {
          id:"102",
          itemType:"section-instruction",
          sectionTitle:`Travelling cost details 1`,
          position: 0,
          visible: true,
        }, {
          fgId:"189", position: 0, visible: true,
          controlCaption:`<b>Type</b> of travelling costs <br/> Travel to health service providers (e.g. car, public transport (e.g. bus), parking fees, taxi)`,
          itemType:"data-item", dataItemId:"pth_TypeOfTravellingCosts__1", dataItemValue:"",
          dataType:"nvarchar", length:200,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:false,
          validationRules:[],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"189", position: 0, visible: true,
          controlCaption:`How much did this <b>cost</b> you?`,
          itemType:"data-item", dataItemId:"pth_Cost__1", dataItemValue:"",
          dataType:"int", length:false,
          prefix:'£', suffix:'',
          inputmode:'numeric',
          missingDataExclude:false,
          hasLookUpTable:false,
          validationRules:[this.intRule,],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          id:"103",
          itemType:"section-instruction",
          sectionTitle:`Please give these travel costs below.`,
          position: 0,
          visible: true,
        }, {
          fgId:"191", position: 0, visible: true,
          controlCaption:`Have you <b>paid</b> for <b>travelling</b> to any other <b>health services</b> over the last <b>{{3or6Months}}</b>? Please include <b>travel costs</b> for both <b>NHS and private services</b>`,
          itemType:"data-item", dataItemId:"hsr_HavePaidTravellingHealthServicesContinued__2", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:true,
          lookUpTable:[
            {value:1, text:"No"},
            {value:2, text:"Yes"},
          ],
          lookupIsRequired:true,
          validationRules:[this.requiredRule,],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          id:"104",
          itemType:"section-instruction",
          sectionTitle:`Travelling cost details 2`,
          position: 0,
          visible: true,
        }, {
          fgId:"193", position: 0, visible: true,
          controlCaption:`<b>Type</b> of travelling costs <br/> Travel to health service providers (e.g. car, public transport (e.g. bus), parking fees, taxi)`,
          itemType:"data-item", dataItemId:"pth_TypeOfTravellingCosts__2", dataItemValue:"",
          dataType:"nvarchar", length:200,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:false,
          validationRules:[],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"193", position: 0, visible: true,
          controlCaption:`How much did this <b>cost</b> you?`,
          itemType:"data-item", dataItemId:"pth_Cost__2", dataItemValue:"",
          dataType:"int", length:false,
          prefix:'£', suffix:'',
          inputmode:'numeric',
          missingDataExclude:false,
          hasLookUpTable:false,
          validationRules:[this.intRule,],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          id:"105",
          itemType:"section-instruction",
          sectionTitle:`Please give these travel costs below.`,
          position: 0,
          visible: true,
        }, {
          fgId:"195", position: 0, visible: true,
          controlCaption:`Have you <b>paid</b> for <b>travelling</b> to any other <b>health services</b> over the last <b>{{3or6Months}}</b>? Please include <b>travel costs</b> for both <b>NHS and private services</b>`,
          itemType:"data-item", dataItemId:"hsr_HavePaidTravellingHealthServicesContinued__3", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:true,
          lookUpTable:[
            {value:1, text:"No"},
            {value:2, text:"Yes"},
          ],
          lookupIsRequired:true,
          validationRules:[this.requiredRule,],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          id:"106",
          itemType:"section-instruction",
          sectionTitle:`Travelling cost details 3`,
          position: 0,
          visible: true,
        }, {
          fgId:"197", position: 0, visible: true,
          controlCaption:`<b>Type</b> of travelling costs <br/> Travel to health service providers (e.g. car, public transport (e.g. bus), parking fees, taxi)`,
          itemType:"data-item", dataItemId:"pth_TypeOfTravellingCosts__3", dataItemValue:"",
          dataType:"nvarchar", length:200,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:false,
          validationRules:[],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"197", position: 0, visible: true,
          controlCaption:`How much did this <b>cost</b> you?`,
          itemType:"data-item", dataItemId:"pth_Cost__3", dataItemValue:"",
          dataType:"int", length:false,
          prefix:'£', suffix:'',
          inputmode:'numeric',
          missingDataExclude:false,
          hasLookUpTable:false,
          validationRules:[this.intRule,],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          id:"107",
          itemType:"section-instruction",
          sectionTitle:`Please give these travel costs below.`,
          position: 0,
          visible: true,
        }, {
          fgId:"199", position: 0, visible: true,
          controlCaption:`Have you <b>paid</b> for <b>travelling</b> to any other <b>health services</b> over the last <b>{{3or6Months}}</b>? Please include <b>travel costs</b> for both <b>NHS and private services</b>`,
          itemType:"data-item", dataItemId:"hsr_HavePaidTravellingHealthServicesContinued__4", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:true,
          lookUpTable:[
            {value:1, text:"No"},
            {value:2, text:"Yes"},
          ],
          lookupIsRequired:true,
          validationRules:[this.requiredRule,],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          id:"108",
          itemType:"section-instruction",
          sectionTitle:`Travelling cost details 4`,
          position: 0,
          visible: true,
        }, {
          fgId:"201", position: 0, visible: true,
          controlCaption:`<b>Type</b> of travelling costs <br/> Travel to health service providers (e.g. car, public transport (e.g. bus), parking fees, taxi)`,
          itemType:"data-item", dataItemId:"pth_TypeOfTravellingCosts__4", dataItemValue:"",
          dataType:"nvarchar", length:200,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:false,
          validationRules:[],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"201", position: 0, visible: true,
          controlCaption:`How much did this <b>cost</b> you?`,
          itemType:"data-item", dataItemId:"pth_Cost__4", dataItemValue:"",
          dataType:"int", length:false,
          prefix:'£', suffix:'',
          inputmode:'numeric',
          missingDataExclude:false,
          hasLookUpTable:false,
          validationRules:[this.intRule,],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          id:"109",
          itemType:"section-instruction",
          sectionTitle:`Please give these travel costs below.`,
          position: 0,
          visible: true,
        }, {
          fgId:"203", position: 0, visible: true,
          controlCaption:`Have you <b>paid</b> for <b>travelling</b> to any other <b>health services</b> over the last <b>{{3or6Months}}</b>? Please include <b>travel costs</b> for both <b>NHS and private services</b>`,
          itemType:"data-item", dataItemId:"hsr_HavePaidTravellingHealthServicesContinued__5", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:true,
          lookUpTable:[
            {value:1, text:"No"},
            {value:2, text:"Yes"},
          ],
          lookupIsRequired:true,
          validationRules:[this.requiredRule,],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          id:"110",
          itemType:"section-instruction",
          sectionTitle:`Travelling cost details 5`,
          position: 0,
          visible: true,
        }, {
          fgId:"205", position: 0, visible: true,
          controlCaption:`<b>Type</b> of travelling costs <br/> Travel to health service providers (e.g. car, public transport (e.g. bus), parking fees, taxi)`,
          itemType:"data-item", dataItemId:"pth_TypeOfTravellingCosts__5", dataItemValue:"",
          dataType:"nvarchar", length:200,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:false,
          validationRules:[],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"205", position: 0, visible: true,
          controlCaption:`How much did this <b>cost</b> you?`,
          itemType:"data-item", dataItemId:"pth_Cost__5", dataItemValue:"",
          dataType:"int", length:false,
          prefix:'£', suffix:'',
          inputmode:'numeric',
          missingDataExclude:false,
          hasLookUpTable:false,
          validationRules:[this.intRule,],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          id:"111",
          itemType:"section-instruction",
          sectionTitle:`Please give these travel costs below.`,
          position: 0,
          visible: true,
        }, {
          fgId:"207", position: 0, visible: true,
          controlCaption:`Have you <b>paid</b> for <b>travelling</b> to any other <b>health services</b> over the last <b>{{3or6Months}}</b>? Please include <b>travel costs</b> for both <b>NHS and private services</b>`,
          itemType:"data-item", dataItemId:"hsr_HavePaidTravellingHealthServicesContinued__6", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:true,
          lookUpTable:[
            {value:1, text:"No"},
            {value:2, text:"Yes"},
          ],
          lookupIsRequired:true,
          validationRules:[this.requiredRule,],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          id:"112",
          itemType:"section-instruction",
          sectionTitle:`Travelling cost details 6`,
          position: 0,
          visible: true,
        }, {
          fgId:"209", position: 0, visible: true,
          controlCaption:`<b>Type</b> of travelling costs <br/> Travel to health service providers (e.g. car, public transport (e.g. bus), parking fees, taxi)`,
          itemType:"data-item", dataItemId:"pth_TypeOfTravellingCosts__6", dataItemValue:"",
          dataType:"nvarchar", length:200,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:false,
          validationRules:[],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"209", position: 0, visible: true,
          controlCaption:`How much did this <b>cost</b> you?`,
          itemType:"data-item", dataItemId:"pth_Cost__6", dataItemValue:"",
          dataType:"int", length:false,
          prefix:'£', suffix:'',
          inputmode:'numeric',
          missingDataExclude:false,
          hasLookUpTable:false,
          validationRules:[this.intRule,],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          id:"113",
          itemType:"section-instruction",
          sectionTitle:``,
          position: 0,
          visible: true,
        }, {
          id:"114",
          itemType:"section-instruction",
          sectionTitle:`This section asks you about expenses you have had that related to health care visits, and any private care you might have received`,
          position: 0,
          visible: true,
        }, {
          fgId:"212", position: 0, visible: true,
          controlCaption:`Over the last <b>{{3or6Months}}</b>, has your <b>partner, relatives</b> or <b>friends</b> had any <b>extra costs</b> (either planned or unplanned) because of <b>your stroke</b>? This can be either NHS or private services`,
          itemType:"data-item", dataItemId:"hsr_HaveExtraCosts", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:true,
          lookUpTable:[
            {value:1, text:"No"},
            {value:2, text:"Yes"},
          ],
          lookupIsRequired:false,
          validationRules:[],
          controlEnabled:true,
          customError:false,
          customErrorMessage:'',
        }, {
          id:"115",
          itemType:"section-instruction",
          sectionTitle:`<p>Please add these additional costs.</p>`,
          pageSplitInDesktopMode: [2,2,2,3],
          pageSplitInMobileMode: [2,2,2,3],
          position: 0,
          visible: true,
        }, {
          fgId:"213", position: 0, visible: true,
          controlCaption:`<p><b>Type</b> of additional costs</p> <br/>Travel to health service providers (e.g. car, public transport (e.g. bus), parking fees, taxi))`,
          itemType:"data-item", dataItemId:"hsr_HealthServiceProviders", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:true,
          lookUpTable:[
            {value:1, text:"No"},
            {value:2, text:"Yes"},
          ],
          lookupIsRequired:false,
          validationRules:[],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"213", position: 0, visible: true,
          controlCaption:`<b>Cost</b> to partner / relatives / friends`,
          itemType:"data-item", dataItemId:"hsr_HealthServiceProvidersCost", dataItemValue:"",
          dataType:"int", length:false,
          prefix:'£', suffix:'',
          inputmode:'numeric',
          missingDataExclude:false,
          hasLookUpTable:false,
          validationRules:[this.intRule,],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"213", position: 0, visible: true,
          controlCaption:`Childcare`,
          itemType:"data-item", dataItemId:"hsr_Childcare", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:true,
          lookUpTable:[
            {value:1, text:"No"},
            {value:2, text:"Yes"},
          ],
          lookupIsRequired:false,
          validationRules:[],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"213", position: 0, visible: true,
          controlCaption:`<b>Cost</b> to partner / relatives / friends`,
          itemType:"data-item", dataItemId:"hsr_ChildcareCost", dataItemValue:"",
          dataType:"int", length:false,
          prefix:'£', suffix:'',
          inputmode:'numeric',
          missingDataExclude:false,
          hasLookUpTable:false,
          validationRules:[this.intRule,],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"213", position: 0, visible: true,
          controlCaption:`Help with housework`,
          itemType:"data-item", dataItemId:"hsr_HelpWithHousework", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:true,
          lookUpTable:[
            {value:1, text:"No"},
            {value:2, text:"Yes"},
          ],
          lookupIsRequired:false,
          validationRules:[],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"213", position: 0, visible: true,
          controlCaption:`<b>Cost</b> to partner / relatives / friends`,
          itemType:"data-item", dataItemId:"hsr_HelpWithHouseworkCost", dataItemValue:"",
          dataType:"int", length:false,
          prefix:'£', suffix:'',
          inputmode:'numeric',
          missingDataExclude:false,
          hasLookUpTable:false,
          validationRules:[this.intRule,],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"213", position: 0, visible: true,
          controlCaption:`Other`,
          itemType:"data-item", dataItemId:"hsr_HealthServiceProvidersOther", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:true,
          lookUpTable:[
            {value:1, text:"No"},
            {value:2, text:"Yes"},
          ],
          lookupIsRequired:false,
          validationRules:[],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"213", position: 0, visible: true,
          controlCaption:`Please specify`,
          itemType:"data-item", dataItemId:"hsr_HealthServiceProvidersOtherSpecify", dataItemValue:"",
          dataType:"nvarchar", length:200,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:false,
          validationRules:[],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"213", position: 0, visible: true,
          controlCaption:`<b>Cost</b> to partner / relatives / friends`,
          itemType:"data-item", dataItemId:"hsr_HealthServiceProvidersOtherCost", dataItemValue:"",
          dataType:"int", length:false,
          prefix:'£', suffix:'',
          inputmode:'numeric',
          missingDataExclude:false,
          hasLookUpTable:false,
          validationRules:[this.intRule,],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          id:"116",
          itemType:"section-instruction",
          sectionTitle:`This section asks you about time off work`,
          position: 0,
          visible: true,
        }, {
          fgId:"214", position: 0, visible: true,
          controlCaption:`Are you in <b>regular work</b> (this includes <b>full</b> or <b>part-time, paid</b> or <b>unpaid</b> carer)?`,
          itemType:"data-item", dataItemId:"hsr_ParticipantRegularWork", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:true,
          lookUpTable:[
            {value:1, text:"No"},
            {value:2, text:"Yes"},
          ],
          lookupIsRequired:false,
          validationRules:[],
          controlEnabled:true,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"214", position: 0, visible: true,
          controlCaption:`<b>Type</b> of work`,
          itemType:"data-item", dataItemId:"hsr_ParticipantTypeOfWork", dataItemValue:"",
          dataType:"nvarchar", length:200,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:false,
          validationRules:[],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"214", position: 0, visible: true,
          controlCaption:`If you work, please enter the number of <b>days</b> you were <b>off work</b> over the last {{3or6Months}} because of health problems after having your stroke`,
          itemType:"data-item", dataItemId:"hsr_ParticipantNumOfDays", dataItemValue:"",
          dataType:"smallint", length:false,
          prefix:'', suffix:'days',
          inputmode:'numeric',
          missingDataExclude:false,
          hasLookUpTable:false,
          validationRules:[this.smallintRule,(v) => this.numberRangeRule(v,0,182),],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          id:"117",
          itemType:"section-instruction",
          sectionTitle:`This section asks you about time off work`,
          position: 0,
          visible: true,
        }, {
          fgId:"215", position: 0, visible: true,
          controlCaption:`Over the last <b>{{3or6Months}}</b>, has your <b>partner, relatives or friends</b> taken any <b>time off work</b>, paid or unpaid following <b>your stroke</b>?`,
          itemType:"data-item", dataItemId:"hsr_PartnerHaveTakenTimeOffWork", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:true,
          lookUpTable:[
            {value:1, text:"No"},
            {value:2, text:"Yes"},
            {value:3, text:"Does not apply"},
          ],
          lookupIsRequired:false,
          validationRules:[],
          controlEnabled:true,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"215", position: 0, visible: true,
          controlCaption:`Their <b>type</b> of work`,
          itemType:"data-item", dataItemId:"hsr_PartnerTypeOfWork", dataItemValue:"",
          dataType:"nvarchar", length:200,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:false,
          validationRules:[],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        }, {
          fgId:"215", position: 0, visible: true,
          controlCaption:`Please enter the number of <b>days</b> they were <b>off work</b>, after <b>your stroke</b> over the <b>last {{3or6Months}}</b>`,
          itemType:"data-item", dataItemId:"hsr_PartnerNumOfDays", dataItemValue:"",
          dataType:"smallint", length:false,
          prefix:'', suffix:'days',
          inputmode:'numeric',
          missingDataExclude:false,
          hasLookUpTable:false,
          validationRules:[this.smallintRule,(v) => this.numberRangeRule(v,0,182),],
          controlEnabled:false,
          customError:false,
          customErrorMessage:'',
        },
      ]
    }, tbFrmStudyResults:{
      crfTitle: "12-month Questionnaire - Study Results",
      tableName: "tbFrmStudyResults",
      timePointDataItem: "srs_DummyTimePoint",
      dataItems:[
        {
          id:"1",
          itemType:"section-instruction",
          sectionTitle:``,
          position: 0,
          visible: true,
        }, {
          id:"2",
          itemType:"section-instruction",
          sectionTitle:`Study Results Details`,
          position: 0,
          visible: true,
        }, {
          fgId:"2", position: 0, visible: true,
          controlCaption:`Would you like to <b>receive</b> a <b>summary</b> of the <b>ReSTORe study results</b> when they are available?`,
          itemType:"data-item", dataItemId:"srs_ReceiveSummary", dataItemValue:"",
          dataType:"tinyint", length:false,
          prefix:'', suffix:'',
          inputmode:'text',
          missingDataExclude:false,
          hasLookUpTable:true,
          lookUpTable:[
            {value:1, text:"No"},
            {value:2, text:"Yes"},
          ],
          lookupIsRequired:true,
          validationRules:[this.requiredRule,],
          controlEnabled:true,
          customError:false,
          customErrorMessage:'',
        },
      ]
    },
  }
}
//DynamicCRF.vue-DataItemInfo END



//DynamicCRF.vue-SkipLogic BEGIN

export function applySkipLogic() {if (this.crfId=="tbFrmInterviewConsentForm") {
    let cDataItem, pDataItemValue, crf = this.crfs[this.crfId];
    return;
  } else if (this.crfId=="tbFrmYourOverallHealth") {
    let cDataItem, pDataItemValue, crf = this.crfs[this.crfId];
    pDataItemValue = crf.dataItems.find(m => m.dataItemId === "yoh_LiveAloneWithoutHelp").dataItemValue;
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="yoh_DoEverythingRightBeforeStroke");  
    if ([2].includes(pDataItemValue)) {
      this.applyRequiredWhenEnabledRule(cDataItem);
      cDataItem.controlEnabled=true;              
    } else {
      this.removeRequiredWhenEnabledRule(cDataItem);
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="yoh_WalkWithoutHelp");  
    if ([1].includes(pDataItemValue)) {
      this.applyRequiredWhenEnabledRule(cDataItem);
      cDataItem.controlEnabled=true;              
    } else {
      this.removeRequiredWhenEnabledRule(cDataItem);
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    pDataItemValue = crf.dataItems.find(m => m.dataItemId === "yoh_DoEverythingRightBeforeStroke").dataItemValue;
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="yoh_CompletelyBackBeforeStroke");  
    if ([2].includes(pDataItemValue)) {
      this.applyRequiredWhenEnabledRule(cDataItem);
      cDataItem.controlEnabled=true;              
    } else {
      this.removeRequiredWhenEnabledRule(cDataItem);
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    pDataItemValue = crf.dataItems.find(m => m.dataItemId === "yoh_WalkWithoutHelp").dataItemValue;
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="yoh_SitUpInBedWithoutHelp");  
    if ([1].includes(pDataItemValue)) {
      this.applyRequiredWhenEnabledRule(cDataItem);
      cDataItem.controlEnabled=true;              
    } else {
      this.removeRequiredWhenEnabledRule(cDataItem);
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    return;
  } else if (this.crfId=="tbFrmQOL") {
    let cDataItem, pDataItemValue, crf = this.crfs[this.crfId];
    return;
  } else if (this.crfId=="tbFrmPROMISNeuro") {
    let cDataItem, pDataItemValue, crf = this.crfs[this.crfId];
    return;
  } else if (this.crfId=="tbFrmQoLEQ5D5L_EQ5D") {
    let cDataItem, pDataItemValue, crf = this.crfs[this.crfId];
    return;
  } else if (this.crfId=="tbFrmIPAQSF") {
    let cDataItem, pDataItemValue, crf = this.crfs[this.crfId];
    pDataItemValue = crf.dataItems.find(m => m.dataItemId === "ipa_VigorousDaysPerWeek").dataItemValue;
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="ipa_VigorousActivityTime");  
    if ([1,2,3,4,5,6,7].includes(pDataItemValue)) {
      cDataItem.controlEnabled=true;              
    } else {
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    pDataItemValue = crf.dataItems.find(m => m.dataItemId === "ipa_VigorousActivityTime").dataItemValue;
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="ipa_VigorousMinutesV2");  
    if ([2].includes(pDataItemValue)) {
      cDataItem.controlEnabled=true;              
    } else {
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    pDataItemValue = crf.dataItems.find(m => m.dataItemId === "ipa_ModerateDaysPerWeek").dataItemValue;
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="ipa_ModerateActivityTime");  
    if ([1,2,3,4,5,6,7].includes(pDataItemValue)) {
      cDataItem.controlEnabled=true;              
    } else {
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    pDataItemValue = crf.dataItems.find(m => m.dataItemId === "ipa_ModerateActivityTime").dataItemValue;
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="ipa_ModerateMinutesV2");  
    if ([2].includes(pDataItemValue)) {
      cDataItem.controlEnabled=true;              
    } else {
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    pDataItemValue = crf.dataItems.find(m => m.dataItemId === "ipa_WalkingDaysPerWeek").dataItemValue;
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="ipa_WalkingTime");  
    if ([1,2,3,4,5,6,7].includes(pDataItemValue)) {
      cDataItem.controlEnabled=true;              
    } else {
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    pDataItemValue = crf.dataItems.find(m => m.dataItemId === "ipa_WalkingTime").dataItemValue;
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="ipa_WalkingMinutesV2");  
    if ([2].includes(pDataItemValue)) {
      cDataItem.controlEnabled=true;              
    } else {
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    pDataItemValue = crf.dataItems.find(m => m.dataItemId === "ipa_SittingTime").dataItemValue;
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="ipa_SittingMinutesV2");  
    if ([2].includes(pDataItemValue)) {
      cDataItem.controlEnabled=true;              
    } else {
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    return;
  } else if (this.crfId=="tbFrmChgOfContDtl") {
    let cDataItem, pDataItemValue, crf = this.crfs[this.crfId];
    pDataItemValue = crf.dataItems.find(m => m.dataItemId === "ccd_AddressChanged").dataItemValue;
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="ccd_HouseNameNumber");  
    if ([2].includes(pDataItemValue)) {
      this.applyRequiredWhenEnabledRule(cDataItem);
      cDataItem.controlEnabled=true;              
    } else {
      this.removeRequiredWhenEnabledRule(cDataItem);
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="ccd_Street");  
    if ([2].includes(pDataItemValue)) {
      this.applyRequiredWhenEnabledRule(cDataItem);
      cDataItem.controlEnabled=true;              
    } else {
      this.removeRequiredWhenEnabledRule(cDataItem);
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="ccd_TownCity");  
    if ([2].includes(pDataItemValue)) {
      this.applyRequiredWhenEnabledRule(cDataItem);
      cDataItem.controlEnabled=true;              
    } else {
      this.removeRequiredWhenEnabledRule(cDataItem);
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="ccd_County");  
    if ([2].includes(pDataItemValue)) {
      this.applyRequiredWhenEnabledRule(cDataItem);
      cDataItem.controlEnabled=true;              
    } else {
      this.removeRequiredWhenEnabledRule(cDataItem);
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="ccd_Country");  
    if ([2].includes(pDataItemValue)) {
      this.applyRequiredWhenEnabledRule(cDataItem);
      cDataItem.controlEnabled=true;              
    } else {
      this.removeRequiredWhenEnabledRule(cDataItem);
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="ccd_Postcode");  
    if ([2].includes(pDataItemValue)) {
      this.applyRequiredWhenEnabledRule(cDataItem);
      cDataItem.controlEnabled=true;              
    } else {
      this.removeRequiredWhenEnabledRule(cDataItem);
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    pDataItemValue = crf.dataItems.find(m => m.dataItemId === "ccd_MobileNumberChanged").dataItemValue;
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="ccd_MobileTelNo");  
    if ([2].includes(pDataItemValue)) {
      this.applyRequiredWhenEnabledRule(cDataItem);
      cDataItem.controlEnabled=true;              
    } else {
      this.removeRequiredWhenEnabledRule(cDataItem);
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    pDataItemValue = crf.dataItems.find(m => m.dataItemId === "ccd_EmailAddressChanged").dataItemValue;
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="ccd_Email");  
    if ([2].includes(pDataItemValue)) {
      this.applyRequiredWhenEnabledRule(cDataItem);
      cDataItem.controlEnabled=true;              
    } else {
      this.removeRequiredWhenEnabledRule(cDataItem);
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    pDataItemValue = crf.dataItems.find(m => m.dataItemId === "ccd_GPChanged").dataItemValue;
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="ccd_GPName");  
    if ([2].includes(pDataItemValue)) {
      this.applyRequiredWhenEnabledRule(cDataItem);
      cDataItem.controlEnabled=true;              
    } else {
      this.removeRequiredWhenEnabledRule(cDataItem);
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="ccd_GPPractice");  
    if ([2].includes(pDataItemValue)) {
      this.applyRequiredWhenEnabledRule(cDataItem);
      cDataItem.controlEnabled=true;              
    } else {
      this.removeRequiredWhenEnabledRule(cDataItem);
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="ccd_GPStreetAddress");  
    if ([2].includes(pDataItemValue)) {
      this.applyRequiredWhenEnabledRule(cDataItem);
      cDataItem.controlEnabled=true;              
    } else {
      this.removeRequiredWhenEnabledRule(cDataItem);
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="ccd_GPTownCity");  
    if ([2].includes(pDataItemValue)) {
      this.applyRequiredWhenEnabledRule(cDataItem);
      cDataItem.controlEnabled=true;              
    } else {
      this.removeRequiredWhenEnabledRule(cDataItem);
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="ccd_GPPostcode");  
    if ([2].includes(pDataItemValue)) {
      this.applyRequiredWhenEnabledRule(cDataItem);
      cDataItem.controlEnabled=true;              
    } else {
      this.removeRequiredWhenEnabledRule(cDataItem);
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="ccd_GPPhoneNo");  
    if ([2].includes(pDataItemValue)) {
      this.applyRequiredWhenEnabledRule(cDataItem);
      cDataItem.controlEnabled=true;              
    } else {
      this.removeRequiredWhenEnabledRule(cDataItem);
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    pDataItemValue = crf.dataItems.find(m => m.dataItemId === "ccd_NextOfKinChanged").dataItemValue;
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="ccd_NextOfKinFirstName");  
    if ([2].includes(pDataItemValue)) {
      this.applyRequiredWhenEnabledRule(cDataItem);
      cDataItem.controlEnabled=true;              
    } else {
      this.removeRequiredWhenEnabledRule(cDataItem);
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="ccd_NextOfKinSurname");  
    if ([2].includes(pDataItemValue)) {
      this.applyRequiredWhenEnabledRule(cDataItem);
      cDataItem.controlEnabled=true;              
    } else {
      this.removeRequiredWhenEnabledRule(cDataItem);
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="ccd_NextOfKinPhoneNo");  
    if ([2].includes(pDataItemValue)) {
      this.applyRequiredWhenEnabledRule(cDataItem);
      cDataItem.controlEnabled=true;              
    } else {
      this.removeRequiredWhenEnabledRule(cDataItem);
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    return;
  } else if (this.crfId=="tbFrmRecentMedicalProblems") {
    let cDataItem, pDataItemValue, crf = this.crfs[this.crfId];
    pDataItemValue = crf.dataItems.find(m => m.dataItemId === "rmp_NextOfKinChanged").dataItemValue;
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="rmp_NextOfKinChangedSpecify");  
    if ([2].includes(pDataItemValue)) {
      this.applyRequiredWhenEnabledRule(cDataItem);
      cDataItem.controlEnabled=true;              
    } else {
      this.removeRequiredWhenEnabledRule(cDataItem);
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    return;
  } else if (this.crfId=="tbFrmHealthSocialCareResourceUse") {
    let cDataItem, pDataItemValue, crf = this.crfs[this.crfId];
    pDataItemValue = crf.dataItems.find(m => m.dataItemId === "hsr_StayedOvernightHospital").dataItemValue;
    pDataItemValue = crf.dataItems.find(m => m.dataItemId === "hsr_StayedOvernightHospital").dataItemValue;
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="ich_NumOfDays__1");  
    if ([2].includes(pDataItemValue)) {
      cDataItem.controlEnabled=true;              
    } else {
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="ich_TypeOfWard__1");  
    if ([2].includes(pDataItemValue)) {
      cDataItem.controlEnabled=true;              
    } else {
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="hsr_StayedOvernightHospitalContinued__2");  
    if ([2].includes(pDataItemValue)) {
      this.applyRequiredWhenEnabledRule(cDataItem);
      cDataItem.controlEnabled=true;              
    } else {
      this.removeRequiredWhenEnabledRule(cDataItem);
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    pDataItemValue = crf.dataItems.find(m => m.dataItemId === "hsr_StayedOvernightHospitalContinued__2").dataItemValue;
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="ich_NumOfDays__2");  
    if ([2].includes(pDataItemValue)) {
      cDataItem.controlEnabled=true;              
    } else {
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="ich_TypeOfWard__2");  
    if ([2].includes(pDataItemValue)) {
      cDataItem.controlEnabled=true;              
    } else {
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="hsr_StayedOvernightHospitalContinued__3");  
    if ([2].includes(pDataItemValue)) {
      this.applyRequiredWhenEnabledRule(cDataItem);
      cDataItem.controlEnabled=true;              
    } else {
      this.removeRequiredWhenEnabledRule(cDataItem);
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    pDataItemValue = crf.dataItems.find(m => m.dataItemId === "hsr_StayedOvernightHospitalContinued__3").dataItemValue;
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="ich_NumOfDays__3");  
    if ([2].includes(pDataItemValue)) {
      cDataItem.controlEnabled=true;              
    } else {
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="ich_TypeOfWard__3");  
    if ([2].includes(pDataItemValue)) {
      cDataItem.controlEnabled=true;              
    } else {
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="hsr_StayedOvernightHospitalContinued__4");  
    if ([2].includes(pDataItemValue)) {
      this.applyRequiredWhenEnabledRule(cDataItem);
      cDataItem.controlEnabled=true;              
    } else {
      this.removeRequiredWhenEnabledRule(cDataItem);
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    pDataItemValue = crf.dataItems.find(m => m.dataItemId === "hsr_StayedOvernightHospitalContinued__4").dataItemValue;
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="ich_NumOfDays__4");  
    if ([2].includes(pDataItemValue)) {
      cDataItem.controlEnabled=true;              
    } else {
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="ich_TypeOfWard__4");  
    if ([2].includes(pDataItemValue)) {
      cDataItem.controlEnabled=true;              
    } else {
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="hsr_StayedOvernightHospitalContinued__5");  
    if ([2].includes(pDataItemValue)) {
      this.applyRequiredWhenEnabledRule(cDataItem);
      cDataItem.controlEnabled=true;              
    } else {
      this.removeRequiredWhenEnabledRule(cDataItem);
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    pDataItemValue = crf.dataItems.find(m => m.dataItemId === "hsr_StayedOvernightHospitalContinued__5").dataItemValue;
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="ich_NumOfDays__5");  
    if ([2].includes(pDataItemValue)) {
      cDataItem.controlEnabled=true;              
    } else {
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="ich_TypeOfWard__5");  
    if ([2].includes(pDataItemValue)) {
      cDataItem.controlEnabled=true;              
    } else {
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="hsr_StayedOvernightHospitalContinued__6");  
    if ([2].includes(pDataItemValue)) {
      this.applyRequiredWhenEnabledRule(cDataItem);
      cDataItem.controlEnabled=true;              
    } else {
      this.removeRequiredWhenEnabledRule(cDataItem);
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    pDataItemValue = crf.dataItems.find(m => m.dataItemId === "hsr_StayedOvernightHospitalContinued__6").dataItemValue;
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="ich_NumOfDays__6");  
    if ([2].includes(pDataItemValue)) {
      cDataItem.controlEnabled=true;              
    } else {
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="ich_TypeOfWard__6");  
    if ([2].includes(pDataItemValue)) {
      cDataItem.controlEnabled=true;              
    } else {
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="hsr_StayedOvernightHospitalContinued__7");  
    if ([2].includes(pDataItemValue)) {
      this.applyRequiredWhenEnabledRule(cDataItem);
      cDataItem.controlEnabled=true;              
    } else {
      this.removeRequiredWhenEnabledRule(cDataItem);
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    pDataItemValue = crf.dataItems.find(m => m.dataItemId === "hsr_StayedOvernightHospitalContinued__7").dataItemValue;
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="ich_NumOfDays__7");  
    if ([2].includes(pDataItemValue)) {
      cDataItem.controlEnabled=true;              
    } else {
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="ich_TypeOfWard__7");  
    if ([2].includes(pDataItemValue)) {
      cDataItem.controlEnabled=true;              
    } else {
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="hsr_StayedOvernightHospitalContinued__8");  
    if ([2].includes(pDataItemValue)) {
      this.applyRequiredWhenEnabledRule(cDataItem);
      cDataItem.controlEnabled=true;              
    } else {
      this.removeRequiredWhenEnabledRule(cDataItem);
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    pDataItemValue = crf.dataItems.find(m => m.dataItemId === "hsr_StayedOvernightHospitalContinued__8").dataItemValue;
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="ich_NumOfDays__8");  
    if ([2].includes(pDataItemValue)) {
      cDataItem.controlEnabled=true;              
    } else {
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="ich_TypeOfWard__8");  
    if ([2].includes(pDataItemValue)) {
      cDataItem.controlEnabled=true;              
    } else {
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="hsr_StayedOvernightHospitalContinued__9");  
    if ([2].includes(pDataItemValue)) {
      this.applyRequiredWhenEnabledRule(cDataItem);
      cDataItem.controlEnabled=true;              
    } else {
      this.removeRequiredWhenEnabledRule(cDataItem);
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    pDataItemValue = crf.dataItems.find(m => m.dataItemId === "hsr_StayedOvernightHospitalContinued__9").dataItemValue;
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="ich_NumOfDays__9");  
    if ([2].includes(pDataItemValue)) {
      cDataItem.controlEnabled=true;              
    } else {
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="ich_TypeOfWard__9");  
    if ([2].includes(pDataItemValue)) {
      cDataItem.controlEnabled=true;              
    } else {
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="hsr_StayedOvernightHospitalContinued__10");  
    if ([2].includes(pDataItemValue)) {
      this.applyRequiredWhenEnabledRule(cDataItem);
      cDataItem.controlEnabled=true;              
    } else {
      this.removeRequiredWhenEnabledRule(cDataItem);
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    pDataItemValue = crf.dataItems.find(m => m.dataItemId === "hsr_StayedOvernightHospitalContinued__10").dataItemValue;
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="ich_NumOfDays__10");  
    if ([2].includes(pDataItemValue)) {
      cDataItem.controlEnabled=true;              
    } else {
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="ich_TypeOfWard__10");  
    if ([2].includes(pDataItemValue)) {
      cDataItem.controlEnabled=true;              
    } else {
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    pDataItemValue = crf.dataItems.find(m => m.dataItemId === "hsr_VisitHospitalOutpatient").dataItemValue;
    pDataItemValue = crf.dataItems.find(m => m.dataItemId === "hsr_VisitHospitalOutpatient").dataItemValue;
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="ohv_Reason__1");  
    if ([2].includes(pDataItemValue)) {
      cDataItem.controlEnabled=true;              
    } else {
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="hsr_VisitHospitalOutpatientContinued__2");  
    if ([2].includes(pDataItemValue)) {
      this.applyRequiredWhenEnabledRule(cDataItem);
      cDataItem.controlEnabled=true;              
    } else {
      this.removeRequiredWhenEnabledRule(cDataItem);
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    pDataItemValue = crf.dataItems.find(m => m.dataItemId === "hsr_VisitHospitalOutpatientContinued__2").dataItemValue;
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="ohv_Reason__2");  
    if ([2].includes(pDataItemValue)) {
      cDataItem.controlEnabled=true;              
    } else {
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="hsr_VisitHospitalOutpatientContinued__3");  
    if ([2].includes(pDataItemValue)) {
      this.applyRequiredWhenEnabledRule(cDataItem);
      cDataItem.controlEnabled=true;              
    } else {
      this.removeRequiredWhenEnabledRule(cDataItem);
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    pDataItemValue = crf.dataItems.find(m => m.dataItemId === "hsr_VisitHospitalOutpatientContinued__3").dataItemValue;
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="ohv_Reason__3");  
    if ([2].includes(pDataItemValue)) {
      cDataItem.controlEnabled=true;              
    } else {
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="hsr_VisitHospitalOutpatientContinued__4");  
    if ([2].includes(pDataItemValue)) {
      this.applyRequiredWhenEnabledRule(cDataItem);
      cDataItem.controlEnabled=true;              
    } else {
      this.removeRequiredWhenEnabledRule(cDataItem);
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    pDataItemValue = crf.dataItems.find(m => m.dataItemId === "hsr_VisitHospitalOutpatientContinued__4").dataItemValue;
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="ohv_Reason__4");  
    if ([2].includes(pDataItemValue)) {
      cDataItem.controlEnabled=true;              
    } else {
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="hsr_VisitHospitalOutpatientContinued__5");  
    if ([2].includes(pDataItemValue)) {
      this.applyRequiredWhenEnabledRule(cDataItem);
      cDataItem.controlEnabled=true;              
    } else {
      this.removeRequiredWhenEnabledRule(cDataItem);
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    pDataItemValue = crf.dataItems.find(m => m.dataItemId === "hsr_VisitHospitalOutpatientContinued__5").dataItemValue;
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="ohv_Reason__5");  
    if ([2].includes(pDataItemValue)) {
      cDataItem.controlEnabled=true;              
    } else {
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="hsr_VisitHospitalOutpatientContinued__6");  
    if ([2].includes(pDataItemValue)) {
      this.applyRequiredWhenEnabledRule(cDataItem);
      cDataItem.controlEnabled=true;              
    } else {
      this.removeRequiredWhenEnabledRule(cDataItem);
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    pDataItemValue = crf.dataItems.find(m => m.dataItemId === "hsr_VisitHospitalOutpatientContinued__6").dataItemValue;
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="ohv_Reason__6");  
    if ([2].includes(pDataItemValue)) {
      cDataItem.controlEnabled=true;              
    } else {
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="hsr_VisitHospitalOutpatientContinued__7");  
    if ([2].includes(pDataItemValue)) {
      this.applyRequiredWhenEnabledRule(cDataItem);
      cDataItem.controlEnabled=true;              
    } else {
      this.removeRequiredWhenEnabledRule(cDataItem);
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    pDataItemValue = crf.dataItems.find(m => m.dataItemId === "hsr_VisitHospitalOutpatientContinued__7").dataItemValue;
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="ohv_Reason__7");  
    if ([2].includes(pDataItemValue)) {
      cDataItem.controlEnabled=true;              
    } else {
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="hsr_VisitHospitalOutpatientContinued__8");  
    if ([2].includes(pDataItemValue)) {
      this.applyRequiredWhenEnabledRule(cDataItem);
      cDataItem.controlEnabled=true;              
    } else {
      this.removeRequiredWhenEnabledRule(cDataItem);
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    pDataItemValue = crf.dataItems.find(m => m.dataItemId === "hsr_VisitHospitalOutpatientContinued__8").dataItemValue;
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="ohv_Reason__8");  
    if ([2].includes(pDataItemValue)) {
      cDataItem.controlEnabled=true;              
    } else {
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="hsr_VisitHospitalOutpatientContinued__9");  
    if ([2].includes(pDataItemValue)) {
      this.applyRequiredWhenEnabledRule(cDataItem);
      cDataItem.controlEnabled=true;              
    } else {
      this.removeRequiredWhenEnabledRule(cDataItem);
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    pDataItemValue = crf.dataItems.find(m => m.dataItemId === "hsr_VisitHospitalOutpatientContinued__9").dataItemValue;
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="ohv_Reason__9");  
    if ([2].includes(pDataItemValue)) {
      cDataItem.controlEnabled=true;              
    } else {
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="hsr_VisitHospitalOutpatientContinued__10");  
    if ([2].includes(pDataItemValue)) {
      this.applyRequiredWhenEnabledRule(cDataItem);
      cDataItem.controlEnabled=true;              
    } else {
      this.removeRequiredWhenEnabledRule(cDataItem);
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    pDataItemValue = crf.dataItems.find(m => m.dataItemId === "hsr_VisitHospitalOutpatientContinued__10").dataItemValue;
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="ohv_Reason__10");  
    if ([2].includes(pDataItemValue)) {
      cDataItem.controlEnabled=true;              
    } else {
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    pDataItemValue = crf.dataItems.find(m => m.dataItemId === "hsr_ToAE").dataItemValue;
    pDataItemValue = crf.dataItems.find(m => m.dataItemId === "hsr_ToAE").dataItemValue;
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="aev_Reason__1");  
    if ([2].includes(pDataItemValue)) {
      cDataItem.controlEnabled=true;              
    } else {
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="hsr_ToAEContinued__2");  
    if ([2].includes(pDataItemValue)) {
      this.applyRequiredWhenEnabledRule(cDataItem);
      cDataItem.controlEnabled=true;              
    } else {
      this.removeRequiredWhenEnabledRule(cDataItem);
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    pDataItemValue = crf.dataItems.find(m => m.dataItemId === "hsr_ToAEContinued__2").dataItemValue;
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="aev_Reason__2");  
    if ([2].includes(pDataItemValue)) {
      cDataItem.controlEnabled=true;              
    } else {
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="hsr_ToAEContinued__3");  
    if ([2].includes(pDataItemValue)) {
      this.applyRequiredWhenEnabledRule(cDataItem);
      cDataItem.controlEnabled=true;              
    } else {
      this.removeRequiredWhenEnabledRule(cDataItem);
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    pDataItemValue = crf.dataItems.find(m => m.dataItemId === "hsr_ToAEContinued__3").dataItemValue;
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="aev_Reason__3");  
    if ([2].includes(pDataItemValue)) {
      cDataItem.controlEnabled=true;              
    } else {
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="hsr_ToAEContinued__4");  
    if ([2].includes(pDataItemValue)) {
      this.applyRequiredWhenEnabledRule(cDataItem);
      cDataItem.controlEnabled=true;              
    } else {
      this.removeRequiredWhenEnabledRule(cDataItem);
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    pDataItemValue = crf.dataItems.find(m => m.dataItemId === "hsr_ToAEContinued__4").dataItemValue;
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="aev_Reason__4");  
    if ([2].includes(pDataItemValue)) {
      cDataItem.controlEnabled=true;              
    } else {
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="hsr_ToAEContinued__5");  
    if ([2].includes(pDataItemValue)) {
      this.applyRequiredWhenEnabledRule(cDataItem);
      cDataItem.controlEnabled=true;              
    } else {
      this.removeRequiredWhenEnabledRule(cDataItem);
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    pDataItemValue = crf.dataItems.find(m => m.dataItemId === "hsr_ToAEContinued__5").dataItemValue;
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="aev_Reason__5");  
    if ([2].includes(pDataItemValue)) {
      cDataItem.controlEnabled=true;              
    } else {
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="hsr_ToAEContinued__6");  
    if ([2].includes(pDataItemValue)) {
      this.applyRequiredWhenEnabledRule(cDataItem);
      cDataItem.controlEnabled=true;              
    } else {
      this.removeRequiredWhenEnabledRule(cDataItem);
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    pDataItemValue = crf.dataItems.find(m => m.dataItemId === "hsr_ToAEContinued__6").dataItemValue;
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="aev_Reason__6");  
    if ([2].includes(pDataItemValue)) {
      cDataItem.controlEnabled=true;              
    } else {
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="hsr_ToAEContinued__7");  
    if ([2].includes(pDataItemValue)) {
      this.applyRequiredWhenEnabledRule(cDataItem);
      cDataItem.controlEnabled=true;              
    } else {
      this.removeRequiredWhenEnabledRule(cDataItem);
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    pDataItemValue = crf.dataItems.find(m => m.dataItemId === "hsr_ToAEContinued__7").dataItemValue;
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="aev_Reason__7");  
    if ([2].includes(pDataItemValue)) {
      cDataItem.controlEnabled=true;              
    } else {
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="hsr_ToAEContinued__8");  
    if ([2].includes(pDataItemValue)) {
      this.applyRequiredWhenEnabledRule(cDataItem);
      cDataItem.controlEnabled=true;              
    } else {
      this.removeRequiredWhenEnabledRule(cDataItem);
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    pDataItemValue = crf.dataItems.find(m => m.dataItemId === "hsr_ToAEContinued__8").dataItemValue;
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="aev_Reason__8");  
    if ([2].includes(pDataItemValue)) {
      cDataItem.controlEnabled=true;              
    } else {
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="hsr_ToAEContinued__9");  
    if ([2].includes(pDataItemValue)) {
      this.applyRequiredWhenEnabledRule(cDataItem);
      cDataItem.controlEnabled=true;              
    } else {
      this.removeRequiredWhenEnabledRule(cDataItem);
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    pDataItemValue = crf.dataItems.find(m => m.dataItemId === "hsr_ToAEContinued__9").dataItemValue;
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="aev_Reason__9");  
    if ([2].includes(pDataItemValue)) {
      cDataItem.controlEnabled=true;              
    } else {
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="hsr_ToAEContinued__10");  
    if ([2].includes(pDataItemValue)) {
      this.applyRequiredWhenEnabledRule(cDataItem);
      cDataItem.controlEnabled=true;              
    } else {
      this.removeRequiredWhenEnabledRule(cDataItem);
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    pDataItemValue = crf.dataItems.find(m => m.dataItemId === "hsr_ToAEContinued__10").dataItemValue;
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="aev_Reason__10");  
    if ([2].includes(pDataItemValue)) {
      cDataItem.controlEnabled=true;              
    } else {
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    pDataItemValue = crf.dataItems.find(m => m.dataItemId === "hsr_NursingHomeCareDayCareVisit").dataItemValue;
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="hsr_NursingHomeCareDaysAdmitted");  
    if ([2].includes(pDataItemValue)) {
      cDataItem.controlEnabled=true;              
    } else {
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="hsr_NursingHomeCareNumOfVisits");  
    if ([2].includes(pDataItemValue)) {
      cDataItem.controlEnabled=true;              
    } else {
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    pDataItemValue = crf.dataItems.find(m => m.dataItemId === "hsr_SeenHealthProfessionals").dataItemValue;
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="hsr_GPSurgeryVisits");  
    if ([2].includes(pDataItemValue)) {
      cDataItem.controlEnabled=true;              
    } else {
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="hsr_GPHomeVisits");  
    if ([2].includes(pDataItemValue)) {
      cDataItem.controlEnabled=true;              
    } else {
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="hsr_GPTelContacts");  
    if ([2].includes(pDataItemValue)) {
      cDataItem.controlEnabled=true;              
    } else {
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="hsr_GPVideoConsultation");  
    if ([2].includes(pDataItemValue)) {
      cDataItem.controlEnabled=true;              
    } else {
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="hsr_PracticeNurseContacts");  
    if ([2].includes(pDataItemValue)) {
      cDataItem.controlEnabled=true;              
    } else {
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="hsr_DistrictNurseContacts");  
    if ([2].includes(pDataItemValue)) {
      cDataItem.controlEnabled=true;              
    } else {
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="hsr_PhysiotherapyContactsVisits");  
    if ([2].includes(pDataItemValue)) {
      cDataItem.controlEnabled=true;              
    } else {
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="hsr_CallsToNHSDirect");  
    if ([2].includes(pDataItemValue)) {
      cDataItem.controlEnabled=true;              
    } else {
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="hsr_CallsToAmbulance");  
    if ([2].includes(pDataItemValue)) {
      cDataItem.controlEnabled=true;              
    } else {
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="hsr_OccupationalTherapyContacts");  
    if ([2].includes(pDataItemValue)) {
      cDataItem.controlEnabled=true;              
    } else {
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="hsr_SpeechLanguageTherapy");  
    if ([2].includes(pDataItemValue)) {
      cDataItem.controlEnabled=true;              
    } else {
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="hsr_PsychologyServices");  
    if ([2].includes(pDataItemValue)) {
      cDataItem.controlEnabled=true;              
    } else {
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="hsr_TypeOfHealthProfOther");  
    if ([2].includes(pDataItemValue)) {
      cDataItem.controlEnabled=true;              
    } else {
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    pDataItemValue = crf.dataItems.find(m => m.dataItemId === "hsr_GPSurgeryVisits").dataItemValue;
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="hsr_GPSurgeryVisitsNumOfVisits");  
    if ([2].includes(pDataItemValue)) {
      cDataItem.controlEnabled=true;              
    } else {
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="hsr_GPSurgeryVisitsAverageTimeSpent");  
    if ([2].includes(pDataItemValue)) {
      cDataItem.controlEnabled=true;              
    } else {
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    pDataItemValue = crf.dataItems.find(m => m.dataItemId === "hsr_GPHomeVisits").dataItemValue;
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="hsr_GPHomeVisitsNumOfVisits");  
    if ([2].includes(pDataItemValue)) {
      cDataItem.controlEnabled=true;              
    } else {
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="hsr_GPHomeVisitsAverageTimeSpent");  
    if ([2].includes(pDataItemValue)) {
      cDataItem.controlEnabled=true;              
    } else {
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    pDataItemValue = crf.dataItems.find(m => m.dataItemId === "hsr_GPTelContacts").dataItemValue;
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="hsr_GPTelContactsNumOfVisits");  
    if ([2].includes(pDataItemValue)) {
      cDataItem.controlEnabled=true;              
    } else {
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="hsr_GPTelContactsAverageTimeSpent");  
    if ([2].includes(pDataItemValue)) {
      cDataItem.controlEnabled=true;              
    } else {
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    pDataItemValue = crf.dataItems.find(m => m.dataItemId === "hsr_GPVideoConsultation").dataItemValue;
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="hsr_GPVideoConsultationNumOfVisits");  
    if ([2].includes(pDataItemValue)) {
      cDataItem.controlEnabled=true;              
    } else {
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="hsr_GPVideoConsultationAverageTimeSpent");  
    if ([2].includes(pDataItemValue)) {
      cDataItem.controlEnabled=true;              
    } else {
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    pDataItemValue = crf.dataItems.find(m => m.dataItemId === "hsr_PracticeNurseContacts").dataItemValue;
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="hsr_PracticeNurseContactsNumOfVisits");  
    if ([2].includes(pDataItemValue)) {
      cDataItem.controlEnabled=true;              
    } else {
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="hsr_PracticeNurseContactsAverageTimeSpent");  
    if ([2].includes(pDataItemValue)) {
      cDataItem.controlEnabled=true;              
    } else {
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    pDataItemValue = crf.dataItems.find(m => m.dataItemId === "hsr_DistrictNurseContacts").dataItemValue;
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="hsr_DistrictNurseContactsNumOfVisits");  
    if ([2].includes(pDataItemValue)) {
      cDataItem.controlEnabled=true;              
    } else {
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="hsr_DistrictNurseContactsAverageTimeSpent");  
    if ([2].includes(pDataItemValue)) {
      cDataItem.controlEnabled=true;              
    } else {
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    pDataItemValue = crf.dataItems.find(m => m.dataItemId === "hsr_PhysiotherapyContactsVisits").dataItemValue;
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="hsr_PhysiotherapyContactsVisitsNumOfVisits");  
    if ([2].includes(pDataItemValue)) {
      cDataItem.controlEnabled=true;              
    } else {
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="hsr_PhysiotherapyContactsVisitsAverageTimeSpent");  
    if ([2].includes(pDataItemValue)) {
      cDataItem.controlEnabled=true;              
    } else {
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    pDataItemValue = crf.dataItems.find(m => m.dataItemId === "hsr_CallsToNHSDirect").dataItemValue;
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="hsr_CallsToNHSDirectNumOfVisits");  
    if ([2].includes(pDataItemValue)) {
      cDataItem.controlEnabled=true;              
    } else {
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="hsr_CallsToNHSDirectAverageTimeSpent");  
    if ([2].includes(pDataItemValue)) {
      cDataItem.controlEnabled=true;              
    } else {
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    pDataItemValue = crf.dataItems.find(m => m.dataItemId === "hsr_CallsToAmbulance").dataItemValue;
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="hsr_CallsToAmbulanceNumOfVisits");  
    if ([2].includes(pDataItemValue)) {
      cDataItem.controlEnabled=true;              
    } else {
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="hsr_CallsToAmbulanceAverageTimeSpent");  
    if ([2].includes(pDataItemValue)) {
      cDataItem.controlEnabled=true;              
    } else {
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    pDataItemValue = crf.dataItems.find(m => m.dataItemId === "hsr_OccupationalTherapyContacts").dataItemValue;
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="hsr_OccupationalTherapyContactsNumOfVisits");  
    if ([2].includes(pDataItemValue)) {
      cDataItem.controlEnabled=true;              
    } else {
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="hsr_OccupationalTherapyContactsAverageTimeSpent");  
    if ([2].includes(pDataItemValue)) {
      cDataItem.controlEnabled=true;              
    } else {
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    pDataItemValue = crf.dataItems.find(m => m.dataItemId === "hsr_SpeechLanguageTherapy").dataItemValue;
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="hsr_SpeechLanguageTherapyNumOfVisits");  
    if ([2].includes(pDataItemValue)) {
      cDataItem.controlEnabled=true;              
    } else {
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="hsr_SpeechLanguageTherapyAverageTimeSpent");  
    if ([2].includes(pDataItemValue)) {
      cDataItem.controlEnabled=true;              
    } else {
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    pDataItemValue = crf.dataItems.find(m => m.dataItemId === "hsr_PsychologyServices").dataItemValue;
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="hsr_PsychologyServicesNumOfVisits");  
    if ([2].includes(pDataItemValue)) {
      cDataItem.controlEnabled=true;              
    } else {
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="hsr_PsychologyServicesAverageTimeSpent");  
    if ([2].includes(pDataItemValue)) {
      cDataItem.controlEnabled=true;              
    } else {
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    pDataItemValue = crf.dataItems.find(m => m.dataItemId === "hsr_TypeOfHealthProfOther").dataItemValue;
    pDataItemValue = crf.dataItems.find(m => m.dataItemId === "hsr_TypeOfHealthProfOther").dataItemValue;
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="hpo_TypeOfHealthProfessionals__1");  
    if ([2].includes(pDataItemValue)) {
      cDataItem.controlEnabled=true;              
    } else {
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="hpo_NumOfVisits__1");  
    if ([2].includes(pDataItemValue)) {
      cDataItem.controlEnabled=true;              
    } else {
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="hpo_AverageTimeSpent__1");  
    if ([2].includes(pDataItemValue)) {
      cDataItem.controlEnabled=true;              
    } else {
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="hsr_TypeOfHealthProfOtherContinued__2");  
    if ([2].includes(pDataItemValue)) {
      this.applyRequiredWhenEnabledRule(cDataItem);
      cDataItem.controlEnabled=true;              
    } else {
      this.removeRequiredWhenEnabledRule(cDataItem);
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    pDataItemValue = crf.dataItems.find(m => m.dataItemId === "hsr_TypeOfHealthProfOtherContinued__2").dataItemValue;
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="hpo_TypeOfHealthProfessionals__2");  
    if ([2].includes(pDataItemValue)) {
      cDataItem.controlEnabled=true;              
    } else {
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="hpo_NumOfVisits__2");  
    if ([2].includes(pDataItemValue)) {
      cDataItem.controlEnabled=true;              
    } else {
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="hpo_AverageTimeSpent__2");  
    if ([2].includes(pDataItemValue)) {
      cDataItem.controlEnabled=true;              
    } else {
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="hsr_TypeOfHealthProfOtherContinued__3");  
    if ([2].includes(pDataItemValue)) {
      this.applyRequiredWhenEnabledRule(cDataItem);
      cDataItem.controlEnabled=true;              
    } else {
      this.removeRequiredWhenEnabledRule(cDataItem);
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    pDataItemValue = crf.dataItems.find(m => m.dataItemId === "hsr_TypeOfHealthProfOtherContinued__3").dataItemValue;
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="hpo_TypeOfHealthProfessionals__3");  
    if ([2].includes(pDataItemValue)) {
      cDataItem.controlEnabled=true;              
    } else {
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="hpo_NumOfVisits__3");  
    if ([2].includes(pDataItemValue)) {
      cDataItem.controlEnabled=true;              
    } else {
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="hpo_AverageTimeSpent__3");  
    if ([2].includes(pDataItemValue)) {
      cDataItem.controlEnabled=true;              
    } else {
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    pDataItemValue = crf.dataItems.find(m => m.dataItemId === "hsr_HaveSocialServices").dataItemValue;
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="hsr_MealsOnWheels");  
    if ([2].includes(pDataItemValue)) {
      cDataItem.controlEnabled=true;              
    } else {
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="hsr_LaundryService");  
    if ([2].includes(pDataItemValue)) {
      cDataItem.controlEnabled=true;              
    } else {
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="hsr_SocialWorkerContacts");  
    if ([2].includes(pDataItemValue)) {
      cDataItem.controlEnabled=true;              
    } else {
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="hsr_CareWorkerContacts");  
    if ([2].includes(pDataItemValue)) {
      cDataItem.controlEnabled=true;              
    } else {
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="hsr_HaveSocialServicesOther");  
    if ([2].includes(pDataItemValue)) {
      cDataItem.controlEnabled=true;              
    } else {
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    pDataItemValue = crf.dataItems.find(m => m.dataItemId === "hsr_MealsOnWheels").dataItemValue;
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="hsr_MealsOnWheelsNumOfVisits");  
    if ([2].includes(pDataItemValue)) {
      cDataItem.controlEnabled=true;              
    } else {
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="hsr_MealsOnWheelsAverageTimeSpent");  
    if ([2].includes(pDataItemValue)) {
      cDataItem.controlEnabled=true;              
    } else {
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    pDataItemValue = crf.dataItems.find(m => m.dataItemId === "hsr_LaundryService").dataItemValue;
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="hsr_LaundryServiceNumOfVisits");  
    if ([2].includes(pDataItemValue)) {
      cDataItem.controlEnabled=true;              
    } else {
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="hsr_LaundryServiceAverageTimeSpent");  
    if ([2].includes(pDataItemValue)) {
      cDataItem.controlEnabled=true;              
    } else {
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    pDataItemValue = crf.dataItems.find(m => m.dataItemId === "hsr_SocialWorkerContacts").dataItemValue;
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="hsr_SocialWorkerContactsNumOfVisits");  
    if ([2].includes(pDataItemValue)) {
      cDataItem.controlEnabled=true;              
    } else {
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="hsr_SocialWorkerContactsAverageTimeSpent");  
    if ([2].includes(pDataItemValue)) {
      cDataItem.controlEnabled=true;              
    } else {
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    pDataItemValue = crf.dataItems.find(m => m.dataItemId === "hsr_CareWorkerContacts").dataItemValue;
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="hsr_CareWorkerContactsNumOfVisits");  
    if ([2].includes(pDataItemValue)) {
      cDataItem.controlEnabled=true;              
    } else {
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="hsr_CareWorkerContactsAverageTimeSpent");  
    if ([2].includes(pDataItemValue)) {
      cDataItem.controlEnabled=true;              
    } else {
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    pDataItemValue = crf.dataItems.find(m => m.dataItemId === "hsr_HaveSocialServicesOther").dataItemValue;
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="hsr_HaveSocialServicesOtherSpecify");  
    if ([2].includes(pDataItemValue)) {
      cDataItem.controlEnabled=true;              
    } else {
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="hsr_HaveSocialServicesOtherNumOfVisits");  
    if ([2].includes(pDataItemValue)) {
      cDataItem.controlEnabled=true;              
    } else {
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="hsr_HaveSocialServicesOtherAverageTimeSpent");  
    if ([2].includes(pDataItemValue)) {
      cDataItem.controlEnabled=true;              
    } else {
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    pDataItemValue = crf.dataItems.find(m => m.dataItemId === "hsr_HaveUsedNewSpecialEquipment").dataItemValue;
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="hsr_HomeAdaptations");  
    if ([2].includes(pDataItemValue)) {
      cDataItem.controlEnabled=true;              
    } else {
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="hsr_BathingAids");  
    if ([2].includes(pDataItemValue)) {
      cDataItem.controlEnabled=true;              
    } else {
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="hsr_StairLifts");  
    if ([2].includes(pDataItemValue)) {
      cDataItem.controlEnabled=true;              
    } else {
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="hsr_Wheelchair");  
    if ([2].includes(pDataItemValue)) {
      cDataItem.controlEnabled=true;              
    } else {
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="hsr_WalkingAids");  
    if ([2].includes(pDataItemValue)) {
      cDataItem.controlEnabled=true;              
    } else {
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="hsr_FeedingAids");  
    if ([2].includes(pDataItemValue)) {
      cDataItem.controlEnabled=true;              
    } else {
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="hsr_HaveUsedNewSpecialEquipmentOther");  
    if ([2].includes(pDataItemValue)) {
      cDataItem.controlEnabled=true;              
    } else {
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    pDataItemValue = crf.dataItems.find(m => m.dataItemId === "hsr_HomeAdaptations").dataItemValue;
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="hsr_HomeAdaptationsWhoProvided");  
    if ([2].includes(pDataItemValue)) {
      cDataItem.controlEnabled=true;              
    } else {
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="hsr_HomeAdaptationsCost");  
    if ([2].includes(pDataItemValue)) {
      cDataItem.controlEnabled=true;              
    } else {
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    pDataItemValue = crf.dataItems.find(m => m.dataItemId === "hsr_BathingAids").dataItemValue;
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="hsr_BathingAidsWhoProvided");  
    if ([2].includes(pDataItemValue)) {
      cDataItem.controlEnabled=true;              
    } else {
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="hsr_BathingAidsCost");  
    if ([2].includes(pDataItemValue)) {
      cDataItem.controlEnabled=true;              
    } else {
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    pDataItemValue = crf.dataItems.find(m => m.dataItemId === "hsr_StairLifts").dataItemValue;
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="hsr_StairLiftsWhoProvided");  
    if ([2].includes(pDataItemValue)) {
      cDataItem.controlEnabled=true;              
    } else {
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="hsr_StairLiftsCost");  
    if ([2].includes(pDataItemValue)) {
      cDataItem.controlEnabled=true;              
    } else {
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    pDataItemValue = crf.dataItems.find(m => m.dataItemId === "hsr_Wheelchair").dataItemValue;
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="hsr_WheelchairWhoProvided");  
    if ([2].includes(pDataItemValue)) {
      cDataItem.controlEnabled=true;              
    } else {
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="hsr_WheelchairCost");  
    if ([2].includes(pDataItemValue)) {
      cDataItem.controlEnabled=true;              
    } else {
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    pDataItemValue = crf.dataItems.find(m => m.dataItemId === "hsr_WalkingAids").dataItemValue;
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="hsr_WalkingAidsWhoProvided");  
    if ([2].includes(pDataItemValue)) {
      cDataItem.controlEnabled=true;              
    } else {
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="hsr_WalkingAidsCost");  
    if ([2].includes(pDataItemValue)) {
      cDataItem.controlEnabled=true;              
    } else {
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    pDataItemValue = crf.dataItems.find(m => m.dataItemId === "hsr_FeedingAids").dataItemValue;
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="hsr_FeedingAidsWhoProvided");  
    if ([2].includes(pDataItemValue)) {
      cDataItem.controlEnabled=true;              
    } else {
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="hsr_FeedingAidsCost");  
    if ([2].includes(pDataItemValue)) {
      cDataItem.controlEnabled=true;              
    } else {
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    pDataItemValue = crf.dataItems.find(m => m.dataItemId === "hsr_HaveUsedNewSpecialEquipmentOther").dataItemValue;
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="hsr_HaveUsedNewSpecialEquipmentOtherSpecify");  
    if ([2].includes(pDataItemValue)) {
      cDataItem.controlEnabled=true;              
    } else {
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="hsr_HaveUsedNewSpecialEquipmentOtherWhoProvided");  
    if ([2].includes(pDataItemValue)) {
      cDataItem.controlEnabled=true;              
    } else {
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="hsr_HaveUsedNewSpecialEquipmentOtherCost");  
    if ([2].includes(pDataItemValue)) {
      cDataItem.controlEnabled=true;              
    } else {
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    pDataItemValue = crf.dataItems.find(m => m.dataItemId === "hsr_TakingNewPrescribedMedicine").dataItemValue;
    pDataItemValue = crf.dataItems.find(m => m.dataItemId === "hsr_TakingNewPrescribedMedicine").dataItemValue;
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="tpm_MedicineName__1");  
    if ([2].includes(pDataItemValue)) {
      cDataItem.controlEnabled=true;              
    } else {
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="tpm_TypeAndDose__1");  
    if ([2].includes(pDataItemValue)) {
      cDataItem.controlEnabled=true;              
    } else {
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="tpm_MedicineBoughtPrescribed__1");  
    if ([2].includes(pDataItemValue)) {
      cDataItem.controlEnabled=true;              
    } else {
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="tpm_NumOfTimesBoughtPrescribed__1");  
    if ([2].includes(pDataItemValue)) {
      cDataItem.controlEnabled=true;              
    } else {
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="hsr_TakingNewPrescribedMedicineContinued__2");  
    if ([2].includes(pDataItemValue)) {
      this.applyRequiredWhenEnabledRule(cDataItem);
      cDataItem.controlEnabled=true;              
    } else {
      this.removeRequiredWhenEnabledRule(cDataItem);
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    pDataItemValue = crf.dataItems.find(m => m.dataItemId === "hsr_TakingNewPrescribedMedicineContinued__2").dataItemValue;
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="tpm_MedicineName__2");  
    if ([2].includes(pDataItemValue)) {
      cDataItem.controlEnabled=true;              
    } else {
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="tpm_TypeAndDose__2");  
    if ([2].includes(pDataItemValue)) {
      cDataItem.controlEnabled=true;              
    } else {
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="tpm_MedicineBoughtPrescribed__2");  
    if ([2].includes(pDataItemValue)) {
      cDataItem.controlEnabled=true;              
    } else {
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="tpm_NumOfTimesBoughtPrescribed__2");  
    if ([2].includes(pDataItemValue)) {
      cDataItem.controlEnabled=true;              
    } else {
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="hsr_TakingNewPrescribedMedicineContinued__3");  
    if ([2].includes(pDataItemValue)) {
      this.applyRequiredWhenEnabledRule(cDataItem);
      cDataItem.controlEnabled=true;              
    } else {
      this.removeRequiredWhenEnabledRule(cDataItem);
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    pDataItemValue = crf.dataItems.find(m => m.dataItemId === "hsr_TakingNewPrescribedMedicineContinued__3").dataItemValue;
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="tpm_MedicineName__3");  
    if ([2].includes(pDataItemValue)) {
      cDataItem.controlEnabled=true;              
    } else {
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="tpm_TypeAndDose__3");  
    if ([2].includes(pDataItemValue)) {
      cDataItem.controlEnabled=true;              
    } else {
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="tpm_MedicineBoughtPrescribed__3");  
    if ([2].includes(pDataItemValue)) {
      cDataItem.controlEnabled=true;              
    } else {
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="tpm_NumOfTimesBoughtPrescribed__3");  
    if ([2].includes(pDataItemValue)) {
      cDataItem.controlEnabled=true;              
    } else {
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="hsr_TakingNewPrescribedMedicineContinued__4");  
    if ([2].includes(pDataItemValue)) {
      this.applyRequiredWhenEnabledRule(cDataItem);
      cDataItem.controlEnabled=true;              
    } else {
      this.removeRequiredWhenEnabledRule(cDataItem);
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    pDataItemValue = crf.dataItems.find(m => m.dataItemId === "hsr_TakingNewPrescribedMedicineContinued__4").dataItemValue;
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="tpm_MedicineName__4");  
    if ([2].includes(pDataItemValue)) {
      cDataItem.controlEnabled=true;              
    } else {
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="tpm_TypeAndDose__4");  
    if ([2].includes(pDataItemValue)) {
      cDataItem.controlEnabled=true;              
    } else {
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="tpm_MedicineBoughtPrescribed__4");  
    if ([2].includes(pDataItemValue)) {
      cDataItem.controlEnabled=true;              
    } else {
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="tpm_NumOfTimesBoughtPrescribed__4");  
    if ([2].includes(pDataItemValue)) {
      cDataItem.controlEnabled=true;              
    } else {
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="hsr_TakingNewPrescribedMedicineContinued__5");  
    if ([2].includes(pDataItemValue)) {
      this.applyRequiredWhenEnabledRule(cDataItem);
      cDataItem.controlEnabled=true;              
    } else {
      this.removeRequiredWhenEnabledRule(cDataItem);
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    pDataItemValue = crf.dataItems.find(m => m.dataItemId === "hsr_TakingNewPrescribedMedicineContinued__5").dataItemValue;
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="tpm_MedicineName__5");  
    if ([2].includes(pDataItemValue)) {
      cDataItem.controlEnabled=true;              
    } else {
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="tpm_TypeAndDose__5");  
    if ([2].includes(pDataItemValue)) {
      cDataItem.controlEnabled=true;              
    } else {
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="tpm_MedicineBoughtPrescribed__5");  
    if ([2].includes(pDataItemValue)) {
      cDataItem.controlEnabled=true;              
    } else {
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="tpm_NumOfTimesBoughtPrescribed__5");  
    if ([2].includes(pDataItemValue)) {
      cDataItem.controlEnabled=true;              
    } else {
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="hsr_TakingNewPrescribedMedicineContinued__6");  
    if ([2].includes(pDataItemValue)) {
      this.applyRequiredWhenEnabledRule(cDataItem);
      cDataItem.controlEnabled=true;              
    } else {
      this.removeRequiredWhenEnabledRule(cDataItem);
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    pDataItemValue = crf.dataItems.find(m => m.dataItemId === "hsr_TakingNewPrescribedMedicineContinued__6").dataItemValue;
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="tpm_MedicineName__6");  
    if ([2].includes(pDataItemValue)) {
      cDataItem.controlEnabled=true;              
    } else {
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="tpm_TypeAndDose__6");  
    if ([2].includes(pDataItemValue)) {
      cDataItem.controlEnabled=true;              
    } else {
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="tpm_MedicineBoughtPrescribed__6");  
    if ([2].includes(pDataItemValue)) {
      cDataItem.controlEnabled=true;              
    } else {
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="tpm_NumOfTimesBoughtPrescribed__6");  
    if ([2].includes(pDataItemValue)) {
      cDataItem.controlEnabled=true;              
    } else {
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="hsr_TakingNewPrescribedMedicineContinued__7");  
    if ([2].includes(pDataItemValue)) {
      this.applyRequiredWhenEnabledRule(cDataItem);
      cDataItem.controlEnabled=true;              
    } else {
      this.removeRequiredWhenEnabledRule(cDataItem);
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    pDataItemValue = crf.dataItems.find(m => m.dataItemId === "hsr_TakingNewPrescribedMedicineContinued__7").dataItemValue;
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="tpm_MedicineName__7");  
    if ([2].includes(pDataItemValue)) {
      cDataItem.controlEnabled=true;              
    } else {
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="tpm_TypeAndDose__7");  
    if ([2].includes(pDataItemValue)) {
      cDataItem.controlEnabled=true;              
    } else {
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="tpm_MedicineBoughtPrescribed__7");  
    if ([2].includes(pDataItemValue)) {
      cDataItem.controlEnabled=true;              
    } else {
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="tpm_NumOfTimesBoughtPrescribed__7");  
    if ([2].includes(pDataItemValue)) {
      cDataItem.controlEnabled=true;              
    } else {
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="hsr_TakingNewPrescribedMedicineContinued__8");  
    if ([2].includes(pDataItemValue)) {
      this.applyRequiredWhenEnabledRule(cDataItem);
      cDataItem.controlEnabled=true;              
    } else {
      this.removeRequiredWhenEnabledRule(cDataItem);
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    pDataItemValue = crf.dataItems.find(m => m.dataItemId === "hsr_TakingNewPrescribedMedicineContinued__8").dataItemValue;
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="tpm_MedicineName__8");  
    if ([2].includes(pDataItemValue)) {
      cDataItem.controlEnabled=true;              
    } else {
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="tpm_TypeAndDose__8");  
    if ([2].includes(pDataItemValue)) {
      cDataItem.controlEnabled=true;              
    } else {
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="tpm_MedicineBoughtPrescribed__8");  
    if ([2].includes(pDataItemValue)) {
      cDataItem.controlEnabled=true;              
    } else {
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="tpm_NumOfTimesBoughtPrescribed__8");  
    if ([2].includes(pDataItemValue)) {
      cDataItem.controlEnabled=true;              
    } else {
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="hsr_TakingNewPrescribedMedicineContinued__9");  
    if ([2].includes(pDataItemValue)) {
      this.applyRequiredWhenEnabledRule(cDataItem);
      cDataItem.controlEnabled=true;              
    } else {
      this.removeRequiredWhenEnabledRule(cDataItem);
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    pDataItemValue = crf.dataItems.find(m => m.dataItemId === "hsr_TakingNewPrescribedMedicineContinued__9").dataItemValue;
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="tpm_MedicineName__9");  
    if ([2].includes(pDataItemValue)) {
      cDataItem.controlEnabled=true;              
    } else {
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="tpm_TypeAndDose__9");  
    if ([2].includes(pDataItemValue)) {
      cDataItem.controlEnabled=true;              
    } else {
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="tpm_MedicineBoughtPrescribed__9");  
    if ([2].includes(pDataItemValue)) {
      cDataItem.controlEnabled=true;              
    } else {
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="tpm_NumOfTimesBoughtPrescribed__9");  
    if ([2].includes(pDataItemValue)) {
      cDataItem.controlEnabled=true;              
    } else {
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="hsr_TakingNewPrescribedMedicineContinued__10");  
    if ([2].includes(pDataItemValue)) {
      this.applyRequiredWhenEnabledRule(cDataItem);
      cDataItem.controlEnabled=true;              
    } else {
      this.removeRequiredWhenEnabledRule(cDataItem);
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    pDataItemValue = crf.dataItems.find(m => m.dataItemId === "hsr_TakingNewPrescribedMedicineContinued__10").dataItemValue;
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="tpm_MedicineName__10");  
    if ([2].includes(pDataItemValue)) {
      cDataItem.controlEnabled=true;              
    } else {
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="tpm_TypeAndDose__10");  
    if ([2].includes(pDataItemValue)) {
      cDataItem.controlEnabled=true;              
    } else {
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="tpm_MedicineBoughtPrescribed__10");  
    if ([2].includes(pDataItemValue)) {
      cDataItem.controlEnabled=true;              
    } else {
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="tpm_NumOfTimesBoughtPrescribed__10");  
    if ([2].includes(pDataItemValue)) {
      cDataItem.controlEnabled=true;              
    } else {
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    pDataItemValue = crf.dataItems.find(m => m.dataItemId === "hsr_HaveUsedHealthServices").dataItemValue;
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="hsr_Physiotherapy");  
    if ([2].includes(pDataItemValue)) {
      cDataItem.controlEnabled=true;              
    } else {
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="hsr_Psychology");  
    if ([2].includes(pDataItemValue)) {
      cDataItem.controlEnabled=true;              
    } else {
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="hsr_PrivateCareHome");  
    if ([2].includes(pDataItemValue)) {
      cDataItem.controlEnabled=true;              
    } else {
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="hsr_PrivateCarer");  
    if ([2].includes(pDataItemValue)) {
      cDataItem.controlEnabled=true;              
    } else {
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="hsr_ChildCarer");  
    if ([2].includes(pDataItemValue)) {
      cDataItem.controlEnabled=true;              
    } else {
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="hsr_HaveUsedHealthServicesOther");  
    if ([2].includes(pDataItemValue)) {
      cDataItem.controlEnabled=true;              
    } else {
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    pDataItemValue = crf.dataItems.find(m => m.dataItemId === "hsr_Physiotherapy").dataItemValue;
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="hsr_PhysiotherapyNumOfContacts");  
    if ([2].includes(pDataItemValue)) {
      cDataItem.controlEnabled=true;              
    } else {
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="hsr_PhysiotherapyCost");  
    if ([2].includes(pDataItemValue)) {
      cDataItem.controlEnabled=true;              
    } else {
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    pDataItemValue = crf.dataItems.find(m => m.dataItemId === "hsr_Psychology").dataItemValue;
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="hsr_PsychologyNumOfContacts");  
    if ([2].includes(pDataItemValue)) {
      cDataItem.controlEnabled=true;              
    } else {
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="hsr_PsychologyCost");  
    if ([2].includes(pDataItemValue)) {
      cDataItem.controlEnabled=true;              
    } else {
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    pDataItemValue = crf.dataItems.find(m => m.dataItemId === "hsr_PrivateCareHome").dataItemValue;
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="hsr_PrivateCareHomeNumOfContacts");  
    if ([2].includes(pDataItemValue)) {
      cDataItem.controlEnabled=true;              
    } else {
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="hsr_PrivateCareHomeCost");  
    if ([2].includes(pDataItemValue)) {
      cDataItem.controlEnabled=true;              
    } else {
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    pDataItemValue = crf.dataItems.find(m => m.dataItemId === "hsr_PrivateCarer").dataItemValue;
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="hsr_PrivateCarerNumOfContacts");  
    if ([2].includes(pDataItemValue)) {
      cDataItem.controlEnabled=true;              
    } else {
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="hsr_PrivateCarerCost");  
    if ([2].includes(pDataItemValue)) {
      cDataItem.controlEnabled=true;              
    } else {
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    pDataItemValue = crf.dataItems.find(m => m.dataItemId === "hsr_ChildCarer").dataItemValue;
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="hsr_ChildCarerNumOfContacts");  
    if ([2].includes(pDataItemValue)) {
      cDataItem.controlEnabled=true;              
    } else {
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="hsr_ChildCarerCost");  
    if ([2].includes(pDataItemValue)) {
      cDataItem.controlEnabled=true;              
    } else {
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    pDataItemValue = crf.dataItems.find(m => m.dataItemId === "hsr_HaveUsedHealthServicesOther").dataItemValue;
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="hsr_HaveUsedHealthServicesOtherSpecify");  
    if ([2].includes(pDataItemValue)) {
      cDataItem.controlEnabled=true;              
    } else {
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="hsr_HaveUsedHealthServicesOtherNumOfContacts");  
    if ([2].includes(pDataItemValue)) {
      cDataItem.controlEnabled=true;              
    } else {
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="hsr_HaveUsedHealthServicesOtherCost");  
    if ([2].includes(pDataItemValue)) {
      cDataItem.controlEnabled=true;              
    } else {
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    pDataItemValue = crf.dataItems.find(m => m.dataItemId === "hsr_HavePaidTravellingHealthServices").dataItemValue;
    pDataItemValue = crf.dataItems.find(m => m.dataItemId === "hsr_HavePaidTravellingHealthServices").dataItemValue;
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="pth_TypeOfTravellingCosts__1");  
    if ([2].includes(pDataItemValue)) {
      cDataItem.controlEnabled=true;              
    } else {
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="pth_Cost__1");  
    if ([2].includes(pDataItemValue)) {
      cDataItem.controlEnabled=true;              
    } else {
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="hsr_HavePaidTravellingHealthServicesContinued__2");  
    if ([2].includes(pDataItemValue)) {
      this.applyRequiredWhenEnabledRule(cDataItem);
      cDataItem.controlEnabled=true;              
    } else {
      this.removeRequiredWhenEnabledRule(cDataItem);
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    pDataItemValue = crf.dataItems.find(m => m.dataItemId === "hsr_HavePaidTravellingHealthServicesContinued__2").dataItemValue;
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="pth_TypeOfTravellingCosts__2");  
    if ([2].includes(pDataItemValue)) {
      cDataItem.controlEnabled=true;              
    } else {
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="pth_Cost__2");  
    if ([2].includes(pDataItemValue)) {
      cDataItem.controlEnabled=true;              
    } else {
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="hsr_HavePaidTravellingHealthServicesContinued__3");  
    if ([2].includes(pDataItemValue)) {
      this.applyRequiredWhenEnabledRule(cDataItem);
      cDataItem.controlEnabled=true;              
    } else {
      this.removeRequiredWhenEnabledRule(cDataItem);
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    pDataItemValue = crf.dataItems.find(m => m.dataItemId === "hsr_HavePaidTravellingHealthServicesContinued__3").dataItemValue;
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="pth_TypeOfTravellingCosts__3");  
    if ([2].includes(pDataItemValue)) {
      cDataItem.controlEnabled=true;              
    } else {
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="pth_Cost__3");  
    if ([2].includes(pDataItemValue)) {
      cDataItem.controlEnabled=true;              
    } else {
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="hsr_HavePaidTravellingHealthServicesContinued__4");  
    if ([2].includes(pDataItemValue)) {
      this.applyRequiredWhenEnabledRule(cDataItem);
      cDataItem.controlEnabled=true;              
    } else {
      this.removeRequiredWhenEnabledRule(cDataItem);
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    pDataItemValue = crf.dataItems.find(m => m.dataItemId === "hsr_HavePaidTravellingHealthServicesContinued__4").dataItemValue;
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="pth_TypeOfTravellingCosts__4");  
    if ([2].includes(pDataItemValue)) {
      cDataItem.controlEnabled=true;              
    } else {
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="pth_Cost__4");  
    if ([2].includes(pDataItemValue)) {
      cDataItem.controlEnabled=true;              
    } else {
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="hsr_HavePaidTravellingHealthServicesContinued__5");  
    if ([2].includes(pDataItemValue)) {
      this.applyRequiredWhenEnabledRule(cDataItem);
      cDataItem.controlEnabled=true;              
    } else {
      this.removeRequiredWhenEnabledRule(cDataItem);
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    pDataItemValue = crf.dataItems.find(m => m.dataItemId === "hsr_HavePaidTravellingHealthServicesContinued__5").dataItemValue;
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="pth_TypeOfTravellingCosts__5");  
    if ([2].includes(pDataItemValue)) {
      cDataItem.controlEnabled=true;              
    } else {
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="pth_Cost__5");  
    if ([2].includes(pDataItemValue)) {
      cDataItem.controlEnabled=true;              
    } else {
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="hsr_HavePaidTravellingHealthServicesContinued__6");  
    if ([2].includes(pDataItemValue)) {
      this.applyRequiredWhenEnabledRule(cDataItem);
      cDataItem.controlEnabled=true;              
    } else {
      this.removeRequiredWhenEnabledRule(cDataItem);
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    pDataItemValue = crf.dataItems.find(m => m.dataItemId === "hsr_HavePaidTravellingHealthServicesContinued__6").dataItemValue;
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="pth_TypeOfTravellingCosts__6");  
    if ([2].includes(pDataItemValue)) {
      cDataItem.controlEnabled=true;              
    } else {
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="pth_Cost__6");  
    if ([2].includes(pDataItemValue)) {
      cDataItem.controlEnabled=true;              
    } else {
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    pDataItemValue = crf.dataItems.find(m => m.dataItemId === "hsr_HaveExtraCosts").dataItemValue;
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="hsr_HealthServiceProviders");  
    if ([2].includes(pDataItemValue)) {
      cDataItem.controlEnabled=true;              
    } else {
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="hsr_Childcare");  
    if ([2].includes(pDataItemValue)) {
      cDataItem.controlEnabled=true;              
    } else {
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="hsr_HelpWithHousework");  
    if ([2].includes(pDataItemValue)) {
      cDataItem.controlEnabled=true;              
    } else {
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="hsr_HealthServiceProvidersOther");  
    if ([2].includes(pDataItemValue)) {
      cDataItem.controlEnabled=true;              
    } else {
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    pDataItemValue = crf.dataItems.find(m => m.dataItemId === "hsr_HealthServiceProviders").dataItemValue;
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="hsr_HealthServiceProvidersCost");  
    if ([2].includes(pDataItemValue)) {
      cDataItem.controlEnabled=true;              
    } else {
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    pDataItemValue = crf.dataItems.find(m => m.dataItemId === "hsr_Childcare").dataItemValue;
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="hsr_ChildcareCost");  
    if ([2].includes(pDataItemValue)) {
      cDataItem.controlEnabled=true;              
    } else {
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    pDataItemValue = crf.dataItems.find(m => m.dataItemId === "hsr_HelpWithHousework").dataItemValue;
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="hsr_HelpWithHouseworkCost");  
    if ([2].includes(pDataItemValue)) {
      cDataItem.controlEnabled=true;              
    } else {
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    pDataItemValue = crf.dataItems.find(m => m.dataItemId === "hsr_HealthServiceProvidersOther").dataItemValue;
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="hsr_HealthServiceProvidersOtherSpecify");  
    if ([2].includes(pDataItemValue)) {
      cDataItem.controlEnabled=true;              
    } else {
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="hsr_HealthServiceProvidersOtherCost");  
    if ([2].includes(pDataItemValue)) {
      cDataItem.controlEnabled=true;              
    } else {
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    pDataItemValue = crf.dataItems.find(m => m.dataItemId === "hsr_ParticipantRegularWork").dataItemValue;
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="hsr_ParticipantTypeOfWork");  
    if ([2].includes(pDataItemValue)) {
      cDataItem.controlEnabled=true;              
    } else {
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="hsr_ParticipantNumOfDays");  
    if ([2].includes(pDataItemValue)) {
      cDataItem.controlEnabled=true;              
    } else {
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    pDataItemValue = crf.dataItems.find(m => m.dataItemId === "hsr_PartnerHaveTakenTimeOffWork").dataItemValue;
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="hsr_PartnerTypeOfWork");  
    if ([2].includes(pDataItemValue)) {
      cDataItem.controlEnabled=true;              
    } else {
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    cDataItem=crf.dataItems.find(m=> m.dataItemId==="hsr_PartnerNumOfDays");  
    if ([2].includes(pDataItemValue)) {
      cDataItem.controlEnabled=true;              
    } else {
      cDataItem.dataItemValue="";  
      cDataItem.controlEnabled=false; 
    } 
    return;
  } else if (this.crfId=="tbFrmStudyResults") {
    let cDataItem, pDataItemValue, crf = this.crfs[this.crfId];
    return;
  }
}
//DynamicCRF.vue-SkipLogic END

